import { Component, ReactNode, StrictMode } from "react";
import React, { useEffect, useState, useRef } from "react"
import axios from 'axios';
import PropTypes from 'prop-types';
import { connect,useDispatch } from 'react-redux';
import { plantSearch, getPlantData, getStructureData,
    getClimateData, updateDesign, getDesigns, addDesign } from "store/design/actions"
import { getProfile, editProfile } from "../../store/auth/profile/actions"
import { getAreas, updateArea, deleteArea, addArea, searchGuild, fetchCustomPlants } from "../../store/goals/actions"
import { v4 as uuidv4 } from 'uuid';
import * as rt from 'reactstrap'
import { Image as RImage } from '@aws-amplify/ui-react';
import Editable from 'react-x-editable'
import { withRouter, Link } from "react-router-dom"
import { Storage } from '@aws-amplify/storage'
import { StorageImage } from '@aws-amplify/ui-react-storage';
import Dropzone from "react-dropzone"
import zim from "zimjs";
import {jsPDF} from 'jspdf';
import PlantSelect from "./PlantSelect"

const Spline = require('cubic-spline');

function GardenElement () {
    this.type;
    this.meta;
    this.gui;
    this.location;
}

const Designer = props => {
  frame: zim.Frame | undefined;

    var frame;
    const [initiated, setInitiated] = useState()
    var waiter;
    const username = JSON.parse(localStorage.getItem("user")).user
     const [backgroundFiles, setBackgroundFiles] = useState([])
    const [terrainExists, setTerrainExists] = useState(false)
    const [selectionCount, setSelectionCount] = useState(0);
    const [visibility, setVisibility] = useState({'plant':true, 'border':true, 'area': true, 'structure': true, 'path': true, 'terrain': true})
    const [foo, setFoo] = useState()
    const [currYear, setCurrYear] = useState(new Date().getFullYear());
    const goPrevYear = () => setCurrYear(y => y - 1);
    const goNextYear = () => setCurrYear(y => y + 1);
    const [lastDatePossible, setLastDatePossible] = useState(true)
    const [zoomScale, setZoomScale] = useState(0.5)
    const [panMode, setPanMode] = useState(false)   // hand/drag (pan) tool toggle
    const [isDropdownActive, setDropdownActive] = useState(false); // Controls dropdown visibility
    const [backgroundWidth, setBackgroundWidth] = useState(40)
    const [backgroundOpacity, setBackgroundOpacity] = useState(100)
    const [backgroundType, setBackgroundType] = useState()
    const [plantSelectionBox, setPlantSelectionBox] = useState()
    const [currLayer, setCurrLayer] = useState('plant')
    const [font, setFont] = useState()
    const [elements, setElements] = useState()
    const [zone, setZone] = useState()
    const [address1, setStreetAddress1] = useState([])
    const [address2, setStreetAddress2] = useState([])
    const [city, setCity] = useState([])
    const [state, setState] = useState([])
    const [zipcode, setZipcode] = useState()
    const [refreshElement, setRefreshElements] = useState([])
    const [newAreaModal, setNewAreaModal] = useState(false)
    const [deleteAreaModal, setDeleteAreaModal] = useState(false)
    const [deleteAllPlants, setDeleteAllPlants] = useState(false)
    const [climateAverages, setClimateAverages] = useState([])
    const [addressModal, setAddressModal] = useState(false)
    const [deleteModal, setDeleteModal] = useState(false)
    const [seasonRotation, setSeasonRotation] = useState("")
    const [accessFill, setAccessFill] = useState("gravel")
    const [borderFill, setBorderFill] = useState("grass")
    const [loadDesignModal, setLoadDesignModal] = useState(false)
    const [generateDatesOption, setGenerateDatesOption] = useState(true)
    const [showSelectedPlant, setShowSelectedPlant] = useState(false)
    const [showSelectedStructure, setShowSelectedStructure] = useState(false)
    const [existingPlant, setExistingPlant] = useState()
    const [name, setName] = useState()
    const [width, setWidth] = useState()
    const [areaExpand, setAreaExpand] = useState(Array(20).fill(false))
    const [height, setHeight] = useState()
    const [seldesign, setDesign] = useState()
    const [tool, setTool] = useState()
    const [borderTool, setBorderTool] = useState()
    const [searchText, setSearchText] = useState()
    const [selElement, setSelElement] = useState()
    const [lineStarted, setLineStarted] = useState(false)
    const [numPlants, setNumPlants] = useState()
    const [numPlantsWidth, setNumPlantsWidth] = useState()
    const [numPlantsHeight, setNumPlantsHeight] = useState()
    const [plantSpacing, setPlantSpacing] = useState()
    const [isOpen, setIsOpen] = useState(true);
    const [activeAreaId, setActiveAreaId] = useState(null);

    var mode;
    var infoBox;
    var propertyBox;
    var borderBox;
    var designBox;
    var optionsPane;
    var monthlyPane;
    var currentPlant;
    var plantingPane;
    var planBox;
    var plantLayer;
    var borderLayer;
    var selectionLayer;
    var backgroundLayer;
    var structureLayer;
    var accessLayer;
    var areaLayer;
    var loadBox;
    var planWindow;
    var grid;
    var startX, startY;
    var currSelectLabel;
    var lineCommands;
    var hotItem;
    var currentSettings;
    var currentPlantTiles;
    var loadDialogVisible, optionsPaneVisible;
    var filePane;
    var warning;
    var menus;
    var alpha;
    var currDesign;
    var userDesigns;
    var cropRotation;

    const zoomSliderRef = useRef(null);
    const areaScrollRefs = useRef({});

    const PROPERTY_TYPE = {
        TEXT: "text",
        DATE: "date"
    }

    const DEFAULT_BACKGROUND_FILL = "soil";
    const TILE_OPTIONS = [
        {
            key: "none",
            label: "None",
            img: null
        },
        {
            key: "soil",
            label: "Soil",
            img: "planner_static/fill_soil.png"
        },
        {
            key: "light_soil",
            label: "Light Soil",
            img: "planner_static/fill_light_soil.png"
        },
        {
            key: "fence",
            label: "Fence",
            img: "planner_static/fill_fence.png"
        },
        {
            key: "brick",
            label: "Brick",
            img: "planner_static/fill_brick.png"
        },
        {
            key: "gravel",
            label: "Gravel",
            img: "planner_static/fill_gravel.png"
        },
        {
            key: "grass",
            label: "Grass",
            img: "planner_static/fill_grass.png"
        },
        {
            key: "deck",
            label: "Deck",
            img: "planner_static/fill_deck.png"
        },
        {
            key: "mulch",
            label: "Mulch",
            img: "planner_static/fill_mulch.png"
        },
        {
            key: "water",
            label: "Water",
            img: "planner_static/fill_water.png"
        }
    ];

    const seasonRotationOptions = [
        { value: "", text: "", label: "" },
        { value: "Spring", text: "Spring", label: "Spring" },
        { value: "Summer", text: "Summer", label: "Summer" },
        { value: "Fall", text: "Fall", label: "Fall" },
        { value: "Winter", text: "Winter", label: "Winter" },
    ];

    const plantScales = {
            "tiny": 0.35,
            "small": 0.5,
            "medium": .75,
            "large": 1,
            "shrub": 2,
            "small tree": 3,
            "medium tree": 4,
            "large tree": 6
    }

    const plantSizeOptions = [
        "tiny","small","medium","large","shrub","small tree","medium tree","large tree"
    ].map((k) => ({
        value: k,
        label: k,
        text: k,
        name: k,
        key: k,
    }));

    const {
        onPlantSearch,
        onFetchClimateData,
        onSaveDesign,
        onGetPlantData,
        onGetStructureData,
        onGetAreas,
        onAddArea,
        onAddDesign,
        onUpdateArea,
        onLoadDesigns,
        onGetProfile,
        onUpdateProfile,
        searchPlants,
        plantData,
        structureData,
        profile,
        plantDataMap,
        structureDataMap,
        climateData,
        designs,
        userareas,
        onDeleteArea,
        customplants,
        onGetCustomPlants,
    } = props

    const visibleAreas = userareas.filter(
        area =>
            area.year === currYear ||
            (area.name === "Unassigned" && area.year == null)
    );

    const activeArea =
        visibleAreas.find(a => a.id === activeAreaId) || null;

    useEffect(() => {
        const { onGetPlantData, onGetStructureData } = props
        onGetAreas()
        onGetProfile(username) 
    }, [])

    useEffect(() => {
        if (currLayer !== "area") return;
        if (!activeAreaId) return;

        const areaElement = Object.values(foo.elements).find(
            el =>
                el.type === "area" &&
                (el.area === activeAreaId || el.id === activeAreaId)
        );

        if (areaElement) {
           // centerOnArea(areaElement);
        }
    }, [activeAreaId, currLayer]);


    useEffect(() => {
        if (!designs || designs.length === 0) return;
        if (!foo || foo.loadingDesign) return;

        switchToYear(currYear);
    }, [currYear]);

    useEffect(() => {
        if (plantDataMap==undefined)
           return
        if ("Apple" in plantDataMap) {
            const combined = { ...plantDataMap }
            if (customplants) {
                customplants.forEach(cp => {
                    combined[cp.species] = {
                        name: cp.species,
                        plant_family: cp.plantFamily,
                        guildFunction: cp.guildFunction || [],
                        foodForestLayer: cp.foodForestLayer || [],
                        climate: cp.climate || [],
                        USDAMin: cp.USDAMin,
                        USDAMax: cp.USDAMax,
                        size: cp.size,
                        spacing_between_plants: cp.spacing_between_plants,
                        minimumTemp: cp.minimumTemperature,
                        maximumTemp: cp.maximumTemperature,
                        yield_per_plant_ounces: cp.yieldPerPlant,
                        season: cp.season_rotation,
                        designerIconKey: cp.designerIconKey,
                        cardIconKey: cp.cardIconKey,
                        isCustomPlant: true,
                    }
                })
            }
            if (foo) foo.plantDataMap = combined
            if (frame) frame.plantDataMap = combined
            if (foo && customplants) {
                customplants.forEach(cp => {
                    if (cp.designerIconKey) {
                        loadTileByKey(cp.designerIconKey)
                            .catch(e => console.error("Failed to preload custom plant icon:", cp.designerIconKey, e));
                    }
                });
            }
            if (foo && foo.pendingCompleteLoad) {
                foo.pendingCompleteLoad = false;
                frame = foo;
                completeLoad();
            }
        }
    }, [plantDataMap, customplants, foo])

    useEffect(() => {
        if (structureDataMap==undefined)
            return
        if (Object.keys(structureDataMap).length > 0) {
            if (foo)
                foo.structureDataMap = structureDataMap
            if (frame)
                frame.structureDataMap = structureDataMap
        }
    }, [structureDataMap])

    async function loadIconsFromS3(folderPath) {
        try {
            // 1️⃣ List all files in the specified folder
            const result = await Storage.list(folderPath, { level: "public" });

            if (!result || !result.results || result.results.length === 0) {
                console.warn(`No valid assets found in folder: ${folderPath}`);
                return;
            }

            console.log("Raw Storage List:", result);

            // 2️⃣ Filter out folders and keep only actual image files
            const imageFiles = result.results.filter(file =>
                file.size > 0 && file.key.match(/\.(png|jpg|jpeg|gif|svg)$/i) // Match image formats
            );

            console.log("Filtered Image Files:", imageFiles);

            // 3️⃣ Generate signed URLs and store in an object
            const assetPromises = imageFiles.map(async (file) => {
                const url = await Storage.get(file.key, { level: "public" });

                return {
                    id: file.key.replace(folderPath, ""), // Remove folder prefix for cleaner keys
                    src: url
                };
            });

            const assets = await Promise.all(assetPromises);
            console.log("Assets Ready for ZIM:", assets);

            // 4️⃣ Load assets into zim.js and associate them with keys
            await frame.loadAssets(assets);
            console.log("All assets loaded successfully into ZIM!");

        } catch (error) {
            console.error("Error loading assets from S3:", error);
        }
    }

    useEffect(() => {
        if (!foo) {
            setFont("Nunito")
            var scaling = "designer";

            var width = 900; // can go higher...
            var height = 835;
            var color = "#AACCAA";

            frame = new zim.Frame(scaling, width, height, color);
            frame.zoomScale = 1;
	          frame.currLayer = 'plant'
            if (designs && designs.length > 0) {
                // Try to find a design for the current year
                const yearDesign = designs.find(d => d.year === currYear && d.year != null);

                // Use it if found, otherwise fall back to the first design
                frame.currDesign = yearDesign || designs[0];
            }
            frame.on("ready", function () {
                // Example: Load all images from the "planner_icons/" folder
                const loadS3Assets = async () => {
                    await loadIconsFromS3("planner_static/");
                };
                const loadStructuresAssets = async () => {
                    await loadIconsFromS3("planner_structures/");
                };
                loadS3Assets();
                loadStructuresAssets();
                frame.assetMap = {}

                this.initiated = false
                frame.on("complete", function () {
                    setFoo(frame)
                    if (this.initiated)
                        return;
                    frame.initiated = true

                    buildPlanBox(900, 800);
                    buildSeasonSlider();
                    onGetPlantData()
                    onGetStructureData()
                    onGetCustomPlants()

                    frame.stage.update();
                    frame.loadingDesign = true
                    onLoadDesigns()
                });
            });
            if (climateData && climateData["JanMin"] && !frame.climateData) {
                frame.climateData = climateData
            }
        }
    }, [frame]);

    useEffect(() => {
      if (foo) {
          frame = foo
          foo.lastDatePossible = true
        }
        if (designs.length > 0) {
            const yearDesign = designs.find(d => d.year === currYear);
            frame.currDesign = yearDesign || designs[0];
        }
        if (frame.loadingDesign) {
          loadDesign()
            normalizeLegacyUnassigned()
        }

    }, [designs]);

    useEffect(() => {
      if ((climateData && climateData["JanMin"]) || (profile.climates && profile.climates.length>0)) {
            if (foo) {
              frame = foo
            } else {
              return;
            }
            if (profile.climates && profile.climates.length>0) {
               for (var i=0; i<profile.climates.length; i++) {
                  if (profile.climates[i].selected) {
                      frame.climateData = profile.climates[i]
                  }
               }
            }
            if (!frame.climateData)
                frame.climateData = climateData
            console.log(climateData)
        }
    }, [climateData]);

    const geocodeAddress = (address) => {
        return new Promise((resolve, reject) => {
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ address: address }, (results, status) => {
               if (status === "OK") {
                   resolve(results[0].geometry.location.toJSON());
               } else {
                   reject(new Error(`Geocode was not successful for the following reason: ${status}`));
               }
            });
        })
         .then(data => {
            var latinrads = data.lat * Math.PI/180
            var mapscale = 1/(156543.03392 * 3.28084 * Math.cos(latinrads) / Math.pow(2, 21))
            const mapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${data.lat},${data.lng}&zoom=21&size=640x640&maptype=roadmap&key=AIzaSyC1liIiGRz5gz14fdeIAfoaMCaLHLkhkGA`;
            axios.get(mapUrl, { responseType: 'arraybuffer' })
  .then(response => {
    const imageObject = new Blob([response.data], { type: 'image/png' });
    Storage.put("designer_" + username+"_background.png", imageObject, {
                     contentType: 'image/png'
            }).then (url => {
                 setTerrainExists(true)
                 saveDesign()
                 Storage.get("designer_" + username+"_background.png", { level: 'public' })
                  .then(url => {
                     var backgroundPic = new zim.Pic(url)
                     backgroundPic.on("complete", function () {
                         console.log(backgroundPic.width)
                         backgroundPic.x = 0
                         backgroundPic.y = 0
                         backgroundPic.scale = 8
                         backgroundPic.alpha = 1;
                         foo.background = {
                            type: backgroundType,
                            file: "designer_" + username+"_background.png",
                            scale: backgroundPic.scale,
                            alpha: backgroundPic.alpha,
                            asset: backgroundPic
                         }

                        backgroundPic.on("pressmove", function (e) {
                            var mousex = e.stageX - planWindow.x - planWindow.scrollX;
                            var mousey = e.stageY - planWindow.y - planWindow.scrollY;
                            applyTool(mousex, mousey, "mousedown");
                            frame.stage.update();
                         })
                         foo.planBox.addChildAt(backgroundPic, 1)
                      });
                  })
             })
        })
})
         .catch(error => {
                console.error('There was a problem with the geocoding request:', error);
        });
    };

    const storeBackgroundImage = () => {
        backgroundFiles.map(file => {
           var fileExt = file.name.split('.').pop();
           Storage.put("designer_" + username+"_background." + fileExt, file, {
               contentType: file.type
           }).then (result => {
             console.log(result)
             setTerrainExists(true)
             Storage.get("designer_" + username+"_background." + fileExt, { level: 'public' })
                  .then(url => {
                     var backgroundPic = new zim.Pic(url)
                     backgroundPic.on("complete", function () {
                         console.log(backgroundPic.width)
                         backgroundPic.x = 0
                         backgroundPic.y = 0
                         backgroundPic.scale = displayGrid/(backgroundPic.width/backgroundWidth)
                         backgroundPic.alpha = .35;
                         foo.background = {
                            type: backgroundType,
                            file: "designer_" + username+"_background" + fileExt,
                            scale: backgroundPic.scale,
                            alpha: backgroundPic.alpha,
                            asset: backgroundPic
                         }
                         backgroundPic.on("pressup", function (e) {
                             currDesign = foo.currDesign
                             frame = foo
                            applyTool(e.stageX, e.stageY, "mousedown");
                         })
                         foo.planBox.addChildAt(backgroundPic, 1)
                      });
                  })
                  .catch(error => console.error(error));
        }).catch(err => {
             console.log(err)
        });
     });
  }

    function switchToYear(year) {
        const existing = designs.find(d => d.year === year);

        if (existing) {
            loadDesignForYear(existing);
        } else {
            createDesignFromPreviousYear(year);
        }
    }

    function normalizeLegacyUnassigned() {
        userareas.forEach(area => {
            if (
                (area.name || "").toLowerCase() === "unassigned" &&
                area.year == null
            ) {
                area.year = currYear;

                // 🔑 Persist immediately
                onUpdateArea(area);
            }
        });
    }

    function getPreviousDesign(targetYear) {
        // Eligible designs include:
        // - designs with year < targetYear
        // - legacy designs with no year
        const eligible = designs.filter(d =>
            d.year == null || d.year < targetYear
        );

        if (eligible.length === 0) return null;

        // Sort most recent first
        eligible.sort((a, b) => {
            const ay = a.year ?? -Infinity;
            const by = b.year ?? -Infinity;
            return by - ay;
        });

        const prev = eligible[0];

        // 🔧 LEGACY FIX-UP
        if (prev.year == null) {
            prev.year = targetYear - 1;

            // Persist the fix so we never hit this again
            onSaveDesign(prev);   // or saveDesign(prev)
        }

        return prev;
    }

    function loadDesignForYear(design) {
        if (!frame) {
            frame = foo;
        }
        foo.currDesign = design;
        foo.loadingDesign = true;

        completeLoad();

        centerOnDesign();
        foo.stage.update();
    }

    function filterPerennials(plants) {
        const result = {};

        for (const key in plants) {
            const plant = plants[key];
            if (plant.plant.season.toLowerCase() === "perennial") {
                result[key] = structuredClone(plant);
            }
        }

        return result;
    }

    function buildAreasForNewYear({
                                      prevDesignAreas = []
                                  }) {
        const newDesignAreas = [];

        prevDesignAreas.forEach(oldShape => {
            // Try to find a logical area for this year with same name
            let logicalArea = userareas.find(
                a => a.year === currYear && a.name === oldShape.name
            );

            // CASE 1: Logical area exists for this year
            if (logicalArea) {
                // If it already has a physical location, do nothing
                if (logicalArea.location === true) return;

                // Otherwise: relink geometry
                newDesignAreas.push({
                    ...structuredClone(oldShape),
                    id: logicalArea.id,
                    year: currYear
                });

                // Attach physical location to logical area
                logicalArea.location = structuredClone(oldShape.location);
                return;
            }

            // CASE 2: No logical area yet → create one
            const newId = uuidv4();

            onAddArea({
                id: newId,
                name: oldShape.name,
                year: currYear,
                plants: [],
                history: {},
                location: true
            });

            newDesignAreas.push({
                ...structuredClone(oldShape),
                id: newId,
                year: currYear
            });
        });

        return newDesignAreas;
    }


    function shiftOneYear(str) {
        if (!str) return null;
        const d = new Date(str);
        if (isNaN(d)) return null;
        d.setFullYear(d.getFullYear() + 1);
        return d.toISOString();
    }

    function clonePerennialPlantsForNewArea(oldArea) {
        return (oldArea.plants || [])
            .filter(p => ((p.season || "").toLowerCase() === "perennial"))
            .map(p => ({
                ...structuredClone(p),
                id: uuidv4(),

                climateAverages: [],
                harvests: [],
                notes: [],

                harvestTotals: 0,
                totalHarvest: 0,

                seedStartDate: shiftOneYear(p.seedStartDate),
                transplantDate: shiftOneYear(p.transplantDate),
                harvestDate: shiftOneYear(p.harvestDate)
            }));
    }


    function ensureLogicalAreasForYear({
                                           prevYearAreas = [],
                                       }) {
        // name -> newLogicalArea
        const byName = new Map();

        // First, index any existing current-year areas
        userareas
            .filter(a => a.year === currYear)
            .forEach(a => byName.set(a.name, a));

        // Next, for every previous-year area (except unassigned), ensure a current-year clone exists
        prevYearAreas
            .forEach(oldArea => {
                if (byName.has(oldArea.name)) return;

                const newArea = {
                    id: uuidv4(),
                    name: oldArea.name,
                    year: currYear,
                    info: {...oldArea.info},
                    plants: clonePerennialPlantsForNewArea(oldArea),
                    history: {}
                    // NOTE: do NOT set location here.
                    // location will be set after we successfully attach geometry from the design.
                };

                onAddArea(newArea);
                byName.set(newArea.name, newArea);
            });

        return byName; // Map(name -> logicalAreaObject)
    }

    function buildDesignAreasForNewYear({
                                            prevDesignAreas = [],
                                            logicalAreasByName
                                        }) {
        const newDesignAreas = [];

        prevDesignAreas.forEach(oldShape => {
            const logicalArea = logicalAreasByName.get(oldShape.name);
            if (!logicalArea) return; // no logical area to link

            newDesignAreas.push({
                ...structuredClone(oldShape),  // points, origScale, location, etc.
                id: logicalArea.id,            // 🔑 relink to new logical area id
                area: logicalArea.id,          // you have both fields in your shape object
                year: currYear
            });

            // mark logical area as having physical placement
            logicalArea.location = structuredClone(oldShape.location);
        });

        return newDesignAreas;
    }



    function copyAreasAndGeometryFromPreviousYear({
                                                      prevYearAreas,       // from userareas for prevYear
                                                      prevDesignAreas
                                                  }) {
        // 1) Ensure logical areas exist (with perennials)
        const logicalAreasByName = ensureLogicalAreasForYear({prevYearAreas});

        // 2) Build design area geometry linked to those logical areas
        const newDesignAreas = buildDesignAreasForNewYear({
            prevDesignAreas,
            logicalAreasByName
        });

        return newDesignAreas;
    }


    function createDesignFromPreviousYear(year) {
        const prevYear = currYear - 1;
        const prevYearAreas = userareas.filter(a => a.year === prevYear);
        const prev = getPreviousDesign(year)

        let newDesign = {
            elements: [],
            id: uuidv4(),
            username: username,
            plants: [],
            borders: [],
            areas: [],
            dimensions: {
                height: 40,
                width: 40
            },
            year: currYear
        };

        if (prev) {
            // --- Copy forward structural elements ---
            newDesign.background = structuredClone(prev.background);
            newDesign.structures = structuredClone(prev.structures);
            newDesign.borders = structuredClone(prev.borders);
            newDesign.access = structuredClone(prev.access);

            // --- Plants: perennials keep identity ---
            newDesign.plants = filterPerennials(prev.plants);

            // --- Areas (logical + physical unified) ---
            newDesign.areas = copyAreasAndGeometryFromPreviousYear({
                prevYearAreas,
                prevDesignAreas: prev.areas || [],
            });
        }

        designs.push(newDesign);

        foo.currDesign = newDesign;
        onAddDesign(foo.currDesign);

        // Ensure crop rotation overlay stays on top
        foo.stage.removeChild(cropRotation);
        foo.stage.addChild(cropRotation);
        foo.stage.update();
        if (!frame)
            frame = foo;
        loadDesign();
    }


    const getBackgroundImageURL = () => {
        Storage.get('designer + "_" + username+"_background', { level: 'pblic' })
           .then(url => {
               // Use the URL for your needs, e.g., display the image in an <img> tag
                console.log(url);
           })
           .catch(error => console.error(error));
    }

    // Logical layer an element belongs to. Paths are stored as structures with
    // subtype "access" (kept for backward compatibility) but live on their own
    // "path" layer in the UI. Everything that routes by layer uses this.
    const layerOf = (element) => {
        if (!element) return undefined;
        if (element.subtype === 'access') return 'path';
        return element.type;
    };

    // Display container for a logical layer (path elements render in accessLayer).
    const layerContainer = (lyr) => {
        const f = foo || frame;
        if (!f) return undefined;
        return lyr === 'path' ? f.accessLayer : f[lyr + 'Layer'];
    };

    const clearOldSelections = () => {
        setShowSelectedPlant(false);
        setShowSelectedStructure(false);

        if (!frame && foo) frame = foo;
        if (!frame) return;

        ensureSelectionSet();
        // Clear highlights + selection flags for ALL currently selected items
        for (const id of Array.from(frame.selectedElements)) {
            const el = frame.elements?.[id];
            if (el) {
                deselectElement(el);
            }
        }

        frame.selectionLayer.removeAllChildren()
        frame.selectedElements.clear();
        frame.selectedElement = null;
        setSelElement();
        syncSelectionCount()
    }

    function makeDashedRectShape() {
        const s = new createjs.Shape();
        s.mouseEnabled = false; // don't block clicks
        return s;
    }

    function drawDashedRect(shape, x, y, w, h) {
        const g = shape.graphics;
        g.clear();
        g.setStrokeStyle(2);     // dash, gap
        g.beginStroke("black");
        g.beginFill("rgba(0,0,0,0)");     // no fill
        g.drawRect(x, y, w, h);
        g.endFill();
        g.endStroke();
    }

    function ensureSelectionSet() {
        if (!frame && foo) frame = foo;
        if (frame && !frame.selectedElements) frame.selectedElements = new Set();
    }

    function ensureHighlight(el) {
        if (!el || !el.asset || el.type === "structure") return;

        // Areas are Blobs whose geometry isn't committed until a drag ends, so a
        // tracking box can't follow them mid-drag. Highlight them by recoloring the
        // Blob's own border instead — that moves with the shape automatically.
        if (el.type === "area") {
            setAreaSelectedStyle(el, true);
            return;
        }

        if (!el.highlight) {
            el.highlight = new zim.Shape();
            el.highlight.mouseEnabled = false; // don't block clicking/drags on the asset

            const g = el.highlight.graphics;
            g.c()                 // clear
                .s("black")
                .ss(2)              // stroke size (optional, match your preference)
                .mt(0, 0)
                .lt(el.asset.width, 0)
                .lt(el.asset.width, el.asset.height)
                .lt(0, el.asset.height)
                .lt(0, 0);

            // Add to selection layer (NOT planBox)
            frame.selectionLayer.addChild(el.highlight);
        }
        positionHighlight(el);
    }

    // Selection box position for plants/borders — they drag via x/y.
    function positionHighlight(el) {
        if (!el || !el.highlight || !el.asset) return;
        el.highlight.x = el.asset.x;
        el.highlight.y = el.asset.y;
    }

    // Show/clear an area's selected look by recoloring its Blob border. Stores the
    // original border so deselect restores it exactly.
    function setAreaSelectedStyle(el, on) {
        if (!el || !el.asset || el.type !== "area") return;
        if (on) {
            if (el._origBorderColor === undefined) el._origBorderColor = el.asset.borderColor;
            if (el._origBorderWidth === undefined) el._origBorderWidth = el.asset.borderWidth;
            el.asset.borderColor = "#1565C0";
            el.asset.borderWidth = 4;
        } else {
            el.asset.borderColor = el._origBorderColor;
            el.asset.borderWidth = el._origBorderWidth;
            el._origBorderColor = undefined;
            el._origBorderWidth = undefined;
        }
        if (frame.stage) frame.stage.update();
    }


    function deselectElement(el) {
        if (!el) return;
        if (el.type === "area") {
            setAreaSelectedStyle(el, false);
            el.selected = false;
            return;
        }
        if (el.highlight) {
            frame.selectionLayer.removeChild(el.highlight);
            el.highlight = undefined;
        }
        el.selected = false;
    }

    // Hide the squiggle edit controls for any selected paths. Called only on a
    // true deselect (empty-canvas click), NOT during re-selection, so it never
    // disables a path's controls mid-interaction.
    function hideSelectedPathControls() {
        if (!frame || !frame.selectedElements) return;
        for (const id of frame.selectedElements) {
            const el = frame.elements?.[id];
            if (el && el.subtype === 'access' && el.asset && typeof el.asset.hideControls === 'function') {
                try { el.asset.hideControls(); } catch (e) { /* ignore */ }
            }
        }
    }

    function getElementLabel(el) {
        if (!el) return "Unknown";

        if (el.type === "plant") {
            const p = el.plant || {};
            const base = p.species || p.name || "Plant";
            return p.variety ? `${base} (${p.variety})` : base;
        }

        if (el.type === "border") return "Border";
        if (el.type === "path") return "Path";

        return el.name || el.type;
    }

    function syncSelElementState() {
        ensureSelectionSet();
        const ids = Array.from(frame.selectedElements);

        // --- NOTHING SELECTED ---
        if (ids.length === 0) {
            frame.selectedElement = null;
            setSelElement();
            setShowSelectedPlant(false);
            setShowSelectedStructure(false);
            return;
        }

        // --- SINGLE SELECTION (ALWAYS USE SINGLE UI) ---
        if (ids.length === 1) {
            const el = frame.elements[ids[0]];
            frame.selectedElement = el;
            setSelElement(el); // 👈 single-item panel
            setShowSelectedPlant(el?.type === "plant");
            setShowSelectedStructure(el?.type === "structure");
            return;
        }

        // --- MULTI SELECTION (2+) ---
        const items = ids
            .map(id => frame.elements[id])
            .filter(Boolean)
            .map(el => ({
                id: el.id,
                type: el.type,
                label: getElementLabel(el),
            }));

        frame.selectedElement = null;
        setSelElement({
            type: "multi",
            count: items.length,
            items,
        });

        setShowSelectedPlant(false);
        setShowSelectedStructure(false);
    }

    function selectSingleElement(el) {
        clearOldSelections();
        ensureSelectionSet();

        el.selected = true;
        frame.selectedElements.add(el.id);
        ensureHighlight(el);

        syncSelElementState();
        syncSelectionCount()

        // Selecting an existing element drops out of "Add" (draw/place) mode for
        // the toggle-style layers (border, path, structure).
        if (['border', 'path', 'structure'].includes(frame.currLayer) && layerOf(el) === frame.currLayer) {
            frame.mode = 'select';
            frame.tool = 'select';
            setTool('select');
        }

        // 🔹 restore lifecycle closure
        if (typeof hotItem !== "undefined") hotItem = null;

        frame.stage.update();
    }

    function toggleElementSelection(el) {
        ensureSelectionSet();
        if (frame.selectedElements.has(el.id)) {
            frame.selectedElements.delete(el.id);
            deselectElement(el);
        } else {
            el.selected = true;
            frame.selectedElements.add(el.id);
            ensureHighlight(el);
        }
        syncSelElementState();

        syncSelectionCount()
        frame.stage.update();
    }


    const generateGrid = (scaleValue) => {
         // draw grid
        grid = new zim.Shape();
        var gridG = grid.graphics;
        foo.gridStuff = []
        var gridLabels = []
        let counter = 0
        var planWidth = foo.planBox.width
        var planHeight = foo.planBox.height
        const gridStep = isMetric ? metricGridWidth : gridWidth;
        const labelEvery = isMetric ? 5 : 10;
        for (var i=0; i<planWidth; i=i+gridStep * scaleValue) {
            if (counter % labelEvery === 0 && counter != 0) {
                gridG.sd([], 0).s("#000").ss(1).mt(i,0).lt(i,foo.planBox.height);
                let label = new zim.Label({
                    text: counter,
                    size: 16,
                    color: "#5A5A5A",
                })

                label.x = i-10*scaleValue
                label.y = 5
                gridLabels.push(label)
                foo.planBox.addChild(label)
            } else {
                gridG.sd([10, 3], 0).s("#AAA").ss(1).mt(i,0).lt(i,foo.planBox.height);
            }
            counter += 1;
        }
        counter = 0;
        for (var i=0; i<planHeight; i=i+gridStep * scaleValue) {
            if (counter % labelEvery === 0 && counter!=0) {
                gridG.sd([], 0).s("#000").ss(1).mt(0,i).lt(foo.planBox.width,i);
                let label = new zim.Label({
                    text: counter,
                    size: 16,
                    color: "#5A5A5A",
                })
                label.x = 5
                label.y = i
                foo.planBox.addChild(label);
                gridLabels.push(label)
            } else {
                gridG.sd([10, 3], 0).s("#AAA").ss(1).mt(0,i).lt(foo.planBox.width,i);
            }
            counter += 1
        }
        foo.planBox.addChildAt(grid,1);
        foo.grid = grid;
        foo.gridLabels = gridLabels;
        foo.stage.update();

    }
    function cancelNewArea () {
        setMode("select")
        if (!frame)
            frame = foo
        enterSelectionMode()
        setNewAreaModal(!newAreaModal)
    }

    const updatePlantInArea = (element) => {
                  for (var i=0; i<userareas.length; i++) {
                      if (userareas[i].id === element.area && userareas[i].year === currYear) {
                          for (var ii=0; ii<userareas[i].plants.length; ii++) {
                              if (userareas[i].plants[ii].id == element.id) {
                                  userareas[i].plants[ii] = element.plant
                                  onUpdateArea(userareas[i])
                                  break
                              }
                          }
                      }
                   }
    }

    const createUnassignedArea = () => {
        foo.unassignedArea = userareas.find(
            a => a.name === "Unassigned" && a.year === currYear
        );

        if (foo.unassignedArea) return;

        const newArea = {
            id: uuidv4(),
            name: "Unassigned",
            year: currYear,
            info: { totalSpace: 0 },
            history: {},
            plants: []
        };

        foo.unassignedArea = newArea;
        onAddArea(newArea);
    };


    const createNewArea = () => {
       const newArea = {
          name: name,
          id: uuidv4(),
           year: currYear,
          info: {
             totalSpace: 0
          },
          history: {},
          plants:[]
       }
       foo.currArea = newArea
       setNewAreaModal(!newAreaModal)
       onAddArea(newArea)
   }

   function checkPlantInDesigner(plant) {
       for (var key in foo.elements) {
            var element = foo.elements[key]
            if (element.id==plant.id)
                return true;
       }
       return false;
   }

    const toggleLayers = () => setIsOpen(!isOpen);

   function checkPlantInArea(areas, plant) {
       if (!foo.unassignedArea || foo.unassignedArea.year !== currYear) {
           createUnassignedArea();
       }

       var plantPoints = [];
       plantPoints.push([plant.location.x, plant.location.y])
       plantPoints.push([plant.location.x, plant.location.y + plant.asset.height/foo.zoomScale])
       plantPoints.push([plant.location.x + plant.asset.width/foo.zoomScale, plant.location.y])
       plantPoints.push([plant.location.x + plant.asset.width/foo.zoomScale, plant.location.y + plant.asset.height/foo.zoomScale])
       for (var l=0; l<areas.length; l++) {
            var xyPoints = [...areas[l].points]
           const areaShape = xyPoints.map(point => {
               return {
                   x: point[0],  // The first element is the x coordinate
                   y: point[1]   // The second element is the y coordinate
               };
           });
            for (var shapeNum=0; shapeNum<areaShape.length; shapeNum++) {
                  areaShape[shapeNum].x = areaShape[shapeNum].x/areas[l].origScale + areas[l].location.x
                  areaShape[shapeNum].y = areaShape[shapeNum].y/areas[l].origScale + areas[l].location.y
            }
            var areaData;
            for (var i=0; i<userareas.length; i++) {
                  if (userareas[i].id==areas[l].area) {
                      areaData = userareas[i]
                  }
            }
            if (areaData==undefined)
                continue;
            var pointInPoly = false;
            for (var k=0; k<plantPoints.length; k++) {
                let odd = false;
                var point = plantPoints[k]
                var j;
                for (let i = 0, j = areaShape.length - 1; i < areaShape.length; i++) {
                    if (((areaShape[i].y > point[1]) !== (areaShape[j].y > point[1]))
                           && (point[0] < ((areaShape[j].x - areaShape[i].x) * (point[1] - areaShape[i].y) / (areaShape[j].y - areaShape[i].y) + areaShape[i].x))) {
                        odd = !odd;
                    }
                    j = i;
                }
                if (odd) {
                    pointInPoly = true;
                    break;
                }
            }
            if (pointInPoly) {
                if (!plant.plant.species)
                    plant.plant.species = plant.plant.name
                var foundPlant = false
                if (!plant.plant.location) {
                    plant.area = areaData.id
                    for (var ii=0; ii<areaData.plants.length; ii++) {
                        if (areaData.plants[ii].id == plant.id) {
                            areaData.plants[ii].location = true
                            onUpdateArea(areaData)
                            break;
                        }
                    }
                }
                for (var ii=0; ii<areaData.plants.length; ii++) {
                    if (areaData.plants[ii].id == plant.id) {
                        foundPlant = true
                        continue
                    }
                }
                if (!foundPlant) {
                    plant.plant.harvests = []
                    plant.plant.id = plant.id
                    plant.plant.location = true
                    areaData.plants.push(plant.plant)
                    plant.area = areaData.id
                    onUpdateArea(areaData)

                    // if plant was unassigned before remove from unassigned area
                    for (var ii=0; ii<foo.unassignedArea.plants.length; ii++) {
                        if (foo.unassignedArea.plants[ii].id == plant.id) {
                            foo.unassignedArea.plants.splice(ii,1);
                            onUpdateArea(foo.unassignedArea)
                            break
                        }
                    }
                }
            } else {
                // make sure to remove plant from area
                var plantIndex = -1
                var narea = areaData;
                for (var n=0; n<narea.plants.length; n++) {
                    if (narea.plants[n].id == plant.id) {
                        plantIndex = n;
                        break
                    }
                }
                if (plantIndex>-1) {
                    narea.plants.splice(plantIndex,1);
                    if (narea.id== plant.area) {
                        plant.area = foo.unassignedArea.id
                    }
                    onUpdateArea(narea)
                }
            }
      }
        if (plant.area==undefined || plant.area=="Unassigned") {
            plant.area = foo.unassignedArea.id
            plant.plant.harvests = []
            plant.plant.id = plant.id
            plant.plant.species = plant.plant.name
            foo.unassignedArea.plants.push(plant.plant)
            onUpdateArea(foo.unassignedArea)
        }
   }

    function setGardenBackground(fillKey, opacity = 1, save = false) {
        if (!foo || !foo.backgroundLayer) return;
        // Clear existing background
        foo.backgroundLayer.removeAllChildren();

        if (fillKey === "none") {
            // White rectangle matches planWindow background, covers planGrid grey,
            // is hittable for plant placement, and grows with zoom via scale()
            const bg = new zim.Rectangle(
                foo.planBox.width || 900,
                foo.planBox.height || 800,
                "white"
            );
            bg.noDrag();
            foo.backgroundLayer.addChild(bg);

            foo.background = {
                type: "tile",
                fill: "none",
                alpha: opacity
            };

            if (save) saveDesign();
            foo.stage.update();
            return;
        }

        // No saved background => nothing to render
        if (!fillKey) {
            foo.background = null;
            foo.stage.update();
            return;
        }

        const assetName = `fill_${fillKey}.png`;
        const asset = foo.asset(assetName);

        if (!asset || !asset.image) {
            console.warn("Background asset not ready:", assetName);
            return;
        }

        const bg = new zim.Rectangle(
            foo.planBox.width,
            foo.planBox.height,
            null
        );

        bg.colorCommand.bitmap(asset.image);
        bg.alpha = opacity;
        bg.mouseEnabled = false;
        bg.noDrag();

        foo.backgroundLayer.addChild(bg);

        foo.background = {
            type: "tile",
            fill: fillKey,
            alpha: opacity
        };

        foo.stage.update();
        if (save)
            saveDesign()
    }

    const sliderToZoom = (sliderValue) => {
        if (sliderValue <= 50) {
            // Map 1-50 to 5%-50% linearly
            return 0.05 + (sliderValue / 50) * (0.5 - 0.05);
        } else {
            // Map 51-100 to 50%-300% using a smooth exponential increase
            return 0.5 * Math.pow(2, (sliderValue - 50) / 10);
        }
    };

    // Convert zoom scale back to slider value for display
    const zoomToSlider = (zoomValue) => {
        if (zoomValue <= 0.5) {
            return ((zoomValue - 0.05) / (0.5 - 0.05)) * 50;
        } else {
            return 50 + (Math.log2(zoomValue / 0.5) * 10);
        }
    };

    const zoomPresets = [0.1, 0.25, 0.5, 0.75, 1, 1.5, 2]; // 10%, 25%, etc.

    // Step zoom in/out via the +/- buttons, clamped to the slider's old range.
    const ZOOM_MIN = 0.05, ZOOM_MAX = 16;
    const zoomBy = (factor) => {
        const current = (foo && foo.zoomScale) ? foo.zoomScale : zoomScale;
        const next = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, current * factor));
        setZoomScale(next);
        scale(next);
    };

    // Hand/drag tool: sticky toggle. On → click-drag pans the map; off → back to select.
    const togglePan = () => {
        if (panMode) {
            enableTool("selectTool");   // clears panMode (see enableTool)
            setTool("select");
        } else {
            setPanMode(true);
            enableTool("panTool");
            setTool("pan");
        }
    };

    // Handle dropdown selection
    const handlePresetChange = (event) => {
        const newZoom = Number(event.target.value);
        setZoomScale(newZoom);
        scale(newZoom); // Call your existing scale function
        setDropdownActive(false); // Hide dropdown after selection
    };

    // Handle slider drag (switches back to text mode)
    const handleSliderChange = (event) => {
        const newZoom = sliderToZoom(Number(event.target.value));
        setZoomScale(newZoom);
        scale(newZoom);
        setDropdownActive(false); // Ensure dropdown is hidden
    };

   const updateStructureOptions = async (structure) => {
        var selStructure = structureDataMap[structure]
        if (!selStructure) {
             foo.selectedStructure = undefined
             setShowSelectedStructure(false)
             return
        }
        setMode("structure", selStructure);
        loadTile("planner_structures","planner_"+
            selStructure.name.toLowerCase().replace(" ","_").replace("(","").replace(")","").replace(",","_").replace(" ","_")+
            "_icon.png")
           .then(() => {
               console.log("{} structure loaded successfully.", assetName);
           })
           .catch((error) => {
               console.error(selStructure.name + " structure failed to load:", error);
           });
        foo.currStructure = { ...selStructure };
        foo.currStructure.width = foo.currStructure.defaultWidth
        foo.currStructure.height = foo.currStructure.defaultHeight
        foo.selectedStructure = foo.currStructure;
        setShowSelectedStructure(true)
   }

    const exitPlantAddMode = () => {
        setTool("select");
        foo.selectedPlant = undefined;
        foo.currPlant = undefined;
        setShowSelectedPlant(false);
        clearOldSelections();
    };

    const syncSelectionCount = () => {
        setSelectionCount(frame.selectedElements ? frame.selectedElements.size : 0);
    };

   const updatePlantOptions = async (plant) => {
       var selPlant = foo.plantDataMap[plant]
       if (!selPlant) {
           foo.selectedPlant = undefined
           setShowSelectedPlant(false)
           return
       }

       setShowSelectedPlant(true)
       selPlant.numPlants = 1
       setMode("plant", selPlant.name);
       if (selPlant.designerIconKey) {
           loadTileByKey(selPlant.designerIconKey)
               .then(() => console.log("custom tile loaded:", selPlant.designerIconKey))
               .catch((error) => console.error(selPlant.designerIconKey + " tile failed to load:", error));
       } else {
           var assetName = "planner_"+plant.toLowerCase().replace(" ","_").replace("(","").replace(")","").replace(",","_").replace(" ","_")+"_icon.png"
           loadTile("planner_icons", assetName)
               .then(() => console.log("{} tile loaded successfully.", assetName))
               .catch((error) => console.error(assetName + " tile failed to load:", error));
       }
       foo.currPlant = selPlant;
       foo.selectedPlant = selPlant;
       setNumPlants(foo.selectedPlant.numPlants)
       setNumPlantsWidth(foo.selectedPlant.numPlantsWidth)
       setNumPlantsHeight(foo.selectedPlant.numPlantsHeight)
       setPlantSpacing(foo.selectedPlant.spacing_between_plants)
       setShowSelectedPlant(true)
   }

    const deleteAllElements = () => {
        setDeleteModal(false);
        if (foo) {
            frame = foo
        }

        foo.planBox.removeAllChildren();
        foo.plantLayer.removeAllChildren();
        foo.areaLayer.removeAllChildren();
        foo.borderLayer.removeAllChildren();
        foo.structureLayer.removeAllChildren();
        foo.accessLayer.removeAllChildren();
        frame.selectedElement = null;
        for (var elementKey in foo.elements) {
            var element = foo.elements[elementKey];
            for (var i = 0; i < userareas.length; i++) {
                for (var ii = 0; ii < userareas[i].plants.length; ii++) {
                    if (userareas[i].plants[ii].id == element.id) {
                        userareas[i].plants.splice(ii, 1);
                        break
                    }
                }
            }
        }
        for (var i = 0; i < userareas.length; i++) {
            userareas[i].info.physical = false
            onUpdateArea(userareas[i])
        }
        foo.elements = {}
        clearOldSelections()
        saveDesign()
        updateTemplateOptions();
        foo.stage.update()
    }

    function SingleSelectionPanel({ selElement }) {
        return (
            <rt.Row style={{paddingTop: "5px"}}>
                <rt.Row>
                    {selElement.type != "area" && selElement.type !== "multi" && <rt.Col md={3}>
                        <rt.Button
                            onClick={e => {
                                copyElement(selElement["id"])
                            }}
                            color="#FFFFFF"
                            className="btn-sm"
                        >
                            <i className="bx bx-copy bx-lg"/>
                        </rt.Button>
                    </rt.Col>
                    }
                    {selElement.type != "area" &&
                        <rt.Col md={3}>
                            <rt.Button
                                onClick={e => {
                                    selElement.type === "multi" ? deleteSelectedElements(selElement.ids) : deleteElement(selElement["id"])
                                }}
                                color="#FFFFFF"
                                className="btn-sm"
                            >
                                <i className="bx bx-trash bx-lg"/>
                            </rt.Button>
                        </rt.Col>
                    }
                    {selElement.type == "border" &&

                        <rt.Col md={3}>
                            <rt.Button
                                onClick={e => {
                                    moveBorderUp(selElement)
                                }}
                                color="#FFFFFF"
                                className="btn-sm"
                            >
                                <i className="bx bx-chevrons-up bx-lg"/>
                            </rt.Button>
                        </rt.Col>
                    }
                    {selElement.type == "border" &&
                        <rt.Col md={3}>
                            <rt.Button
                                onClick={e => {
                                    moveBorderDown(selElement)
                                }}
                                color="#FFFFFF"
                                className="btn-sm"
                            >
                                <i className="bx bx-chevrons-down bx-lg"/>
                            </rt.Button>
                        </rt.Col>

                    }
                    {/* LOCK / UNLOCK — NOT FOR AREAS */}
                    {selElement.type !== "area" && selElement.type !== "multi" && (
                        <rt.Button
                            onClick={() => {
                                selElement.editable = !selElement.editable;

                                if (!selElement.editable) {
                                    selElement.asset.noDrag();

                                    // safety for patches
                                    if (isPlantPatch(selElement)) {
                                        selElement.asset.children?.forEach(ch => ch.noDrag());
                                    }
                                } else {
                                    if (isPlantPatch(selElement)) {
                                        selElement.asset.drag({all: true});
                                    } else {
                                        selElement.asset.drag();
                                    }
                                }

                                saveDesign();
                                foo.stage.update();
                            }}
                            color="#FFFFFF"
                            className="btn-sm"
                            title={selElement.editable === false ? "Unlock position" : "Lock position"}
                        >
                            <i
                                className={
                                    selElement.editable === false
                                        ? "bx bx-lock-alt bx-lg"
                                        : "bx bx-lock-open-alt bx-lg"
                                }
                            />
                        </rt.Button>
                    )}
                </rt.Row>
                {selElement.type != 'area' &&
                    <rt.Col md={6}>Rotation</rt.Col>
                }
                {selElement.type != 'area' && <rt.Col md={6}>
                    <Editable
                        name="rotation"
                        value={selElement["rotation"]}
                        showButtons={false}
                        display={(value) => {
                            return (<span style={{color: "black"}}>{value}</span>);
                        }}
                        dataType="text"
                        mode="inline"
                        handleSubmit={rotateElement}
                    />
                </rt.Col>
                }
            </rt.Row>
        );
    }

    function MultiSelectionPanel({selElement}) {
        return (
            <rt.Row style={{paddingTop: "5px"}}>
                <rt.Col md={12}>
                    <strong>{selElement.count} items selected</strong>
                </rt.Col>

                <rt.Col md={12} style={{marginTop: "8px"}}>
                    <ul style={{paddingLeft: "16px"}}>
                        {selElement.items.map(item => (
                            <li key={item.id}>
                                {item.label}
                            </li>
                        ))}
                    </ul>
                </rt.Col>

                <rt.Col md={12}>
                    <rt.Button
                        onClick={() => deleteSelectedElements()}
                        color="#FFFFFF"
                        className="btn-sm"
                    >
                        <i className="bx bx-trash bx-lg"/> Delete Selected
                    </rt.Button>
                </rt.Col>
            </rt.Row>
        );
    }


    const copyElement = (id) => {
        if (foo)
            frame = foo
        for (var elementKey in foo.elements) {
            var element = foo.elements[elementKey];
            if (element.id == id) {
                var newelement = {...element};
                newelement.asset = element.asset.clone();
                newelement.id = uuidv4();
                newelement.asset.x += 20;
                newelement.asset.y += 20;
                newelement.selected = false;
                newelement.moved = false;
                newelement.pressdown = null;
                newelement.pressmove = null;
                newelement.pressup = null;

                frame.elements[newelement.id] = newelement
                newelement.location = {x: newelement.asset.x, y: newelement.asset.y};
                var fill = "fill_" + element.fill + ".png";
                if (newelement.type == "border" || newelement.subtype == "access") {
                    newelement.asset.colorCommand.bitmap((frame.asset(fill).image));
                }
                if (newelement.type == "plant") {
                    frame.plantLayer.addChild(newelement.asset);
                } else if (newelement.type == "border") {
                    frame.borderLayer.addChild(newelement.asset);
                } else if (newelement.type == "structure") {
                    if (newelement.subtype == "access") {
                        frame.accessLayer.addChild(newelement.asset);
                    } else {
                        frame.structureLayer.addChild(newelement.asset);
                    }
                } else {
                    frame.planBox.addChildAt(newelement.asset, 1);
                }
                enterSelectionMode()
                saveDesign()
                foo.stage.update()

            }
        }
    }

    // ONLY RUN IN SELECTION MODE
    const selectElement = (element) => {
        frame = foo;
        if (!frame || !element) return;
        if (layerOf(element) != frame.currLayer) return;

        // Legacy helper used by some code paths: treat as single-select.
        selectSingleElement(element);

        if (element.moved && element.editable !== false) {
            element.location.x = this.x / foo.zoomScale;
            element.location.y = this.y / foo.zoomScale;
            element.asset.x = this.x;
            element.asset.y = this.y;
            if (element.type == "plant") {
                var areas = []
                for (var key in frame.elements) {
                    var celement = frame.elements[key]
                    if (celement.type == "area" && celement.asset) {
                        areas.push(celement)
                    }
                }
                checkPlantInArea(areas, element)
            } else if (element.type == "area") {
                var areas = []
                areas.push(element)
                for (var key in frame.elements) {
                    var candidateElement = frame.elements[key]
                    if (candidateElement.type == "plant")
                        checkPlantInArea(areas, candidateElement)
                }
            }
            hotItem = this;
            saveDesign();
            element.moved = false
            frame.stage.update();
        }
    }

    const rotateElement = (target) => {
        var rotation = target.newValue
        if (foo)
            frame = foo
        if (frame.selectedElement) {
            frame.selectedElement.rotation = rotation
            frame.selectedElement.asset.rotation = rotation
            frame.stage.update();
        }
        saveDesign();
    }

    const moveBorderUp = (currentBorder) => {
        let borderArr = [];
        for (var elementKey in foo.elements) {
            let element = foo.elements[elementKey];
            if (element.type == "border") {
                borderArr.push(element)
            }
        }

        borderArr.sort((a, b) => a.childIndex - b.childIndex)
        if (currentBorder.childIndex < borderArr.length - 1) {
            let higherBorder = borderArr[currentBorder.childIndex + 1]
            higherBorder.childIndex = currentBorder.childIndex
            currentBorder.childIndex = currentBorder.childIndex + 1
            foo.borderLayer.setChildIndex(currentBorder.asset, currentBorder.childIndex)
            foo.borderLayer.setChildIndex(higherBorder.asset, higherBorder.childIndex)
        }
        foo.stage.update()
        saveDesign()
    }

    const moveBorderDown = (currentBorder) => {
        let borderArr = [];
        for (var elementKey in foo.elements) {
            let element = foo.elements[elementKey];
            if (element.type == "border") {
                borderArr.push(element)
            }
        }

        borderArr.sort((a, b) => a.childIndex - b.childIndex)
        if (currentBorder.childIndex > 0) {
            let lowerBorder = borderArr[currentBorder.childIndex - 1]
            lowerBorder.childIndex = currentBorder.childIndex
            currentBorder.childIndex = currentBorder.childIndex - 1
            foo.borderLayer.setChildIndex(currentBorder.asset, currentBorder.childIndex)
            foo.borderLayer.setChildIndex(lowerBorder.asset, lowerBorder.childIndex)
        } else {
            foo.borderLayer.setChildIndex(currentBorder.asset, 0)
        }
        foo.stage.update()
        saveDesign()
    }

    const applyHotkey = (str) => {
        if (str == "ArrowRight") {
            frame.planWindow.scrollX -= 10;
        } else if (str == "ArrowLeft") {
            frame.planWindow.scrollX += 10;
        } else if (str == "ArrowUp") {
            frame.planWindow.scrollY += 10;
        } else if (str == "ArrowDown") {
            frame.planWindow.scrollY -= 10;
        }
        frame.stage.update()
    }

    const deleteElement = (id) => {
        if (foo)
            frame = foo
        for (var elementKey in foo.elements) {
            var element = foo.elements[elementKey];
            if (element.id == id) {
                if (element.type == "plant" && element.area != undefined) {
                    for (var i = 0; i < userareas.length; i++) {
                        for (var ii = 0; ii < userareas[i].plants.length; ii++) {
                            if (userareas[i].plants[ii].id == element.id) {
                                userareas[i].plants.splice(ii, 1);
                                onUpdateArea(userareas[i])
                                break
                            }
                        }
                    }
                }
                if (element.type == "area") {
                    for (var i = 0; i < userareas.length; i++) {
                        if (userareas[i].id == element.area) {
                            userareas[i].info.physical = false
                            onUpdateArea(userareas[i])
                        }
                    }
                }
                if (element.type == "border") {
                    foo.borderLayer.removeChild(element.asset)
                } else if (element.type == "plant") {
                    foo.plantLayer.removeChild(element.asset)
                } else if (element.type == "structure") {
                    if (element.subtype == "access") {
                        foo.accessLayer.removeChild(element.asset)
                    } else {
                        foo.structureLayer.removeChild(element.asset)
                    }
                }
                delete foo.elements[elementKey]
                clearOldSelections()
                saveDesign()
                foo.stage.update()
            }
        }
    }
    const deleteSelectedElements = (ids) => {
        if (foo) frame = foo;
        ensureSelectionSet();

        const toDelete = (ids && ids.length) ? ids : Array.from(frame.selectedElements || []);
        if (!toDelete.length) return;

        // Remove selection visuals first so highlights don't linger
        clearOldSelections();

        for (const id of toDelete) {
            for (var elementKey in foo.elements) {
                var element = foo.elements[elementKey];
                if (element.id != id) continue;

                if (element.type == "plant" && element.area != undefined) {
                    for (var i = 0; i < userareas.length; i++) {
                        for (var ii = 0; ii < userareas[i].plants.length; ii++) {
                            if (userareas[i].plants[ii].id == element.id) {
                                userareas[i].plants.splice(ii, 1);
                                onUpdateArea(userareas[i])
                                break
                            }
                        }
                    }
                }

                if (element.type == "border") {
                    foo.borderLayer.removeChild(element.asset)
                } else if (element.type == "plant") {
                    foo.plantLayer.removeChild(element.asset)
               } else if (element.type=="structure") {
                   if (element.subtype=="access") {
                       foo.accessLayer.removeChild(element.asset)
                   } else {
                       foo.structureLayer.removeChild(element.asset)
                   }
               }

               if (element.type!="area")
                   delete foo.elements[elementKey]
               break;
           }
       }

       saveDesign();
       foo.stage.update();
   }


   async function generatePresignedUrl() {
  const command = new GetObjectCommand({
    Bucket: bucketName,
    Key: objectKey,
  });

  try {
    const signedUrl = getSignedUrl(s3Client, command, { expiresIn: 3600 }).then // URL expires in 1 hour
    console.log("The presigned URL is:", signedUrl);
    return signedUrl;
  } catch (err) {
    console.error("Error generating presigned URL", err);
    return null;
  }
}

  const generateStructureElement = (x,y, element) => {
       var structureAsset = frame.asset("planner_"+element.meta.toLowerCase().replace(" ","_").replace("(","").replace(")","").replace(",","_").replace(" ","_")+"_icon.png").clone();
        structureAsset.x = x;
        structureAsset.y = y;
        structureAsset.scaleX = foo.zoomScale*element.width* 75/element.imgwidth
        structureAsset.scaleY = foo.zoomScale*element.height * 75/element.imgheight;
        structureAsset.rotation = element.rotation;

        element.scaleX = structureAsset.scaleX
        element.scaleY = structureAsset.scaleY;

        if (structureAsset.x<0) {
            structureAsset.x = 0;
        }
        if (structureAsset.y<0) {
            structureAsset.y = 0;
        }

        element.asset = structureAsset;
        element.location = {x:x, y:y};
        frame.structureLayer.addChild(structureAsset);
    }

    const generateAccessElement = (points, element) => {
        var accessAsset = new zim.Squiggle({
            points:points
        });
        //accessAsset.setBounds(100,100);
        accessAsset.thickness = element.thickness * gridWidth * frame.zoomScale
        if (!fill && !element.fill)
            element.fill = "gravel"
        var fill = "fill_" + element.fill + ".png";
        accessAsset.colorCommand.bitmap(frame.asset(fill).image)
        accessAsset.on("change", function (e) {
           element.points = getAbsolutePoints(this.points, frame.zoomScale)
           saveDesign()
        })
        accessAsset.x = element.location.x;
        accessAsset.y = element.location.y;

        frame.accessLayer.addChild(accessAsset);
        return accessAsset;
    }

    function saveAddress() {
        // save this information to the user's profile
        var updatedProfile = {...profile}
        updatedProfile.address = {}
        updatedProfile.address.address1 = address1
        updatedProfile.address.address2 = address2
        updatedProfile.address.city = city
        updatedProfile.address.state = state
        updatedProfile.address.zipcode = zipcode
        updatedProfile.unitmeasurement = "Imperial"
        updatedProfile.climate = "Temperate"
        updatedProfile.zone = "7"
        updatedProfile.setup = "completed"
        onUpdateProfile(updatedProfile)
        onFetchClimateData(updatedProfile.address.zipcode);
        setAddressModal(false)
   }

    function applyZoomToPlantElement(element, zoom) {
        if (!element || element.type !== "plant" || !element.asset) return;

        element.asset.x = element.location.x * zoom;
        element.asset.y = element.location.y * zoom;

        if (element.plant.numPlants > 1) {
            const patchPlants = element.asset.children;
            let patchCount = 0;

            for (let i = 0; i < element.numPlantsWidth; i++) {
                for (let j = 0; j < element.numPlantsHeight; j++) {
                    const patchPlant = patchPlants[patchCount++];
                    if (!patchPlant) continue;

                    const spacingPx1 = isMetric ? metricGridWidth * element.plant.spacing_between_plants * 2.54 / 100 : gridWidth * element.plant.spacing_between_plants / 12;
                    patchPlant.x = i * spacingPx1 * zoom;
                    patchPlant.y = j * spacingPx1 * zoom;
                    patchPlant.scaleX = zoom * element.scale;
                    patchPlant.scaleY = zoom * element.scale;
                }
            }
        } else {
            element.asset.scaleX = zoom * element.scale;
            element.asset.scaleY = zoom * element.scale;
        }
    }

    function rerenderSelectedPlantIcon(savedElement) {
        const el = foo.selectedElement;
        if (!el || el.type !== "plant" || !el.asset) return;

        const oldX = el.asset.x;
        const oldY = el.asset.y;
        const oldRot = el.rotation || el.asset.rotation || 0;

        foo.plantLayer.removeChild(el.asset);
        frame = foo;

        const patch = (el.plant.numPlants > 1)
            ? { width: el.numPlantsWidth, height: el.numPlantsHeight }
            : null;

        const assetName = plantIconAssetId(el.plant);

        // Call generate as usual (don't care what coords it expects)
        generatePlantElement(oldX, oldY, el, el.id, el.plant.size, patch, assetName);

        // Force the new asset back to the original pixel location
        el.asset.x = oldX;
        el.asset.y = oldY;
        el.asset.rotation = oldRot;

        // Keep location consistent with your zoom model
        el.location.x = oldX / foo.zoomScale;
        el.location.y = oldY / foo.zoomScale;

        // Apply current zoom scaling immediately (no zoom needed)
        applyZoomToPlantElement(el, foo.zoomScale);

        enterSelectionMode();
        selectSingleElement(savedElement);
        foo.stage.update();
    }


    const plantIconAssetId = (plant) => {
        if (plant && plant.designerIconKey) return plant.designerIconKey;
        const species = (plant && (plant.species || plant.name)) || "";
        return "planner_" + species.toLowerCase()
            .replace(" ", "_").replace("(", "").replace(")", "").replace(",", "_").replace(" ", "_")
            + "_icon.png";
    }

    const generatePlantElement = (x,y, element, name, size, patch, assetName) => {
        var iconScale;

        if (!size) {
           iconScale = 1;
        } else {
           iconScale = plantScales[size.toLowerCase()];
        }
        if (!iconScale)
           iconScale = 1;

        if (!element.meta)
            element.meta = element.plant.species
        var plantAsset = foo.asset(assetName).clone();

        // plantAsset.x = x-(plantAsset.width/2);
        // plantAsset.y = y-(plantAsset.height/2);
        plantAsset.x = x;
        plantAsset.y = y;
        plantAsset.scale = iconScale;
        element.scale = iconScale;
        element.id = name;
        plantAsset.x -= plantAsset.width*1/2;
        plantAsset.y -= plantAsset.height*1/2;

        if (patch) {
            var patchContainer = new zim.Container()
            for (var i=0; i<element.numPlantsWidth; i++) {
                for (var j=0; j<element.numPlantsHeight; j++) {
                    var copyPlant = foo.asset(assetName).clone();
                    copyPlant.scale = iconScale;
                    const spacingPx2 = isMetric ? metricGridWidth * element.plant.spacing_between_plants * 2.54 / 100 : gridWidth * element.plant.spacing_between_plants / 12;
                    copyPlant.x = i * spacingPx2 * frame.zoomScale;
                    copyPlant.y = j * spacingPx2 * frame.zoomScale;
                    patchContainer.addChild(copyPlant)
                    copyPlant.noDrag();
                }
            }
            patchContainer.x = x;
            patchContainer.y = y;
            plantAsset = patchContainer;
        }

        if (plantAsset.x<0) {
            plantAsset.x = 0;
        }
        if (plantAsset.y<0) {
            plantAsset.y = 0;
        }

        element.asset = plantAsset;
        element.asset.rotation = element.rotation;
        element.location = {x:x, y:y};

        frame.plantLayer.addChild(plantAsset);
    }

    const isPlantPatch = (el) =>
        el?.type === "plant" &&
        el?.asset instanceof zim.Container &&
        el?.plant &&
        el.plant.numPlants > 1;   // or (el.numPlantsWidth > 1 || el.numPlantsHeight > 1)

    const generatePlantDates = (plantElement) => {

        var plantWindows = {}
        var plant = plantElement.plant;
        var plantInfo = {...foo.plantDataMap[plantElement.meta]};
        var plantName = plant.name;
        plant.species = plant.name;
        plantWindows[plantName] = {}
        plantWindows[plantName].ranges = []

        var min = parseFloat(plantInfo.minimumTemp);
        var max = parseFloat(plantInfo.maximumTemp);
        var minMonth;
        var maxMonth;
        var climateInfo = Object.assign({}, foo.climateData);
        if (profile.climates && profile.climates.length>0) {
            for (var i=0; i<profile.climates.length; i++) {
                if (profile.climates[i].selected) {
                    climateInfo = profile.climates[i]
                }
            }
        }

        var plWindow = [];
        var min = parseFloat(plantInfo.minimumTemp);
        var max = parseFloat(plantInfo.maximumTemp);
        var minMonth;
        var maxMonth;
        if (foo.seasonRotation=="Fall") {
            for (var i=9; i<months.length; i++) {
                var minMonthTemp = parseFloat(climateInfo[months[i] + "Min"]);
                var maxMonthTemp = parseFloat(climateInfo[months[i] + "Max"]);
                if (minMonthTemp>min && maxMonthTemp<max) {
                    plWindow.push(i);
                }
            }
        } else if (foo.seasonRotation=="Spring") {
            for (var i=0; i<6; i++) {
                var minMonthTemp = parseFloat(climateInfo[months[i] + "Min"]);
                var maxMonthTemp = parseFloat(climateInfo[months[i] + "Max"]);
                if (minMonthTemp>min && maxMonthTemp<max) {
                    plWindow.push(i);
                }
            }
        } else if (foo.seasonRotation=="Summer") {
            for (var i=6; i<9; i++) {
                var minMonthTemp = parseFloat(climateInfo[months[i] + "Min"]);
                var maxMonthTemp = parseFloat(climateInfo[months[i] + "Max"]);
                if (minMonthTemp>min && maxMonthTemp<max) {
                    plWindow.push(i);
                }
            }
        } else {
            for (var i=0; i<11; i++) {
                var minMonthTemp = parseFloat(climateInfo[months[i] + "Min"]);
                var maxMonthTemp = parseFloat(climateInfo[months[i] + "Max"]);
                if (minMonthTemp>min && maxMonthTemp<max) {
                    plWindow.push(i);
                }
            }
        }

        var climateSeries = [
            {
                name: "Hot Averages",
                color: "#F00505",
                data: [parseFloat(climateInfo["JanMax"]),parseFloat(climateInfo["FebMax"]),parseFloat(climateInfo["MarMax"]),parseFloat(climateInfo["AprMax"]),parseFloat(climateInfo["MayMax"]),
                    parseFloat(climateInfo["JunMax"]),parseFloat(climateInfo["JulMax"]),parseFloat(climateInfo["AugMax"]),parseFloat(climateInfo["SepMax"]),
                    parseFloat(climateInfo["OctMax"]),parseFloat(climateInfo["NovMax"]),parseFloat(climateInfo["DecMax"])]
            },
            {
                name: "Cold Averages",
                color: "#143FA1",
                data: [parseFloat(climateInfo["JanMin"]),parseFloat(climateInfo["FebMin"]),parseFloat(climateInfo["MarMin"]),parseFloat(climateInfo["AprMin"]),parseFloat(climateInfo["MayMin"]),
                    parseFloat(climateInfo["JunMin"]),parseFloat(climateData["JulMin"]),parseFloat(climateInfo["AugMin"]),parseFloat(climateInfo["SepMin"]),
                    parseFloat(climateInfo["OctMin"]),parseFloat(climateInfo["NovMin"]),parseFloat(climateInfo["DecMin"])]
            }]

        setClimateAverages(climateSeries)

        if (plWindow.length<2) {
            return
        }
        var nummonths = 1
        var ranges = []
        var start = plWindow[0]
        var pointer = plWindow[0]
        for (var i=1; i<plWindow.length; i++) {
            if (plWindow[i]==pointer+1) {
                nummonths++
            } else {
                ranges.push({"start":start, "end": pointer})
                nummonths = 1
                start = plWindow[i]
            }
            pointer = plWindow[i]
        }
        if (nummonths>1) {
            ranges.push({"start":start, "end": pointer})
        }
        console.log("Plant " + plantName + " has ranges " + ranges);

        // if we have a range, calculate exact dates based off
        var annot = {};
        if (ranges.length>0) {
            var startofyear = false;
            if (ranges[0].start == 0) {
                // if whole year, add another range from mid-year to mid-year
                if (ranges[0].end == 11) {
                    ranges.push({"start": 7, "end": 6})
                }
                var rangeToMerge;
                var numranges = ranges.length;
                for (var i = 1; i < numranges; i++) {
                    if (ranges[i].end == 11) {
                        ranges[0].start = ranges[i].start;
                        ranges.splice(i, 1);
                        break;
                    }
                }
            }

            var startWindow, endWindow;
            var dateRanges = [];
            for (var i = 0; i < ranges.length; i++) {
                var startMonth = ranges[i].start;
                var endMonth = ranges[i].end;
                var startDay = null;
                var calcStartMonth = startMonth;
                while (!(startDay instanceof Date && !isNaN(startDay))) {
                    startDay = calcExactDay(calcStartMonth, min, max, false, climateInfo);
                    if (startDay < new Date())
                        startDay.setFullYear(startDay.getFullYear() + 1);
                    calcStartMonth++;
                }
                var endDay = calcExactDay(endMonth, min, max, true, climateInfo);
                if (endDay < new Date())
                    endDay.setFullYear(endDay.getFullYear() + 1);
                if (endDay.getTime() - startDay.getTime() < 0) {
                    endDay.setFullYear(endDay.getFullYear() + 1);
                }
                var numDays = (endDay.getTime() - startDay.getTime()) / (1000 * 3600 * 24)
                const daysToHarvest = parseFloat(plantInfo.daysToHarvest);
                const storageDays = parseFloat(plantInfo.storage_days);
                if (numDays > daysToHarvest) {
                    plantWindows[plant.species].ranges.push({"start": startDay, "end": endDay});
                } else {
                    plWindow = {
                        "start": startDay.toDateString(),
                        "end": endDay.toDateString()
                    }
                }
            }
        }

        var ranges = plantWindows[plant.species].ranges;
        var numweeks = 0;
        plantWindows[plant.species].spaceNeeded = [];
        plantWindows[plant.species].seedStart = [];
        plantWindows[plant.species].transplant = [];
        plantWindows[plant.species].harvest = [];

        if (ranges.length>0) {
            plant.plantingWindow = annot;
            var daysToTransplant = 0;
            if (plantInfo.daysToTransplant) {
                daysToTransplant = parseInt(plantInfo.daysToTransplant)
            }

            if (!foo.lastDatePossible) {
                var harvestDate = new Date(ranges[0].start);
                harvestDate.setDate(harvestDate.getDate() + parseInt(plantInfo.daysToHarvest));
                plantElement.plant["harvestDate"] = (harvestDate.getMonth() + 1) + '/' + (harvestDate.getDate()+1) + '/' +  harvestDate.getFullYear();
                harvestDate.setDate(harvestDate.getDate() + 1)

                var seedDate = new Date(ranges[0].start);
                seedDate.setDate(seedDate.getDate() - daysToTransplant - parseInt(plantInfo.germinationTime));
                plantElement.plant["seedStartDate"] = (seedDate.getMonth() + 1) + '/' + (seedDate.getDate()+1) + '/' +  seedDate.getFullYear();
                seedDate.setDate(seedDate.getDate() + 1)

                var transplantDate = ranges[0].start;
                plantElement.plant["transplantDate"] = (transplantDate.getMonth() + 1) + '/' + (transplantDate.getDate()+1) + '/' +  transplantDate.getFullYear();
                transplantDate.setDate(transplantDate.getDate() + 1)
            } else {
                var harvestDate = new Date(ranges[0].end);
                harvestDate.setDate(harvestDate.getDate());
                plantElement.plant["harvestDate"] = (harvestDate.getMonth() + 1) + '/' + (harvestDate.getDate()+1) + '/' +  harvestDate.getFullYear();
                harvestDate.setDate(harvestDate.getDate() + 1)

                var seedDate = new Date(ranges[0].end);
                seedDate.setDate(seedDate.getDate() - daysToTransplant - parseInt(plantInfo.daysToHarvest) - parseInt(plantInfo.germinationTime));
                plantElement.plant["seedStartDate"] = (seedDate.getMonth() + 1) + '/' + (seedDate.getDate()+1) + '/' +  seedDate.getFullYear();
                seedDate.setDate(seedDate.getDate() + 1)

                var transplantDate = ranges[0].end;
                transplantDate.setDate(transplantDate.getDate() - parseInt(plantInfo.daysToHarvest));
                plantElement.plant["transplantDate"] = (transplantDate.getMonth() + 1) + '/' + (transplantDate.getDate()+1) + '/' +  transplantDate.getFullYear();
                transplantDate.setDate(transplantDate.getDate() + 1)
            }

        }
     }

function loadGoogleMap() {
  if (profile && profile.address) {
      var location = profile.address.address1 + ","
      if (profile.address.address2 && profile.address.address2!='') {
          location += profile.address.address2 + ","
      }
      location += profile.address.city + "," + profile.address.state
      if (profile.address.zipcode && profile.address.zipcode!='') {
          location += "," + profile.address.zipcode
      }
  }
  geocodeAddress(location)
}

    function calcExactDay(keyMonth, min, max, inv = false, climateInfo) {
        const xs = [0, 30, 60];
        let keyDate = null;
        let ymins = [];
        let ymaxs = [];
        let prevMonth = keyMonth - 1;
        let nextMonth = keyMonth + 1;

        if (prevMonth == -1) prevMonth = 11;
        if (nextMonth == 12) nextMonth = 0;

        ymins.push(climateInfo[months[prevMonth] + "Min"]);
        ymins.push(climateInfo[months[keyMonth] + "Min"]);
        ymins.push(climateInfo[months[nextMonth] + "Min"]);
        ymaxs.push(climateInfo[months[prevMonth] + "Max"]);
        ymaxs.push(climateInfo[months[keyMonth] + "Max"]);
        ymaxs.push(climateInfo[months[nextMonth] + "Max"]);

        const minSpline = new Spline(xs, ymins);
        const maxSpline = new Spline(xs, ymaxs);

        if (!inv) {
            for (let i = 0; i < 60; i++) {
                if (minSpline.at(i) >= min && maxSpline.at(i) <= max) {
                    keyDate = i;
                    break;
                }
            }
        } else {
            for (let i = 60; i > 0; i--) {
                if (minSpline.at(i) >= min && maxSpline.at(i) <= max) {
                    keyDate = i;
                    break;
                }
            }
        }

        if (keyDate === null) {
            console.log("No valid keyDate found.");
            return null; // No valid date found
        }

        let currYear = new Date().getFullYear();
        let d = new Date(currYear, prevMonth, 15); // prevMonth is zero-based now
        d.setDate(d.getDate() + keyDate);

        // Ensure `d` doesn't exceed the max days of the computed month
        const maxDaysInMonth = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
        if (d.getDate() > maxDaysInMonth) {
            d.setDate(maxDaysInMonth); // Clamps date to last day of month
        }

        // Handle year roll-over correctly
        if (nextMonth == 0 && d.getMonth() == 0) {
            d.setFullYear(d.getFullYear() + 1);
        }

        return d;
    }


    const updateTemplateOptions = () => {
        // set dimensions
        currDesign = frame.currDesign
        if (currDesign.dimensions.width && currDesign.dimensions.height) {
            var width = 3000;
            var height = 3000;
            buildPlanBox(width, height);
        }
        // grab zipcode.  If not set, alert user
        if (profile.address!=undefined) {
            // fetch station and look up normals based off zipcode
            onFetchClimateData(profile.address.zipcode);
        } else {
            setAddressModal(true)
        }

    generateGrid(1)       
    }

    const buildPlanBox = (planWidth, planHeight) => {
        // Asks to enable hotkeys
        frame.stage.removeChild(planWindow);
        frame.stage.removeChild(planBox);
        frame.zoomScale = 1;
        frame.marquee = null;
        frame.marqueeStarted = false;
        frame.marqueeStart = null;

        frame.elements = {};
	      if (planBox) {
            planBox.removeAllChildren;
        }

        planWindow = new zim.Window({
            width: 890,
            height: 690,
            padding: 0,
            borderColor: "black",
            borderWidth: 1,
            corner: 0,
            backgroundColor: "white",
            scrollBarActive: false,   // hidden — panning replaces the scrollbars
            slideSnap: "none",
            swipe: false,
            slide: false,
            draggable: false,
            optimize: false
        });
        planWindow.scrollX = 0;
        planWindow.scrollY = 0;

        planBox = new zim.Container();

        plantLayer = new zim.Container();
        frame.planBox = planBox
        frame.plantLayer = plantLayer
        borderLayer = new zim.Container();
        frame.borderLayer = borderLayer
        accessLayer = new zim.Container();
        frame.accessLayer = accessLayer
        structureLayer = new zim.Container();
        frame.structureLayer = structureLayer
        areaLayer = new zim.Container();
        frame.areaLayer = areaLayer
        backgroundLayer = new zim.Container();
        frame.backgroundLayer = backgroundLayer;

        selectionLayer = new zim.Container();
        frame.selectionLayer = selectionLayer

        frame.planBox.addChildAt(frame.backgroundLayer, 2);
        frame.planBox.addChildAt(frame.areaLayer,3)
        frame.planBox.addChildAt(frame.borderLayer,4)
        frame.planBox.addChildAt(frame.accessLayer,5)
        frame.planBox.addChildAt(frame.structureLayer,6)
        frame.planBox.addChildAt(frame.plantLayer,7)
        frame.planBox.addChildAt(frame.selectionLayer,8)
        planWindow.x = 0;
        planWindow.y = 50;
        frame.planWindow = planWindow

        planGrid = new zim.Rectangle(planWidth, planHeight, "#EEE");

	      planBox.on("mousedown", function (e) {
          //  var mousex = e.stageX / frame.stage.scaleX - planWindow.x - planWindow.scrollX;
           //var mousey = e.stageY / frame.stage.scaleY - planWindow.y - planWindow.scrollY;
            var mousex = e.stageX - planWindow.x - planWindow.scrollX;
            var mousey = e.stageY - planWindow.y - planWindow.scrollY;
            applyTool(mousex, mousey, "mousedown");
            frame.stage.update();
        })


        frame.stage.on("stagemousemove", function (e) {
           var curx =  e.stageX.toFixed(2);
           var cury =  (e.stageY-80).toFixed(2);
           if (!frame.cursor) {
	       var curx =  e.stageX.toFixed(2);
	       var cury =  (e.stageY-80).toFixed(2);
	       frame.cursor = new zim.Label({
                   text: "(" + curx + "," + cury + ")",
                   size: "10px",
                   color: "#006600",
                   font:font
               });
               planGrid.addChild(frame.cursor);
	   }
	   frame.cursor.x = e.stageX+15;
           frame.cursor.y = cury;
	   frame.cursor.text =  "(" + curx + "," + cury + ")";
           frame.stage.update();
        })

        planBox.on("pressmove", function (e) {
            applyTool(e.stageX, e.stageY, "mousemove");
        })
        planBox.on("pressup", function (e) {
            applyTool(e.stageX, e.stageY, "mouseup");
        })
        frame.on("keydown", e=>{
            applyHotkey(e.key);
        })

        planBox.addChild(planGrid);
        for (var elementKey in frame.elements) {
            var element = frame.elements[elementKey];
            if (element.type == 'border') {
                borderLayer.addChild(element.asset);
            } else if (element.type == 'structure') {
                if (element.subtype == 'access') {
                    accessLayer.addChild(element.asset);
                } else {
                    structureLayer.addChild(element.asset);
                }
            } else if (element.type == 'plant') {
                plantLayer.addChild(element.asset);
            } else {
                planBox.addChild(elements[elementKey].asset);
            }
        }
        mode = ""
        planWindow.add(planBox);
        frame.stage.addChild(planWindow);
    }

    const scale = (newVal) => {
        if (
            foo.planWindow.scrollX == null ||
            foo.planWindow.scrollY == null ||
            isNaN(foo.planWindow.scrollX) ||
            isNaN(foo.planWindow.scrollY) || foo.planWindow.scrollX == Infinity ||
            foo.planWindow.scrollY == Infinity
        ) {
            foo.planWindow.scrollX = 0;
            foo.planWindow.scrollY = 0;
        }

        if (foo.selectedElement) {
            foo.planBox.removeChild(foo.selectedElement.highlight);
            foo.selectedElement.highlight = undefined;
            foo.selectedElement.selected = false;
            foo.selectedElement = null;
            setSelElement()
        }

        // Compute scaling ratio
        let scaleRatio = newVal / foo.zoomScale;

        // Compute the new scroll values based on pixel scaling
        foo.planWindow.scrollX = foo.planWindow.scrollX * scaleRatio - (foo.planWindow.width / 2) * (scaleRatio - 1);
        foo.planWindow.scrollY = foo.planWindow.scrollY * scaleRatio - (foo.planWindow.height / 2) * (scaleRatio - 1);

        setZoomScale(newVal)
       foo.zoomScale = newVal

       for (var key in foo.elements) {
            var element = foo.elements[key];
            if (!element.asset)
               continue
            element.asset.x = element.location.x*newVal;
            element.asset.y = element.location.y*newVal;

            if (element.type=="plant") {
                if (element.plant.numPlants>1) {
                    var patchPlants = element.asset.children
                    var patchCount = 0
                    for (var i=0; i<element.numPlantsWidth; i++) {
                        for (var j=0; j<element.numPlantsHeight; j++) {
                            var patchPlant = patchPlants[patchCount++]
                            const spacingPx3 = isMetric ? metricGridWidth * element.plant.spacing_between_plants * 2.54 / 100 : gridWidth * element.plant.spacing_between_plants / 12;
                            patchPlant.x = i * spacingPx3 * newVal;
                            patchPlant.y = j * spacingPx3 * newVal;
                            patchPlant.scaleX = newVal * element.scale;
                            patchPlant.scaleY = newVal * element.scale;
                        }
                    }

                } else {
                    element.asset.scaleX = newVal * element.scale;
                    element.asset.scaleY = newVal * element.scale;
                }
            } else if (element.type=="structure" && element.subtype=="structure") {
                element.asset.scaleX = newVal*element.width* 75/element.imgwidth
                element.asset.scaleY = newVal*element.height * 75/element.imgheight;
            } else if (element.type == "structure" && element.subtype=="access") {
                element.asset.setPoints(element.points)
                element.asset.transformPoints("scale", Number(newVal))
                let scaledPoints = element.asset.getPoints();
                element.asset.thickness = newVal*element.thickness*gridWidth
            } else {
                element.asset.scaleX = newVal/element.origScale;
                element.asset.scaleY = newVal/element.origScale;
            }
        }
        for (var i=0; i<foo.planBox.children.length; i++) {
             if (foo.planBox.children[i].type=="gridlines" || foo.planBox.children[i].type=="gridlabel") {
                 foo.planBox.removeChild(foo.planBox.children[i])
             }
        }
        foo.planBox.removeChild(foo.grid)
        for (let i = 0; i < foo.gridLabels.length; i++) {
            foo.planBox.removeChild(foo.gridLabels[i]);
        }
        // Optionally, clear the array to ensure no references remain
        foo.gridLabels.length = 0; // Reset the array


        generateGrid(newVal)

        if (foo.backgroundLayer && foo.backgroundLayer.numChildren > 0) {
            setGardenBackground(foo.background.fill, foo.background.opacity)
        }
        foo.planBox.addChildAt(foo.backgroundLayer, 2)
        foo.planBox.addChildAt(foo.areaLayer, 3)
        foo.planBox.addChildAt(foo.borderLayer, 4)
        foo.planBox.addChildAt(foo.accessLayer, 5)
        foo.planBox.addChildAt(foo.structureLayer, 6)
        foo.planBox.addChildAt(foo.plantLayer, 7)
        foo.planBox.addChildAt(foo.selectionLayer, 8)
        // grid lines must be above backgroundLayer so they remain visible over any terrain fill
        foo.planBox.setChildIndex(foo.grid, 2)

        if (!frame)
          foo.stage.update()
        else
          frame.stage.update()
    }


    const enableTool = (tool) => {
        // Picking any tool other than pan exits pan mode (so the button un-highlights).
        if (tool !== 'panTool') setPanMode(false);
        if (mode != "selectTool") {
            let elementKey;
            if (!frame && foo)
		           frame = foo
	          for (elementKey in frame.elements) {
                    var element = frame.elements[elementKey];
                     element.asset.noDrag();
            }
        }

        if (tool == 'plantTool') {
            clearOldSelections();
        } else if (tool == 'borderTool') {
            clearOldSelections();
        } else if (tool == 'selectTool') {
            setMode("select");
            enterSelectionMode();
            frame.tool = "select"
            frame.stage.update();
        } else if (tool == 'editAreaTool') {
	         clearOldSelections();
	         frame.stage.update();
	    }  else if (tool == 'addAreaTool') {
            clearOldSelections();
            frame.stage.update();
        } else if (tool == 'linkAreaTool') {
            clearOldSelections();
            frame.stage.update();
        } else if (tool == 'structureTool') {
            setMode("access");
            clearOldSelections();
            frame.stage.update();
        } else if (tool == 'accessTool') {
            setMode("access");
            frame.lineStarted = false;
            frame.accessThickness = 75;
            setLineStarted(false)
            clearOldSelections();
            frame.stage.update();
        } else if (tool == 'panTool') {
            setMode("pan", "pan");
            clearOldSelections();
            // Disable element dragging while panning the map.
            for (var pk in frame.elements) {
                if (frame.elements[pk].asset) frame.elements[pk].asset.noDrag();
            }
            try { frame.stage.canvas.style.cursor = "grab"; } catch (e) { /* ignore */ }
            frame.stage.update();
        }

        if (tool !== 'panTool') {
            try { if (frame.stage && frame.stage.canvas) frame.stage.canvas.style.cursor = "default"; } catch (e) { /* ignore */ }
        }

    }

    const setMode = (lmode, ltool) => {
        // check current mode
	if (!frame)
	   frame = foo
        frame.mode = lmode
        frame.tool = ltool
    }

    function getDayOfYear(date) {
        const startOfYear = new Date(date.getFullYear(), 0, 1); // January 1st of the year
        const diffInMilliseconds = date - startOfYear;
        const dayOfYear = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24)) + 1;
        return dayOfYear;
    }

    function dayOfYearToDate(year, dayOfYear) {
        const startOfYear = new Date(year, 0, 1); // January 1st of the given year
        return new Date(startOfYear.setDate(dayOfYear));
    }

    const buildSeasonSlider = () => {
        cropRotation = new zim.Container();

        // draw labels for months
        var months = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
        for (var i=0; i<12; i++) {
            var monthLabel = new zim.Label({
                text:months[i],
                size:14,
                color:"#006600",
            });
            monthLabel.x = 75+i*64.33;
            monthLabel.y = 15;

            var monthRect = new zim.Rectangle({width:75.33,
                height:35,
                color:"#AABBAA",
                borderWidth:2,
                borderColor:"white"});
            monthRect.x = 55 + i*64.33;
            monthRect.y = 0;

            cropRotation.addChild(monthRect);
            cropRotation.addChild(monthLabel);
        }

        var seasonSlider = new zim.Slider ({
            min: 0,
            max: 365,
            barLength: 800,
            barWidth: 30,
            barColor: "#AAA",
            keyArrows: false
        });
        seasonSlider.on("change", function() {
            var newVal = Math.round(seasonSlider.currentValue);
            const sliderValue = seasonSlider.currentValueEvent;
            const date = dayOfYearToDate(new Date().getFullYear(), Math.round(sliderValue));
            const formattedDate = date.toDateString();

            if (seasonSlider.showTooltip) {
                tooltip.text = formattedDate;
                // Update tooltip text
                tooltip.pos(seasonSlider.x + seasonSlider.currentValue * seasonSlider.width / seasonSlider.max,
                    seasonSlider.y - 20); // Position above the slider
                tooltip.visible = true;
            }

            for (var key in frame.elements) {
                var element = frame.elements[key];
                if (element.type=='plant')
                    frame.plantLayer.removeChild(element.asset);
            }
            for (var elementKey in frame.elements) {
                var keepElement = false;
                var element = frame.elements[elementKey];
                if (element.type!='plant')
                    continue;
                if (element.plant.seedStartDate!=undefined && element.plant.transplantDate!=undefined) {
                    var start = getDayOfYear(new Date(element.plant.seedStartDate))
                    var end = getDayOfYear(new Date(element.plant.harvestDate))
                    if (start<newVal && end>newVal) {
                        frame.plantLayer.addChild(element.asset)
                        continue;
                    }
                } else {
                    frame.plantLayer.addChildAt(element.asset);
                }
            }
        });
        seasonSlider.alpha = 0.5;
        seasonSlider.x = 60;
        seasonSlider.y = 15;
        cropRotation.addChild(seasonSlider);

        const tooltip = new zim.Label({
            text: "",
            size: 14,
            color: "#000",
            backgroundColor: "#fff",
            paddingHorizontal: 10,
            paddingVertical: 5,
            corner: 5
        });
        tooltip.alpha = 0.8; // Slight transparency
        tooltip.visible = false; // Initially hidden
        cropRotation.addChild(tooltip)

        seasonSlider.on("mouseout", () => {
            //tooltip.visible = false; // Hide the tooltip when not hovering
            //frame.stage.update();
        });

        var resetButtonIcon = pizzazz.makeIcon({
            type:"rotate",
            color:"#004200",
            scale:0.7,
            multi:1,
            multiAlpha:.5,
            multiScale:0,
            multiX:2,
            multiY:2,
            skewX:0,
            skewY:0
        });

        (function (seasonSlider) {
            var yearPulldown = new zim.Button({
                icon: resetButtonIcon,
                width: 40,
                height: 30,
                color:frame.lighter,
                rollColor:frame.green,
                gradient:.3,
                corner:2,
                backing: resetButtonIcon
            });
            yearPulldown.x = 2;
            yearPulldown.y = 0;
            yearPulldown.on("click", function() {
                if (seasonSlider.animation) {
                    seasonSlider.animation.stopAnimate();
                    seasonSlider.showTooltip = true
                }
                seasonSlider.currentValue = 0;
                tooltip.visible = false
                for (var key in frame.elements) {
                     var element = frame.elements[key];
                     if (element.type=="plant") {
                        frame.plantLayer.removeChild(element.asset);
                        frame.plantLayer.addChildAt(element.asset);
                     }
                }
                frame.stage.update();
            });
            cropRotation.addChild(yearPulldown);

            // add play button
            var playButtonIcon = pizzazz.makeIcon({
                type:"play",
                color:"#004200",
                scale:0.7,
                multi:1,
                multiAlpha:.5,
                multiScale:0,
                multiX:2,
                multiY:2,
                skewX:0,
                skewY:0
            });
            var playButton = new zim.Button({
                width:30,
                height:30,
                color:frame.lighter,
                rollColor:frame.green,
                gradient:.3,
                corner:2,
                backing: playButtonIcon,
                icon:playButtonIcon
            });
            playButton.x = 844;
            playButton.y = 0;

            var done = function() {
                seasonSlider.currentValue = 0;
                tooltip.visible = false
                seasonSlider.showTooltip = true
                for (var key in frame.elements) {
                    var element = frame.elements[key];
                    frame.plantLayer.removeChild(element.asset);
                    frame.plantLayer.addChild(element.asset);
                }
                frame.stage.update();
            }
            playButton.on("click", function() {
                seasonSlider.currentValue = 0;
                seasonSlider.showTooltip = false
                seasonSlider.animation = seasonSlider.animate({props:{currentValueEvent:365}, time:20, ease:"linear", call:done});
		            frame.stage.update()

            });
            cropRotation.addChild(playButton);
            cropRotation.y = 10;
            cropRotation = cropRotation;
            frame.stage.addChild(cropRotation);

        })(seasonSlider)

    }

    const createDesign = () => {
        foo.savingdesign = true
        createTemplate();
	      updateTemplateOptions();
        createUnassignedArea()
        saveDesign()
    }

    const saveDesign = () => {
        // foo can be undefined in init-render closures (canvas handlers); fall back
        // to the live frame. See foo/frame canvas pattern.
        const F = foo || frame;
        var plants = []
        var borders = []
        var areas = []
        var background = {}
        var structures = []
        var access = []
        if (F.background) {
            background.type = "tile";
            background.fill = F.background.fill;
            background.alpha = F.background.alpha;
        }
        for (var key in F.elements) {
             var element = F.elements[key];
             var saveElement = {};

             saveElement.location = element.location;
             saveElement.location.x = element.asset.x/F.zoomScale;
             saveElement.location.y = element.asset.y/F.zoomScale;
             saveElement.id = element.id;
             saveElement.editable = element.editable;
             saveElement.name = element.name;
             saveElement.type = element.type
             if (element.type == 'plant') {
                 saveElement.species = element.plant.species;
                 saveElement.area = element.area
                 saveElement.plant = element.plant
                 if (element.plant.designerIconKey)
                     saveElement.designerIconKey = element.plant.designerIconKey;
                 saveElement.rotation = element.rotation
                 saveElement.numPlantsWidth = element.numPlantsWidth
                 saveElement.numPlantsHeight = element.numPlantsHeight
                 plants.push(saveElement);
              } else if (element.type == 'border') {
                 saveElement.type = "border";
                 if (element.childIndex != undefined)
                     saveElement.childIndex = element.childIndex
                 saveElement.tool = element.tool
                 if (element.tool=="rectangle") {
                     saveElement.width = element.width;
                     saveElement.height = element.height;
                 } else if (element.tool=="circle") {
                     saveElement.diameter = element.diameter;
                 } else {
                     saveElement.points = element.asset.points
                 }
                 saveElement.fill = element.fill;
                 saveElement.rotation = element.rotation
                 saveElement.startDate = element.startDate;
                 saveElement.endDate = element.endDate;
                 saveElement.origScale = element.origScale
                 borders.push(saveElement);
              } else if (element.subtype == 'structure') {
                 saveElement.subtype = "structure";
                 saveElement.structure = element.meta
                 saveElement.rotation = element.rotation
                 saveElement.width = element.width;
                 saveElement.height = element.height;
                 saveElement.imgwidth = element.imgwidth;
                 saveElement.imgheight = element.imgheight;
                 saveElement.width = element.width;
                 saveElement.height = element.height;
                 saveElement.width = element.width;
                 saveElement.height = element.height;
                 saveElement.rotation = element.rotation;
                 saveElement.origScale = element.origScale
                 structures.push(saveElement);
              } else if (element.subtype == 'access') {
                 saveElement.subtype = "access";
                 saveElement.origScale = element.origScale
                 saveElement.points = element.points
                 saveElement.thickness = element.thickness
                 saveElement.fill = element.fill
                 access.push(saveElement);
              } else if (element.type == 'area') {
                 saveElement.type = "area";
                 saveElement.area = element.area
                 saveElement.origScale = element.origScale
                 saveElement.points = element.asset.points;
                 areas.push(saveElement);
              }
        }
        F.currDesign.plants = plants;
        F.currDesign.borders = borders;
        F.currDesign.areas = areas;
        F.currDesign.structures = structures;
        F.currDesign.access = access;
        F.currDesign.background = background;
        if (F.currDesign.year === undefined)
            F.currDesign.year = currYear
        onSaveDesign(F.currDesign);

        F.stage.removeChild(cropRotation);
        F.stage.addChild(cropRotation);
    }


  function handleBackgroundFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size)
      })
    )

    setBackgroundFiles(files)
  }

    const generateCounts = () => {
        var counts = {};
        for (var elementKey in frame.currDesign.plants) {
            var element = frame.currDesign.plants[elementKey];
            if (counts[element.species]) {
                counts[element.species] = counts[element.species] + 1;
            } else {
                counts[element.species] = 1;
            }
        }
        return counts;
    }

    async function loadDesign () {
        if (designs.length==0 && !foo.savingdesign) {
            createDesign()
            designs.push(foo.currDesign)
            foo.loadingDesign = false
        }
        var tiles = new Set();

        let tilePromises = [];
        for (var key in foo.currDesign.plants) {
            var element = foo.currDesign.plants[key];
            var plantName = element.species;
            if (!plantName)
                continue
            var plantTile = "planner_" + element.species.toLowerCase().replace(" ","_").replace("(","").replace(")","").replace(",","_").replace(" ","_") + "_icon.png";
            const designerIconKey = element.designerIconKey || (element.plant && element.plant.designerIconKey);
            const iconKey = designerIconKey ? designerIconKey : "planner_icons/" + plantTile;
            const assetId = designerIconKey ? designerIconKey : plantTile;
            const assetURL = await Storage.get(iconKey, { level: 'public' });

            let tilePromise = new Promise((resolve, reject) => {
                frame.loadAssets([{ id: assetId, src: assetURL }]);

                frame.on("complete", () => {
                    console.log(`Asset ${plantTile} loaded successfully.`);
                    resolve(); // Resolve when asset is ready
                });

                frame.on("error", (e) => {
                    console.error(`Error loading asset: ${plantTile}`, e);
                    reject(e);
                });
            });

            tilePromises.push(tilePromise);
        }
        await Promise.all(tilePromises);
        if (foo.plantDataMap && Object.keys(foo.plantDataMap).length > 0) {
            completeLoad();
        } else {
            foo.pendingCompleteLoad = true;
        }
    }

    const completeLoad = () => {
        if (frame.elements) {
            for (var key in frame.elements) {
                var element = frame.elements[key];
                // add editable property
                if (element.editable === undefined) {
                    element.editable = true;
                }

                if (element.type=="border") {
                     frame.borderLayer.removeChild(element.asset);
                } else if (element.type=="area") {
                    frame.areaLayer.removeChild(element.asset);
                } else if (element.type=="structure") {
                    if (element.subtype=="access") {
                        frame.accessLayer.removeChild(element.asset);
                    } else {
                        frame.structureLayer.removeChild(element.asset);
                    }
                } else if (element.type=="plant") {
                    frame.plantLayer.removeChild(element.asset);
                } else {
                     frame.planBox.removeChild(element.asset);
                }
            }
        }

        updateTemplateOptions();

        var plants = foo.currDesign.plants;
        var borders = foo.currDesign.borders;
        var areas = foo.currDesign.areas;
        var background = foo.currDesign.background;
        var structures = foo.currDesign.structures;
        var access = foo.currDesign.access;
        if (areas == undefined)
          areas = []
        if (background == undefined)
          background = {}
        frame.elements = {};
	      var counts = {};



       for (var i=0; i<userareas.length; i++) {
           const area = userareas[i];
           if (!area) continue;

           // Backfill missing info object
           if (!area.info) area.info = {};

           // If you truly want to force all to false:
            area.info.physical = false;
        }

        if (borders.length>0) {
            borders.sort((a, b) => a.childIndex - b.childIndex);
            for (var key in borders) {
                var element = borders[key]
                var borderElement = new GardenElement();
                borderElement.editable = element.editable;
                borderElement.meta = element.tool;
                borderElement.tool = element.tool;
                borderElement.fill = element.fill;
                borderElement.location = element.location;
                borderElement.rotation = element.rotation;
                borderElement.type = "border";
                borderElement.id = element.id;
                borderElement.origScale = 1;
                if (!element.fill)
                    element.fill = "soil"
                if (element.tool=="rectangle") {
                    asset = new zim.Rectangle({width:element.width*gridWidth+5,
                        height:element.height*gridHeight+5,
                        color:"#EEE",
                        borderWidth:5,
                        borderColor:"black"});
                    var fill = "fill_" + element.fill + ".png";
                    asset.colorCommand.bitmap(frame.asset(fill).image)
                    borderElement.width = element.width
                    borderElement.height = element.height
                } else if (element.tool=="circle") {
                    if (!element.diameter)
                        borderElement.diameter = element.width
                    else
                        borderElement.diameter = element.diameter
                    asset = new zim.Circle({
                        radius:borderElement.diameter*gridHeight/2,
                        color:"#EEE",
                        borderWidth:5,
                        borderColor:"black"});
                    var fill = "fill_" + element.fill + ".png";
                    asset.colorCommand.bitmap(frame.asset(fill).image)
                } else if (element.tool=="line") {
                    asset = new zim.Blob({
                        points:element.points,
                        toggle:false
                    });
                    asset.on("click", function (e) {
                        applyTool(e.stageX, e.stageY, "mousedown");
                    })
                    var fill = "fill_" + element.fill + ".png";
                    asset.colorCommand.bitmap(frame.asset(fill).image)
                }
                asset.x = element.location.x;
                asset.y = element.location.y;
                asset.rotation = element.rotation;
                asset.id = element.id;
                borderElement.asset = asset;
                frame.elements[borderElement.id] = borderElement
                frame.borderLayer.addChild(asset);
                borderElement.childIndex = frame.borderLayer.getChildIndex(asset);

            }
        }

        frame.unassignedArea = userareas.find(
            a =>
                a.year === currYear &&
                (a.name || "").toLowerCase() === "unassigned"
        );
        
        for (var key in areas) {
              var element = areas[key]
              var areaElement = new GardenElement();
              areaElement.editable = element.editable;
              areaElement.type="area"
              areaElement.meta = areaElement.type
              areaElement.area = element.area

              var foundArea = false;
               for (var i=0; i<userareas.length; i++) {
                  if (userareas[i].id==element.area) {
                      areaElement.plants = userareas[i].plants
                      if (element.points && element.points.length>0) {
                          userareas[i].info.physical = true
                      }
                      areaElement.name = userareas[i].name
                      foundArea = true
                  }
                   for (var j=0; j<userareas[i].plants.length; j++) {
                       if (userareas[i].plants[j].species) {
                           var areaPlant = userareas[i].plants[j];
                           var assetName = "planner_" + areaPlant.species.toLowerCase().replace(" ", "_").replace("(", "").replace(")", "").replace(",", "_").replace(" ", "_") + "_icon.png"
                           var tileLoader = areaPlant.designerIconKey
                               ? loadTileByKey(areaPlant.designerIconKey)
                               : loadTile("planner_icons", assetName)
                           tileLoader
                               .then(() => {
                                   console.log("{} tile loaded successfully.", assetName);
                               })
                               .catch((error) => {
                                   console.error(assetName + " tile failed to load:", error);
                               });
                       }
                   }
              }
              if (element.points==undefined || !foundArea) {
                continue;
              }

              var asset = new zim.Blob({points:element.points})
              asset.x = element.location.x;
              asset.y = element.location.y;
              areaElement.location = element.location
              areaElement.points = element.points
              if (element.origScale)
                  areaElement.origScale = element.origScale
              else
                  areaElement.origScale = 1
              asset.color = "#F3F3BB";
              asset.alpha = 0.25;
              asset.id = element.id;
              areaElement.id = element.id
              areaElement.asset = asset;
            const points = areaElement.asset.points;

            const upperLeftPoint = points.reduce((acc, point) => {
                return {
                    x: Math.min(acc.x, point[0]),  // First value is x
                    y: Math.min(acc.y, point[1])   // Second value is y
                };
            }, { x: Infinity, y: Infinity });

            const calibratedPoints = points.map(point => {
                // Adjust only the x (point[0]) and y (point[1]) values
                const newPoint = [...point]; // Create a copy of the array to avoid mutation
                newPoint[0] = point[0] - upperLeftPoint.x; // Calibrate x
                newPoint[1] = point[1] - upperLeftPoint.y; // Calibrate y
                return newPoint;
            });
            areaElement.asset.x = areaElement.location.x + upperLeftPoint.x
            areaElement.asset.y = areaElement.location.y + upperLeftPoint.y
            areaElement.location.x = areaElement.asset.x
            areaElement.location.y = areaElement.asset.y
            areaElement.asset.setPoints(calibratedPoints);


              (function (areaElement) {
                  asset.on("change", function (e) {
                      areaElement.points = this.getPoints()
                      for (var key in foo.elements) {
                          var candidateElement = foo.elements[key]
                          if (candidateElement.type=="plant")
                              checkPlantInArea(areas, candidateElement)
                      }
                  });
            })(areaElement)
              frame.elements[element.id] = areaElement
              areaLayer.addChild(asset);

        }
        for (var key in plants) {
            var element = plants[key];
            var asset;
            var plantElement = new GardenElement();
            plantElement.editable = element.editable;
            if (!element.plant.species)
                continue
            if (element.plant.numPlants>1 && (!element.numPlantsWidth || !element.numPlantsHeight))
                continue
            plantElement.type = "plant";
            plantElement.meta = element.species;
            plantElement.id = element.id;
            plantElement.area = element.area;
            plantElement.numPlantsWidth = element.numPlantsWidth
            plantElement.numPlantsHeight = element.numPlantsHeight
            plantElement.plant = element.plant;
            plantElement.rotation = element.rotation;
            plantElement.plant.location = element.plant.location
            var patch = undefined
            if (plantElement.plant.numPlants>1) {
                patch = {
                  width: element.numPlantsWidth,
                  height: element.numPlantsHeight
                }
            }
            var assetName = plantIconAssetId(element.plant);
            generatePlantElement(element.location.x,element.location.y, plantElement, plantElement.id, element.plant.size, patch, assetName);
            foo.elements[plantElement.id] = plantElement;
            for (var i=0; i<userareas.length; i++) {
                  if (userareas[i].id==element.area) {
                      for (var j=0; j<userareas[i].plants.length; j++) {
                          if (userareas[i].plants[j].id == element.id) {
                              plantElement.plant =  userareas[i].plants[j]
                          }
                      }
                  }
              }
        }

        for (var key in structures) {
            var element = structures[key];
            var asset;
            var structureElement = new GardenElement();
            structureElement.editable = element.editable;
            structureElement.type = "structure";
            structureElement.subtype = "structure";
            structureElement.meta = element.structure;
            structureElement.id = element.id;
            structureElement.imgwidth = element.imgwidth;
            structureElement.rotation = element.rotation;
            structureElement.imgheight = element.imgheight;
            structureElement.width = element.width;
            structureElement.height = element.height;
            structureElement.rotation = element.rotation;
            generateStructureElement (element.location.x, element.location.y, structureElement)
            frame.elements[structureElement.id] = structureElement
        }
        for (var key in access) {
            var element = access[key];
            var asset;
            var accessElement = new GardenElement();
            accessElement.editable = element.editable;
            accessElement.type = "structure";
            accessElement.subtype = "access";
            accessElement.meta = element.meta;
            accessElement.id = element.id;
            accessElement.thickness = element.thickness;
            accessElement.fill = element.fill;
            accessElement.origScale = element.origScale
            accessElement.points = element.points
            accessElement.location =  element.location
            var asset = generateAccessElement (element.points, accessElement)
            asset.hideControls()
            accessElement.asset = asset
            frame.elements[accessElement.id] = accessElement
        }
        frame.unassignedArea = userareas.find(
            a =>
                a.year === currYear &&
                (a.name || "").toLowerCase() === "unassigned"
        );

        frame.stage.removeChild(cropRotation);
        frame.stage.addChild(cropRotation);
        frame.selectedElement = null;
        centerOnDesign();
        if (background?.type === "tile") {
            setGardenBackground(
                background.fill,
                background.alpha
            );
        }
        setBackgroundType(background?.fill)
        scale(0.5)

        frame.planBox.setChildIndex(frame.grid, 1)
        frame.planBox.setChildIndex(areaLayer, 2)
        frame.planBox.setChildIndex(borderLayer, 3);
        frame.planBox.setChildIndex(accessLayer, 4);
        frame.planBox.setChildIndex(structureLayer, 5);
        frame.planBox.setChildIndex(plantLayer, 6)
        frame.planBox.setChildIndex(selectionLayer, 7)
        frame.stage.update();

        updateLayer('plant');

        scale(0.5)
        frame.loadingDesign = false
    }

    const centerOnArea = (areaElement) => {
        if (!areaElement?.points || !areaElement.location) return;

        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;

        for (const p of areaElement.points) {
            const x = p[0];
            const y = p[1];
            minX = Math.min(minX, x);
            minY = Math.min(minY, y);
            maxX = Math.max(maxX, x);
            maxY = Math.max(maxY, y);
        }

        // Local center of polygon
        const localCenterX = (minX + maxX) / 2;
        const localCenterY = (minY + maxY) / 2;

        const areaScale = areaElement.origScale ?? 1;

        // World-space center
        const worldCenterX =
            areaElement.location.x + localCenterX * areaScale;
        const worldCenterY =
            areaElement.location.y + localCenterY * areaScale;

        // 🔑 Convert world → screen via zoomScale
        const zoom = foo.zoomScale || 1;

        foo.planWindow.scrollX = -Math.round(worldCenterX / zoom);
        foo.planWindow.scrollY = -Math.round(worldCenterY / zoom);

        foo.stage?.update?.();
    };


    const centerOnDesign = () => {
        let minX = Infinity,
            minY = Infinity,
            maxX = -Infinity,
            maxY = -Infinity;

        for (var key in foo.elements) {
            var child = foo.elements[key].asset;

            minX = Math.min(minX, child.x);
            minY = Math.min(minY, child.y);
            maxX = Math.max(maxX, child.x + child.width);
            maxY = Math.max(maxY, child.y + child.height);
        }

        foo.planWindow.scrollX = -Math.round((maxX - minX) / 2);
        foo.planWindow.scrollY = -Math.round((maxY - minY) / 2);
    }

    const generatePdf = () => {
        // Clone the planBox
        const pdfBox = foo.planBox.clone();

        for (var key in foo.elements) {
            pdfBox.removeChild(foo.elements[key])
        }
        // Determine the bounding box of the children
        let minX = Infinity,
            minY = Infinity,
            maxX = -Infinity,
            maxY = -Infinity;

        const tempTexts = [];
        var plantIndex = 1;
        var plantsData = [];
        var plantObj = {};
        var plantNames = {};
        var circleRadius = 10;
        var labelModifierX = 5;

        // Collect plant data
        for (var key in foo.elements) {
            if (foo.elements[key].type == "plant") {
                if (plantObj[foo.elements[key].plant.species]) {
                    plantObj[foo.elements[key].plant.species] += parseInt(foo.elements[key].plant.numPlants);
                } else {
                    plantObj[foo.elements[key].plant.species] = parseInt(foo.elements[key].plant.numPlants);
                    plantNames[foo.elements[key].plant.species] = plantIndex;
                    plantIndex++;
                }
            }
        }

        // **Step 2: Process All Other Elements (Except Plants)**
        for (var key in foo.elements) {
            var child = foo.elements[key].asset;

            minX = Math.min(minX, child.x);
            minY = Math.min(minY, child.y);
            maxX = Math.max(maxX, child.x + child.width);
            maxY = Math.max(maxY, child.y + child.height);

            if (foo.elements[key].type !== "plant") {
                pdfBox.addChild(child);
            }
        }

        for (var key in foo.elements) {
            if (foo.elements[key].type == "plant") {
                var child = foo.elements[key].asset;
                pdfBox.addChild(child)
                plantIndex = plantNames[foo.elements[key].plant.species];

                var plantData = {
                    id: plantIndex,
                    name: foo.elements[key].plant.species,
                    count: plantObj[foo.elements[key].plant.species]
                };

                plantsData.push(plantData);
                if (plantIndex > 9) {
                    circleRadius = 12;
                    labelModifierX = 8;
                }

                // Create a circle with a label for plant index
                const tempCircle = new zim.Circle({
                    radius: circleRadius,
                    color: "black",
                });

                tempCircle.x = labelModifierX;
                tempCircle.y = 10;

                const tempLabel = new zim.Label({
                    text: plantIndex,
                    size: 18,
                    color: "white",
                    font: font
                });

                // Group the circle and label together
                const group = new zim.Container();
                group.addChild(tempCircle);
                group.addChild(tempLabel);

                // Position the group over the plant
                group.x = child.x + child.width / 2;
                group.y = child.y + child.height / 2;

                // Add to the cloned planBox
                pdfBox.addChild(group);

                // Store for later removal
                tempTexts.push(group);
            }
        }

        // Calculate the bounding box dimensions
        const boundingWidth = maxX - minX + 250;
        const boundingHeight = maxY - minY + 200;

        // Create an off-screen canvas
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // Set the canvas dimensions
        canvas.width = boundingWidth;
        canvas.height = boundingHeight;

        // Delay drawing to allow fills to update
        setTimeout(() => {
            pdfBox.draw(ctx);

            tempTexts.forEach((tempText) => pdfBox.removeChild(tempText));

            // Create a new instance of jsPDF
            const doc = new jsPDF("l", "pt", "letter");

            // Title
            const title = "SAGE Design";
            doc.setFontSize(24);
            doc.setFont("helvetica", "bold");
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            doc.text(title, pageWidth / 2, 40, { align: "center" });

            // Canvas Scaling
            const maxCanvasWidth = pageWidth * 0.9;
            const maxCanvasHeight = pageHeight * 0.6;
            const canvasScale = Math.min(
                maxCanvasWidth / canvas.width,
                maxCanvasHeight / canvas.height
            );
            const scaledWidth = canvas.width * canvasScale;
            const scaledHeight = canvas.height * canvasScale;
            const canvasX = (pageWidth - scaledWidth) / 2;
            const canvasY = 60;

            const imgData = canvas.toDataURL("image/png");
            doc.addImage(imgData, "PNG", canvasX, canvasY, scaledWidth, scaledHeight);

            // Add Plant Key Background
            const keyTop = pageHeight * 0.8;
            const keyLeft = pageWidth * 0.05;
            const keyWidth = pageWidth * 0.9;
            const keyHeight = pageHeight * 0.25;

            doc.setFillColor(240);
            doc.rect(keyLeft, keyTop - 20, keyWidth, keyHeight, "F");

            // Add Plant Key Title
            doc.setFontSize(16);
            doc.setFont("helvetica", "bold");
            doc.text("Plant Key", keyLeft + 10, keyTop);

            // Table layout
            const tableTop = keyTop + 20;
            const tableLeft = keyLeft + 10;
            const tableWidth = keyWidth - 20;
            const columnWidth = tableWidth / 4;
            const rowHeight = 20;
            let currentX = tableLeft;
            let currentY = tableTop;

            doc.setFontSize(12);
            doc.setFont("helvetica", "normal");

            plantsData = plantsData.filter((o, index, arr) =>
                arr.findIndex(item => JSON.stringify(item) === JSON.stringify(o)) === index
            );

            plantsData.forEach((plant) => {
                if (plant.id > 9) {
                    doc.setFontSize(8);
                    doc.text(`${plant.id}`, currentX + 5, currentY - 2);
                } else {
                    doc.setFontSize(12);
                    doc.text(`${plant.id}`, currentX + 8, currentY - 2);
                }
                doc.circle(currentX + 10, currentY - 5, 8, "S");
                doc.setFontSize(12);
                doc.text(
                    `${plant.name} (${plant.count})`,
                    currentX + 30,
                    currentY
                );

                currentY += rowHeight;

                if (currentY > keyTop + keyHeight - 20) {
                    currentX += columnWidth;
                    currentY = tableTop;
                }
            });

            doc.save("SAGE_Design.pdf");
            toggleLayerVisibility('structure', true)
            toggleLayerVisibility('path', true)
            toggleLayerVisibility('border', true)
            toggleLayerVisibility('plant', true)
        }, 100);
    };


    function getFactors(num) {
        const factors = [];
        for (let i = 1; i <= Math.sqrt(num); i++) {
            if (num % i === 0) {
                factors.push(i);
                if (i !== num / i) {
                    factors.push(num / i);
                }
            }
        }
        return factors.sort((a, b) => a - b);
    }

  function getAbsolutePoints(points, zoomScale) {
    return points.map(point => {
        // Ensure that the point has at least the first two values (x, y) and fill in the rest if missing
        let [
            controlX = 0,       // x value of the control container
            controlY = 0,       // y value of the control container
            circleX = 0,        // x value of the circle within the container
            circleY = 0,        // y value of the circle within the container
            rect1X = 0,         // x value of the first rectangle handle
            rect1Y = 0,         // y value of the first rectangle handle
            rect2X = 0,         // x value of the second rectangle handle
            rect2Y = 0,         // y value of the second rectangle handle
        ] = point;

        // Scale each coordinate by dividing by the zoomScale, leaving controlType unchanged
        return [
            controlX / zoomScale,
            controlY / zoomScale,
            circleX,
            circleY,
            rect1X,
            rect1Y,
            rect2X,
            rect2Y
        ];
    });
}

    const PropertyRow = ({ label, children }) => (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "8px",
            }}
        >
            <div style={{ color: "#4a544d" }}>{label}</div>
            <div>{children}</div>
        </div>
    );

    const PropertyCheckbox = ({ label, checked, onChange }) => (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "8px",
            }}
        >
            <div style={{ color: "#4a544d" }}>{label}</div>
            <input
                type="checkbox"
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
            />
        </div>
    );


    function restoreBorderZOrder() {
        const borders = [];

        for (const key in foo.elements) {
            const el = foo.elements[key];
            if (el.type === "border" && el.asset) {
                borders.push(el);
            }
        }

        // Sort by stored childIndex
        borders.sort((a, b) => a.childIndex - b.childIndex);

        // Re-apply ordering in the container
        borders.forEach((el, idx) => {
            foo.borderLayer.setChildIndex(el.asset, idx);
        });
    }

    function exitStructurePlacement() {
        foo.selectedStructure = null;
        foo.currStructure = null;
        setShowSelectedStructure(false);
        setMode("select");
    }

    const applyTool = async (x, y, event) => {
        if (!currDesign && !warning) {
            warning = true;
            var label = new zim.Label("Please load or start a new template to start editing", 16, font, "black");
            var warningPane = new zim.Pane({
                width: 300,
                height: 200,
                label: label,
                backgroundColor: "white",
                draggable: false,
                close: true
            });
            warningPane.on("close", function () {
                warning = false;
            });
            warningPane.show();
            return;
        }

        // Pan (hand) tool — click-drag anywhere to scroll the map. Uses the live
        // stage pointer so it works regardless of where the press started.
        if (frame.tool === "pan") {
            if (event === "mousedown") {
                frame.panStart = {
                    scrollX: frame.planWindow.scrollX,
                    scrollY: frame.planWindow.scrollY,
                    mx: frame.stage.mouseX,
                    my: frame.stage.mouseY,
                };
                try { frame.stage.canvas.style.cursor = "grabbing"; } catch (e) { /* ignore */ }
            } else if (event === "mousemove" && frame.panStart) {
                const dx = frame.stage.mouseX - frame.panStart.mx;
                const dy = frame.stage.mouseY - frame.panStart.my;
                frame.planWindow.scrollX = frame.panStart.scrollX + dx;
                frame.planWindow.scrollY = frame.panStart.scrollY + dy;
                try { frame.stage.canvas.style.cursor = "grabbing"; } catch (e) { /* ignore */ }
                frame.stage.update();
            } else if (event === "mouseup") {
                frame.panStart = null;
                try { frame.stage.canvas.style.cursor = "grab"; } catch (e) { /* ignore */ }
            }
            return;
        }

        if (event === "mousedown" && frame.tool === "select") {
            // If you clicked on an element, let normal single-select/drag logic run
            if (frame.pointerOnElement)
                return
            // Start marquee
            frame.marqueeStarted = true;

            // Use planBox local coords to avoid scroll/zoom confusion
            const p = frame.planBox.globalToLocal(frame.stage.mouseX, frame.stage.mouseY);
            frame.marqueeStart = { x: p.x, y: p.y };

            frame.marquee = makeDashedRectShape();
            frame.selectionLayer.addChild(frame.marquee);

            // initial tiny rect
            drawDashedRect(frame.marquee, frame.marqueeStart.x, frame.marqueeStart.y, 1, 1);

            frame.stage.update();

            return;
        } else if (event === "mousemove" && frame.tool === "select") {
            if (frame.tool === "select" && frame.marqueeStarted && frame.marquee && frame.marqueeStart) {
                const p = frame.planBox.globalToLocal(frame.stage.mouseX, frame.stage.mouseY);

                const x1 = frame.marqueeStart.x;
                const y1 = frame.marqueeStart.y;
                const x2 = p.x;
                const y2 = p.y;

                const left = Math.min(x1, x2);
                const top = Math.min(y1, y2);
                const w = Math.abs(x2 - x1);
                const h = Math.abs(y2 - y1);

                drawDashedRect(frame.marquee, left, top, w, h);
                frame.stage.update();
                return;
            }
        } else if (event === "mouseup" && frame.tool === "select") {
            if (frame.marqueeStarted && frame.marquee && frame.marqueeStart) {
                frame.pointerOnElement = false;
                const p = frame.planBox.globalToLocal(frame.stage.mouseX, frame.stage.mouseY);
                const x1 = frame.marqueeStart.x;
                const y1 = frame.marqueeStart.y;
                const x2 = p.x;
                const y2 = p.y;

                const selLeft = Math.min(x1, x2);
                const selTop = Math.min(y1, y2);
                const selRight = Math.max(x1, x2);
                const selBottom = Math.max(y1, y2);

                // Small drags should behave like "click empty" = clear selection
                const minSize = 8;
                const w = selRight - selLeft;
                const h = selBottom - selTop;

                // Clean up marquee visuals
                frame.selectionLayer.removeChild(frame.marquee);
                frame.marquee = null;
                frame.marqueeStarted = false;
                frame.marqueeStart = null;

                if (w < minSize && h < minSize) {
                    // click empty clears selection
                    hideSelectedPathControls();
                    clearOldSelections();
                    frame.stage.update();
                    return;
                }

                // Clear previous selection (optional)
                clearOldSelections();

                const newlySelected = [];

                for (const id in foo.elements) {
                    const el = foo.elements[id];
                    if (layerOf(el) !== frame.currLayer) continue;

                    const left = el.asset.x;
                    const right = el.asset.x + 100;
                    const top = el.asset.y;
                    const bottom = el.asset.y + 100;

                    const intersects =
                        right >= selLeft &&
                        left <= selRight &&
                        bottom >= selTop &&
                        top <= selBottom;

                    if (intersects) {
                        el.selected = true;
                        frame.selectedElements.add(el.id);
                        ensureHighlight(el); // make sure it draws a box for plants/borders/paths
                        newlySelected.push(el);
                    }
                }

                // Optional: set selElement to multi
                frame.selElement = { type: "multi", ids: newlySelected.map(e => e.id), count: newlySelected.length };
                if (typeof hotItem !== "undefined") hotItem = null;
                syncSelElementState();

                syncSelectionCount()
                frame.stage.update();
                return;
            }
        }

        // existing logic
        if (frame.mode == "plant" && event == "mousedown") {
            var plantElement = new GardenElement();
            if (frame.currPlant) {
                plantElement.type = "plant";
                plantElement.meta = frame.tool;
                plantElement.plant = {...frame.currPlant}
                plantElement.plant.location = true
                plantElement.numPlantsWidth = plantElement.plant.numPlantsWidth
                plantElement.numPlantsHeight = plantElement.plant.numPlantsHeight
                plantElement.variety = ''
                var patch = undefined
                if (plantElement.plant.numPlants>1) {
                    patch = {
                      width: plantElement.plant.numPlantsWidth,
                      height: plantElement.plant.numPlantsHeight
                    }
                }

                var numPerSquareFoot = Math.pow(12/plantElement.plant["spacing_between_plants"],2);
                var spaceNeeded = (plantElement.plant.numPlants/numPerSquareFoot).toFixed(2);
                plantElement.plant["spaceUsed"] = spaceNeeded
                plantElement.plant["totalHarvest"] = 0
                if (plantElement.plant["yield_per_plant_ounces"])
                    plantElement.plant["estHarvest"] = plantElement.plant["yield_per_plant_ounces"] * plantElement.plant.numPlants/16.0;
                else
                    plantElement["estHarvest"] = 0
                // All values kept in imperial; metric display conversion happens on the fly
                var assetName = plantIconAssetId(plantElement.plant);
                generatePlantElement(x,y, plantElement,generatePlantName(plantElement.meta), frame.currPlant.size, patch, assetName);
                if (frame.zoomScale != 1) {
                    if (plantElement.plant.numPlants>1) {
                        var patchPlants = plantElement.asset.children
                        for (var i=0; i<patchPlants.length; i++) {
                            var patchPlant = patchPlants[i]
                            patchPlant.scaleX = frame.zoomScale * plantElement.scale;
                            patchPlant.scaleY = frame.zoomScale * plantElement.scale;
                        }
                    } else {
                        plantElement.asset.scaleX = frame.zoomScale * plantElement.scale;
                        plantElement.asset.scaleY = frame.zoomScale * plantElement.scale;
                        plantElement.asset.x = x - plantElement.asset.width / 2
                        plantElement.asset.y = y - plantElement.asset.height / 2
                        plantElement.location.x = plantElement.asset.x/foo.zoomScale;
                        plantElement.location.y = plantElement.asset.y/foo.zoomScale;
                    }
                }
                generatePlantDates(plantElement);
                var areas = []
                var areas = []

                  for (var key in frame.elements) {
                        var celement = frame.elements[key]
                        if (celement.type =="area" && celement.asset) {
                            areas.push(celement)
                        }
                    }

                checkPlantInArea(areas, plantElement)
	              frame.elements[plantElement.id] = plantElement
                saveDesign();

                frame.stage.update()
            } else if (frame.existingPlant) {
                frame.existingPlant.name = frame.existingPlant.species
                var assetName = plantIconAssetId(frame.existingPlant);
                var epLoader = frame.existingPlant.designerIconKey
                    ? loadTileByKey(frame.existingPlant.designerIconKey)
                    : loadTile("planner_icons", assetName)
                epLoader
                    .then(() => {
                        console.log("{} tile loaded successfully.", assetName);
                    })
                    .catch((error) => {
                        console.error(assetName + " tile failed to load:", error);
                    });
                plantElement.type = "plant";
                plantElement.name = generatePlantName(frame.existingPlant.species);
                plantElement.id = plantElement.name
                plantElement.plant = frame.existingPlant
                plantElement.species = frame.existingPlant.species
                plantElement.variety = ''
                if (plantElement.plant.numPlants>1) {
                    var numPerSquareFoot = Math.pow(12/parseInt(plantElement.plant.numPlants),2);
                    plantElement.spaceUsed = (plantElement.plant.numPlants/numPerSquareFoot).toFixed(2);
                    var factors = getFactors(plantElement.plant.numPlants)
                    var bigfactor = factors[factors.length-1]
                    if (factors.length>2) {
                        bigfactor = factors[factors.length-2]
                    }
                    var newWidth = bigfactor
                    var newHeight = plantElement.plant.numPlants/bigfactor
                    plantElement.numPlantsWidth = newWidth
                    plantElement.numPlantsHeight = newHeight
                    patch = {
                        width: plantElement.numPlantsWidth,
                        height: plantElement.numPlantsHeight
                    }
                }
                generatePlantElement(x,y, plantElement,plantElement.plant.id, frame.existingPlant.size, patch, assetName);
                if (frame.zoomScale != 1) {
                    if (plantElement.plant.numPlants>1) {
                        var patchPlants = plantElement.asset.children
                        for (var i=0; i<patchPlants.length; i++) {
                            var patchPlant = patchPlants[i]
                            patchPlant.scaleX = frame.zoomScale * plantElement.scale;
                            patchPlant.scaleY = frame.zoomScale * plantElement.scale;
                        }
                    } else {
                        plantElement.asset.scaleX = frame.zoomScale * plantElement.scale;
                        plantElement.asset.scaleY = frame.zoomScale * plantElement.scale;
                        plantElement.asset.x = x - plantElement.asset.width / 2
                        plantElement.asset.y = y - plantElement.asset.height / 2
                        plantElement.location.x = plantElement.asset.x/foo.zoomScale;
                        plantElement.location.y = plantElement.asset.y/foo.zoomScale;
                    }
                }
                var areas = []

                  for (var key in frame.elements) {
                        var celement = frame.elements[key]
                        if (celement.type =="area" && celement.asset) {
                            areas.push(celement)
                        }
                    }
                checkPlantInArea(areas, plantElement)
                frame.elements[plantElement.id] = plantElement
                saveDesign();
                frame.existingPlant = undefined
                // Clear the React placement state too — this forces the area panel to
                // re-render now (reading the just-set location), instead of waiting for
                // the async area-update round-trip, so the plant moves to "Placed" immediately.
                setExistingPlant(undefined)

                frame.stage.update()

            }
        } else if (frame.mode == "structure" && tool !="select" && event == "mousedown") {
            var structure = new GardenElement();
            if (frame.currStructure) {
                structure.type = "structure";
                structure.subtype = "structure";
                structure.meta = frame.currStructure.name;
                var structureAsset = frame.asset("planner_"+structure.meta.toLowerCase().replace(" ","_").replace("(","").replace(")","").replace(",","_").replace(" ","_")+"_icon.png").clone();
                structureAsset.x = x;
                structureAsset.y = y;
                structure.imgwidth = structureAsset.width;
                structure.imgheight = structureAsset.height;

                structureAsset.scaleX = frame.zoomScale*frame.currStructure.width* 75/structure.imgwidth
                structureAsset.scaleY = frame.zoomScale*frame.currStructure.height * 75/structure.imgheight;
                structureAsset.rotation = frame.currStructure.rotation;

                structure.width = frame.currStructure.width
                structure.height = frame.currStructure.height;
                structure.rotation = frame.currStructure.rotation;

                structure.scaleX = structureAsset.scaleX
                structure.scaleY = structureAsset.scaleY;
                structure.origScale = frame.zoomScale;
                structure.id = uuidv4();

                frame.elements[structure.id] = structure
                if (structureAsset.x<0) {
                    structureAsset.x = 0;
                }
                if (structureAsset.y<0) {
                    structureAsset.y = 0;
                }

                structure.asset = structureAsset;
                structure.location = {x:x, y:y};
                frame.structureLayer.addChild(structureAsset);

                saveDesign();
                frame.stage.update()
            }
        } else if (frame.mode == "access" && tool !="success" && event == "mousedown") {
              if (frame.accessFill==undefined) {
                        frame.accessFill="gravel";
                     }
                     var accessElement = new GardenElement();
                     accessElement.meta = tool;
                     accessElement.location = {x:x, y:y};
                     accessElement.type = "structure";
                     accessElement.subtype = "access";
                     accessElement.thickness = 1;
                     accessElement.fill = frame.accessFill;
                     accessElement.id = uuidv4();
                     frame.elements[accessElement.id] = accessElement
                     var fill = "fill_" + frame.accessFill + ".png";
                     var points = [
                            [x,y],
                            [x+40,y],
                            [x+80,y],
                            [x+120,y],
                            [x+160,y],
                            [x+200,y]
                        ]
                     var newAccess = new zim.Squiggle({
                        points: points
                     });

                     accessElement.points = getAbsolutePoints(points, frame.zoomScale)
                     newAccess.on("change", function (e) {
                          accessElement.points = getAbsolutePoints(this.points, frame.zoomScale)
                          saveDesign()
                     })
                     newAccess.colorCommand.bitmap(frame.asset(fill).image)
                     newAccess.thickness =  frame.zoomScale*accessElement.thickness*gridWidth;
                     accessElement.asset = newAccess;
                     newAccess.setBounds(100,100);
                     frame.currAccess = accessElement
                     frame.accessLayer.addChild(newAccess);
                     saveDesign()
                     frame.stage.update();

        } else if (frame.mode == "area" && (frame.tool =="add" || frame.tool=="link") && event == "mousedown") {
            startX = Math.round(x);
            startY = Math.round(y);
            frame.newArea = new zim.Blob({points:new zim.Rectangle(200,200)})
            frame.newArea.x = startX;
            frame.newArea.y = startY;
            frame.newArea.color = "#F3F3BB";
            areaLayer.addChild(frame.newArea);
            frame.stage.update();

            var areaElement = new GardenElement();
            areaElement.location = {x: frame.newArea.x, y: frame.newArea.y};
            areaElement.meta = tool;
            areaElement.type = "area";
            areaElement.asset = frame.newArea
            areaElement.name = frame.currArea.name;
            areaElement.area = frame.currArea.id
            areaElement.plants = frame.currArea.plants
            areaElement.origScale = frame.zoomScale;
            if (frame.tool=="add")
                frame.currArea.year = 2025;
            // Fold the Blob's internal upper-left offset into the shape's position and
            // normalize the points to a (0,0) origin — the SAME calibration the load
            // path applies (see loadDesign). Doing it here too means the first save
            // already matches what reloads, so the very first placement isn't offset.
            {
                const _pts = frame.newArea.points;
                const _ul = _pts.reduce(
                    (acc, p) => ({ x: Math.min(acc.x, p[0]), y: Math.min(acc.y, p[1]) }),
                    { x: Infinity, y: Infinity }
                );
                const _calibrated = _pts.map(p => { const np = [...p]; np[0] = p[0] - _ul.x; np[1] = p[1] - _ul.y; return np; });
                frame.newArea.x = areaElement.location.x + _ul.x;
                frame.newArea.y = areaElement.location.y + _ul.y;
                areaElement.location.x = frame.newArea.x;
                areaElement.location.y = frame.newArea.y;
                frame.newArea.setPoints(_calibrated);
            }
            areaElement.points = frame.newArea.getPoints()
            frame.currArea.info.physical = true;
            areaElement.id = frame.currArea.id
            areaElement.area = frame.currArea.id
            var areas = [areaElement]
            for (var key in frame.elements) {
                var candidateElement = frame.elements[key]
                if (candidateElement.type=="plant")
                    checkPlantInArea(areas, candidateElement)
            }
            frame.elements[areaElement.id] = areaElement;
            areaElement.asset.on("change", function (e) {
                areaElement.points = areaElement.asset.getPoints()
                for (var key in frame.elements) {
                    var candidateElement = frame.elements[key]
                    if (candidateElement.type=="plant")
                        checkPlantInArea(areas, candidateElement)
                }
            })
            frame.newArea = undefined;
            enableTool("selectTool");
            setTool("select")
            saveDesign()
            onUpdateArea(frame.currArea)
	} else if (frame.mode == "border") {
            // Clicked on an existing border → let the element's mousedown handler
            // select it instead of starting a new shape.
            if (frame.pointerOnElement)
                return;
            let borderShapeStarted;
            var fill = "fill_" + frame.borderFill + ".png";
            if (event == "mousedown") {
                if (borderShapeStarted)
                    return;
                startX = Math.round(x);
                startY = Math.round(y);
                if (frame.tool == "rectangle") {
                    borderShapeStarted = true;
                    frame.newBorder = new zim.Rectangle({
                        width: 15,
                        height: 15,
                        color: "#EEE",
                        borderWidth: 5,
                        borderColor: "black"
                    });
                    frame.newBorder.x = startX;
                    frame.newBorder.y = startY;
                    borderLayer.addChild(frame.newBorder);
                } else if (frame.tool == "circle") {
                    borderShapeStarted = true;
                    frame.newBorder = new zim.Circle({
                        radius: 20,
                        color: "#EEE",
                        borderWidth: 5,
                        borderColor: "black"
                    });
                    frame.newBorder.x = startX;
                    frame.newBorder.y = startY;
                    borderLayer.addChild(frame.newBorder);
                } else if (frame.tool == "line") {
                    frame.newBorder = new zim.Blob({points:new zim.Rectangle(200,200),toggle:false});
                        frame.newBorder.x = startX;
                        frame.newBorder.y = startY;
                        frame.newBorder.id = uuidv4();
                        borderLayer.addChild(frame.newBorder);
                        var borderElement = new GardenElement();
                        borderElement.id = frame.newBorder.id;
                        borderElement.meta = tool;
                        borderElement.type = "border";
                        borderElement.tool = "line";
                        borderElement.asset = frame.newBorder;
                        borderElement.asset.setBounds(100, 100);
                        frame.elements[borderElement.id] = borderElement;
                        borderElement.location = {x: frame.newBorder.x, y: frame.newBorder.y};
                        borderElement.asset.colorCommand.bitmap(frame.asset(fill).image)
                        borderElement.fill = frame.borderFill;
                       frame.newBorder = undefined;
                      borderShapeStarted = false;
                      borderElement.origScale = frame.zoomScale;
                      saveDesign()
                      // Stay in Add Border (draw) mode so shapes are repeatable;
                      // attach handlers so the new border is selectable later.
                      setMode("border", frame.borderShape || "rectangle")
                      enterSelectionMode()
                      frame.stage.update();

                }

                frame.stage.update();
            } else if (event == "mousemove") {
                var width = Math.round(x) - startX - foo.planWindow.scrollX;
                var height = Math.round(y) - startY - foo.planWindow.scrollY;
                if (frame.tool == "rectangle") {
                    borderLayer.removeChild(frame.newBorder);
                    if (width<20)
                        width = 20
                    if (height<20)
                        height = 20
                    frame.newBorder = new zim.Rectangle({
                        width: width + 5,
                        height: height + 5,
                        color: "#EEE",
                        borderWidth: 5,
                        borderColor: "black"
                    });
                    frame.newBorder.x = startX;
                    frame.newBorder.y = startY;
                    borderLayer.addChild(frame.newBorder);
                } else if (frame.tool == "circle") {
                    borderLayer.removeChild(frame.newBorder);
                    if (width<20)
                        width = 20
                    frame.newBorder = new zim.Circle({
                        radius: width / 2,
                        color: "#EEE",
                        borderWidth: 5,
                        borderColor: "black"
                    });
                    frame.newBorder.x = startX;
                    frame.newBorder.y = startY;
                    borderLayer.addChild(frame.newBorder);
		}
            } else if (event == "mouseup") {
                if (!frame.newBorder)
                    return;
                if (frame.tool == "line")
                    return;
                var borderElement = new GardenElement();
                borderElement.location = {x: frame.newBorder.x, y: frame.newBorder.y};
                borderElement.tool = frame.tool
                frame.newBorder.id =  uuidv4();
                borderElement.id = frame.newBorder.id;
                borderElement.meta = tool;
                borderElement.type = "border"
                borderElement.asset = frame.newBorder;
                hotItem = frame.newBorder;

                if (frame.tool == "rectangle" || frame.tool == "circle") {
                    if (frame.newBorder.width < 21 && frame.newBorder.height < 21) {
                        borderLayer.removeChild(frame.newBorder);
                        return;
                    }
                }
                if (frame.tool == "rectangle") {
                    borderElement.width = frame.newBorder.width/(frame.zoomScale*gridWidth);
                    borderElement.height = frame.newBorder.height/(frame.zoomScale*gridHeight);
                }
                if (frame.tool == "circle") {
                    borderElement.diameter = frame.newBorder.width/(frame.zoomScale*gridWidth);
                }
                if (frame.tool == "rectangle" || frame.tool == "circle") {
                    borderElement.asset = frame.newBorder;
                    borderElement.origScale = frame.zoomScale;
                    var fill = "fill_" + frame.borderFill + ".png";
                    borderElement.asset.colorCommand.bitmap(frame.asset(fill).image)
                    borderElement.fill = frame.borderFill;
                }
                foo.elements[borderElement.id] = borderElement;
                frame.newBorder = undefined;
                borderShapeStarted = false;
                // Stay in Add Border (draw) mode so shapes are repeatable;
                // attach handlers so the new border is selectable later.
                setMode("border", frame.borderShape || "rectangle")
                enterSelectionMode()
                frame.stage.update();
                saveDesign()
            }
        }
    }

    function deleteArea(areaID) {
        for (var i=0; i<userareas.length; i++) {
            if (userareas[i].id == areaID) {
                foo.currArea = userareas[i]
                break;
            }
        }
        if (foo.currArea) {
            setDeleteAreaModal(true)
        }
    }

    function cancelDeleteArea() {
        setDeleteAreaModal(false)
        setDeleteAllPlants(false)
    }

    function finalDeleteArea() {
        var plantsInArea = []
        for (var key in foo.elements) {
            var candidateElement = foo.elements[key]
            if (candidateElement.type=="plant" && candidateElement.area == foo.currArea.id) {
                plantsInArea.push(candidateElement)
            }
        }

        var saveUnassigned = false
        if (deleteAllPlants) {
            // remove all plant Icons in Designer as well as remove area
            for (const element of plantsInArea) {
                foo.plantLayer.removeChild(foo.elements[element.id].asset)
                delete foo.elements[element.id]
            }
        } else {
            // move all plants in this area to unassigned
            for (var i=0; i<plantsInArea.length; i++) {
                var plantElement = plantsInArea[i]
                plantElement.area = foo.unassignedArea.id
            }
            for (var i=0; i<foo.currArea.plants.length; i++) {
                var plantElement = foo.currArea.plants[i]
                if (plantElement.location)
                    continue
                foo.unassignedArea.plants.push(plantElement)
                saveUnassigned = true
            }
        }
        foo.areaLayer.removeChild(foo.elements[foo.currArea.id].asset)
        delete foo.elements[foo.currArea.id]
        foo.stage.update()
        saveDesign()
        setDeleteAreaModal(false)
        setDeleteAllPlants(false)
        onDeleteArea(foo.currArea.id)
        if (saveUnassigned) {
            onUpdateArea(foo.unassignedArea)
        }
    }

    const generatePlantName = (plantName) => {
        var count = 1;

        let elementKey;
        for (elementKey in frame.elements) {
            if (elementKey.startsWith(plantName)) {
                count++;
            }
        }
        return plantName + "_" + count;
    }

    const toggleLayerVisibility = (layer, toggle) => {
        if (!frame)
            frame = foo
        const container = layerContainer(layer)
        for (var elementKey in frame.elements) {
            var element = frame.elements[elementKey];
            if (layerOf(element)==layer && container) {
                if (!toggle) {
                    container.removeChild(element.asset)
                } else {
                    container.addChild(element.asset)
                }
            }
        }
        frame.stage.update()
        var newVis = { ...visibility }
        newVis[layer] = toggle
        setVisibility(newVis)
    }

    function inside(point, vs) {
        var x = point[0], y = point[1];

        var inside = false;
        for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
            var xi = vs[i][0], yi = vs[i][1];
            var xj = vs[j][0], yj = vs[j][1];

            var intersect = ((yi > y) != (yj > y))
                && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;
        }

        return inside;
    };

    const clearLogicalSelection = () => {
        setShowSelectedPlant(false);
        setShowSelectedStructure(false);

        if (!frame && foo) frame = foo;
        if (!frame) return;

        frame.selectedElement = null;
        setSelElement();
        setSelectionCount(0);

        // Important: DO NOT touch selectedElements or highlights here
    };


    const enterSelectionMode = () => {
        // iterate through the elements and enable drag on all of them
        clearLogicalSelection()
        for (var elementKey in frame.elements) {
            var element = frame.elements[elementKey];
	          if (!element.asset)
                continue
            if (layerOf(element)!=frame.currLayer) {
                element.asset.off("mousedown", element.pressdown)
                element.asset.off("pressmove", element.pressmove)
                element.asset.off("pressup", element.pressup)
                continue;
	          }
            var bounds = new zim.Boundary(0,0,850,850);
            if (element.editable === false) {
                element.asset.noDrag();
            } else {
                if (element.asset instanceof zim.Container) {
                    element.asset.drag({all: true})
                } else {
                    element.asset.drag()
                }
                if (element.asset instanceof zim.Squiggle || element.asset instanceof zim.Blob) {
                    element.asset.addPoint(1);
                    element.asset.removePoint(1);
                }
            }
            (function (element) {
                element.pressdown = element.asset.on("mousedown", function(e) {
                    if (layerOf(element) !== frame.currLayer) return;
                    if (frame.tool === "pan") return;   // pan tool: ignore element, let map drag

                    frame.pointerOnElement = true;
                    const ne = (e && e.nativeEvent) ? e.nativeEvent : {};
                    const additive = !!ne.shiftKey;
                    const toggle = !!(ne.ctrlKey || ne.metaKey);

                    ensureSelectionSet();
                    const isSelected = frame.selectedElements.has(element.id);

                    // 1) Modifier click → toggle selection
                    if (additive || toggle) {
                        toggleElementSelection(element);
                    }
                    // 2) Plain click on unselected element → replace selection
                    else if (!isSelected) {
                        selectSingleElement(element);
                    }
                    // 3) Plain click on already-selected element → keep selection
                    else {
                        // do nothing; selection remains intact
                        syncSelElementState();
                    }
                    if (element.type === "area") {
                        setActiveAreaId(element.id);
                    }

                    // Prepare group-drag ONLY if clicking a selected element
                    if (frame.selectedElements.has(element.id) && frame.selectedElements.size > 1) {
                        frame.groupDrag = {
                            anchorId: element.id,
                            startPositions: {},
                        };

                        for (const id of frame.selectedElements) {
                            const el = frame.elements[id];
                            if (el && el.asset) {
                                frame.groupDrag.startPositions[id] = {
                                    x: el.asset.x,
                                    y: el.asset.y,
                                };
                            }
                        }
                    } else {
                        frame.groupDrag = null;
                    }
                    setSelectionCount(frame.selectedElements.size);
                });

                element.pressmove = element.asset.on("pressmove", function(e) {
                    if (layerOf(element) != frame.currLayer) return;
                    if (frame.tool === "pan") return;   // pan tool handles the drag

                    // Dragging an unselected element selects it.
                    if (!element.selected) {
                        selectSingleElement(element);
                    }

                    ensureSelectionSet();

                    // Group drag (only runs for the anchor being dragged)
                    if (frame.groupDrag && frame.selectedElements.size > 1 && frame.groupDrag.anchorId === element.id) {
                        const anchorStart = frame.groupDrag.startPositions[element.id];
                        if (!anchorStart) return;

                        const dx = this.x - anchorStart.x;
                        const dy = this.y - anchorStart.y;

                        for (const id of frame.selectedElements) {
                            const el = frame.elements[id];
                            if (!el || !el.asset) continue;
                            const p = frame.groupDrag.startPositions[id];
                            if (!p) continue;

                            el.asset.x = p.x + dx;
                            el.asset.y = p.y + dy;

                            if (el.type !== "structure") {
                                ensureHighlight(el);
                                positionHighlight(el);
                            }

                            el.location.x = el.asset.x / frame.zoomScale;
                            el.location.y = el.asset.y / frame.zoomScale;
                            el.moved = true;
                        }

                        frame.stage.update();
                        return;
                    }

                    // Single drag
                    if (element.type !== "structure") {
                        ensureHighlight(element);
                        positionHighlight(element);
                    }
                    element.location.x = this.x/frame.zoomScale;
                    element.location.y = this.y/frame.zoomScale;
                    element.moved = true
                    element.asset.x = this.x;
                    element.asset.y = this.y;
                    frame.stage.update();
                });

                element.pressup = element.asset.on("pressup", function(e) {
                    if (layerOf(element) != frame.currLayer) return;
                    if (frame.tool === "pan") return;   // pan tool: no element select on release

                    frame.pointerOnElement = false;
                    const ne = (e && e.nativeEvent) ? e.nativeEvent : {};
                    const additive = !!ne.shiftKey;
                    const toggle = !!(ne.ctrlKey || ne.metaKey);

                    // Click (no drag) updates selection
                    if (!element.moved) {
                        if (additive || toggle) {
                            toggleElementSelection(element);
                        } else {
                            selectSingleElement(element);
                        }
                        frame.stage.update();
                        return;
                    }

                    ensureSelectionSet();
                    setSelectionCount(frame.selectedElements.size);

                    // Group drag finalize (anchor only)
                    if (frame.groupDrag && frame.selectedElements.size > 1 && frame.groupDrag.anchorId === element.id) {
                        let movedBorder = false;

                        for (const id of frame.selectedElements) {
                            const el = frame.elements[id];
                            if (!el || !el.asset) continue;

                            el.location.x = el.asset.x / frame.zoomScale;
                            el.location.y = el.asset.y / frame.zoomScale;

                            if (el.type === "plant") {
                                const areas = [];
                                for (const key in frame.elements) {
                                    const ce = frame.elements[key];
                                    if (ce.type === "area" && ce.asset) areas.push(ce);
                                }
                                checkPlantInArea(areas, el);
                            } else if (el.type === "border") {
                                movedBorder = true;
                            }

                            el.moved = false;
                        }

                        if (movedBorder) restoreBorderZOrder();

                        hotItem = this;
                        saveDesign();
                        frame.groupDrag = null;

                        frame.pointerOnElement = false;
                        frame.stage.update();
                        return;
                    }

                    // Single drag finalize
                    element.location.x = this.x / frame.zoomScale;
                    element.location.y = this.y / frame.zoomScale;
                    element.asset.x = this.x;
                    element.asset.y = this.y;

                    if (element.type === "plant") {
                        const areas = [];
                        for (const key in frame.elements) {
                            const ce = frame.elements[key];
                            if (ce.type === "area" && ce.asset) areas.push(ce);
                        }
                        checkPlantInArea(areas, element);
                    } else if (element.type === "area") {
                        const areas = [element];
                        for (const key in frame.elements) {
                            const cand = frame.elements[key];
                            if (cand.type === "plant") checkPlantInArea(areas, cand);
                        }
                    } else if (element.type === "border") {
                        restoreBorderZOrder();
                    }

                    hotItem = null;
                    saveDesign();
                    element.moved = false;
                    frame.stage.update();
                });
            })(element);
        }
    }

    const createTemplate = () => {
        // template is a snapshot of garden elements, settings, username
        // create template data structure and persist on the backend, getting id creation
        frame = foo
        frame.currDesign = {
            "elements": [],
            "id":  uuidv4(),
            "dimensions": {},
            "username": username,
            "plants": [],
            "borders": [],
            "areas": [],
            "dimensions": {
		            "height":40,
                "width":40
	          }
        }

        for (var elementKey in frame.elements) {
            var element = frame.elements[elementKey];
            frame.planBox.removeChild(element);
        }
        frame.stage.removeChild(propertyBox);
        setElements({});
        onAddDesign(frame.currDesign);

        frame.stage.removeChild(cropRotation);
        frame.stage.addChild(cropRotation);
        frame.stage.update();
    }


  function newStructureProperties (target) {
     var structure;
     structure = foo.selectedStructure

     if (isMetric && (target.props.name === "width" || target.props.name === "height")) {
         structure[target.props.name] = parseFloat(target.newValue) * metricGridWidth / gridWidth;
     } else {
         structure[target.props.name] = target.newValue;
     }
    }

  function newAcccessProperties (target) {
     foo.accessThickness = target.newValue * displayGrid
  }

  function newPlantProperties (target) {
     var plant;
     plant = foo.selectedPlant

     plant[target.props.name] = target.newValue
     var numPerSquareFoot = Math.pow(12/plant["spacing_between_plants"],2);
     plant.spaceUsed = (plant.numPlants/numPerSquareFoot).toFixed(2);
     if (target.props.name=="patchWidth") {
          plant.numPlantsWidth = parseInt(target.newValue);
          plant.numPlantsHeight = Math.round(plant.numPlants/parseInt(target.newValue));
          setNumPlantsWidth(plant.numPlantsWidth)
          setNumPlantsHeight(plant.numPlantsHeight)
     }  else if (target.props.name=="patchHeight") {
          plant.numPlantsHeight = parseInt(target.newValue);
          plant.numPlantsWidth = Math.round(plant.numPlants/parseInt(target.newValue));
         setNumPlantsWidth(plant.numPlantsWidth)
         setNumPlantsHeight(plant.numPlantsHeight)
     }  else if (target.props.name=="plantSpacing") {
         plant.spacing_between_plants = isMetric ? parseFloat(target.newValue) / 2.54 : parseInt(target.newValue);
         setPlantSpacing(plant.spacing_between_plants)
     } else if (target.props.name=="numPlants") {
          if (parseInt(target.newValue)>1) {
              var numPerSquareFoot = Math.pow(12/parseInt(target.newValue),2);
              plant.spaceUsed = (plant.numPlants/numPerSquareFoot).toFixed(2);
              var factors = getFactors(target.newValue)
              var bigfactor = factors[factors.length-1]
              if (factors.length>2) {
                  bigfactor = factors[factors.length-2]
              }
              var newWidth = bigfactor
              var newHeight = target.newValue/bigfactor
              plant.numPlantsWidth = newWidth
              plant.numPlantsHeight = newHeight
              plant.numPlants = target.newValue
          }
         setNumPlantsWidth(plant.numPlantsWidth)
         setNumPlantsHeight(plant.numPlantsHeight)
         setNumPlants(plant.numPlants)
       }
    }

    function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

    const displayTooltip = (label, container, item, location, width) => {
        var tooltipBackground = new zim.Rectangle(100,25,"red");
        tooltipBackground.borderColor = "white";
        tooltipBackground.borderWidth = 1;
        item.tooltip = new zim.Label({
            text: label,
            size: 18,
            align: "right",
            color: "#FFF",
            font:font,
            backing: tooltipBackground
        });
        item.tooltip.alpha = 0.5;
        if (!location) {
            item.tooltip.x = item.x + 20;
            item.tooltip.y = item.y + 20;
        } else {
            item.tooltip.x = location.x;
            item.tooltip.y = location.y;
        }
        if (width) {
            tooltipBackground.width = width;
            tooltipBackground.x = -20;
        }

        container.addChild(item.tooltip);
        frame.stage.update();
    }

    function updateLayer (layer) {
	      setCurrLayer(layer)
        frame = foo
        clearOldSelections()
        if (layer != "plant"){
            frame.selectedPlant = undefined
            setShowSelectedPlant(false)
        }

        foo.currLayer = layer
        if (layer === 'border') {
            // Borders open in select mode (marquee + click-select). Drawing is an
            // explicit choice via the "Add Border" toggle. Seed sensible defaults.
            if (foo && !foo.borderFill) pickBorderFill('soil');
            if (foo) foo.borderShape = foo.borderShape || 'rectangle';
            if (!borderTool) setBorderTool('rectangle');
        }
        enableTool("selectTool")
        setTool("select")
    }

      function pickFill (fill) {
         setAccessFill(fill)
         foo.accessFill = fill
      }

      function changeFill (fill) {
         foo.selectedElement.fill = fill
         var fill = "fill_" + fill + ".png";
         foo.selectedElement.asset.colorCommand.bitmap(foo.asset(fill).image)
         setAccessFill(fill)
         saveDesign()
      }

      function changeSeasonRotation(newVal) {
          foo.seasonRotation = newVal
          setSeasonRotation (newVal)
      }

    function changeLastDatePossible(newVal) {
        foo.lastDatePossible = newVal
        setLastDatePossible (newVal)
    }

      function pickBorderFill (fill) {
         setBorderFill(fill)
         foo.borderFill = fill
      }


    function changeBorder (target) {
       var borderAsset = foo.selectedElement.asset
       if (target.props.name=="width") {
           var asset;
           const feetW = isMetric ? parseFloat(target.newValue) * metricGridWidth / gridWidth : parseFloat(target.newValue);
           if (foo.selectedElement.tool == "rectangle") {
               asset = new zim.Rectangle({
                   width: feetW * gridWidth + 5,
                   height: foo.selectedElement.height * gridHeight + 5,
                   color: "#EEE",
                   borderWidth: 5,
                   borderColor: "black"
               });
           }
           var fill = "fill_" + foo.selectedElement.fill + ".png";
           asset.colorCommand.bitmap(foo.asset(fill).image)
           asset.scaleX = foo.zoomScale
           asset.scaleY = foo.zoomScale
           asset.x = borderAsset.x;
           asset.y = borderAsset.y;
           asset.rotation = foo.selectedElement.rotation;
           asset.id = foo.selectedElement.id;
           foo.borderLayer.removeChild(foo.selectedElement.asset)
           foo.selectedElement.asset = asset;
           foo.borderLayer.addChild(asset);
           foo.selectedElement.width = feetW;
           borderAsset.borderWidth = 5
           frame = foo
       } else if (target.props.name=="diameter") {
           const feetD = isMetric ? parseFloat(target.newValue) * metricGridWidth / gridWidth : parseFloat(target.newValue);
           if (foo.selectedElement.tool=="circle") {
               var asset = new zim.Circle({radius: feetD * gridWidth / 2,
                   color:"#EEE",
                   borderWidth:5,
                   borderColor:"black"});
           }
           var fill = "fill_" + foo.selectedElement.fill + ".png";
           asset.colorCommand.bitmap(foo.asset(fill).image)
           asset.scaleX = foo.zoomScale
           asset.scaleY = foo.zoomScale
           asset.x = borderAsset.x;
           asset.y = borderAsset.y;
           asset.id = foo.selectedElement.id;
           foo.borderLayer.removeChild(foo.selectedElement.asset)
           foo.selectedElement.asset = asset;
           foo.borderLayer.addChild(asset);
           foo.selectedElement.diameter = feetD;
           borderAsset.borderWidth = 5
           frame = foo
           enterSelectionMode()
       } else if (target.props.name=="height") {
           const feetH = isMetric ? parseFloat(target.newValue) * metricGridWidth / gridWidth : parseFloat(target.newValue);
           if (foo.selectedElement.tool=="rectangle") {
               var asset = new zim.Rectangle({
                   width: foo.selectedElement.width*gridWidth + 5,
                   height: feetH * gridHeight + 5,
                   color: "#EEE",
                   borderWidth: 5,
                   borderColor: "black"
               });
               var fill = "fill_" + foo.selectedElement.fill + ".png";
               asset.colorCommand.bitmap(foo.asset(fill).image)
               asset.scaleX = foo.zoomScale
               asset.scaleY = foo.zoomScale
               asset.x = borderAsset.x;
               asset.y = borderAsset.y;
               asset.rotation = foo.selectedElement.rotation;
               asset.id = foo.selectedElement.id;
               foo.borderLayer.removeChild(foo.selectedElement.asset)
               foo.selectedElement.asset = asset;
               foo.borderLayer.addChild(asset);
               foo.selectedElement.height = feetH;
               borderAsset.borderWidth = 5
               frame = foo
               enterSelectionMode()
           }
       } else if (target.props.name=="locationx") {
          var asset = foo.selectedElement.asset
           asset.x = parseFloat(target.newValue) * displayGrid * foo.zoomScale
       } else if (target.props.name=="locationy") {
           var asset = foo.selectedElement.asset
           asset.y = parseFloat(target.newValue) * displayGrid * foo.zoomScale
       }  else if (target.props.name=="rotation") {
          foo.selectedElement.rotation = parseInt(target.newValue)
          borderAsset.rotation = parseInt(target.newValue)
       }
       saveDesign()
       foo.stage.update();
    }

    function rebuildStructure(element) {
        frame = foo;
        var x = element.asset.x
        var y = element.asset.y
        if (element.asset) {
            foo.structureLayer.removeChild(element.asset);
            element.asset.dispose?.(); // optional but good hygiene
            element.asset = null;
        }

        generateStructureElement(
            x,
            y,
            element
        );

        saveDesign();
        foo.stage.update();
    }

    function changeStructure(target) {
        const element = foo.selectedElement;
        if (!element) return;

        if (target.props.name === "width") {
            element.width = isMetric ? parseFloat(target.newValue) * metricGridWidth / gridWidth : parseFloat(target.newValue);

        } else if (target.props.name === "height") {
            element.height = isMetric ? parseFloat(target.newValue) * metricGridWidth / gridWidth : parseFloat(target.newValue);

        } else if (target.props.name === "rotation") {
            element.rotation = target.newValue;
        }

        rebuildStructure(element);
    }


    function changeElement (target) {
        var savedElement = foo.selectedElement
       if (target.props.name=="seedStartDate") {
          foo.selectedElement["seedStartDate"] = target.newValue;
          var seedStartDate = new Date(target.newValue)
          foo.selectedElement.plant["seedStartDate"] = (seedStartDate.getMonth() + 1) + '/' + (seedStartDate.getDate()+1) + '/' + seedStartDate.getFullYear();
          updatePlantInArea(foo.selectedElement)
       } else if (target.props.name=="transplantDate") {
          foo.selectedElement["transplantDate"] = target.newValue;
          var harvestDate = new Date(target.newValue)
          foo.selectedElement.plant["transplantDate"] = (harvestDate.getMonth() + 1) + '/' + (harvestDate.getDate()+1) + '/' + harvestDate.getFullYear();
          updatePlantInArea(foo.selectedElement)
       } else if (target.props.name === "size") {
        foo.selectedElement.plant.size = target.newValue;
        rerenderSelectedPlantIcon(savedElement);
       } else if (target.props.name=="patchWidth") {
          foo.selectedElement.numPlantsWidth = parseInt(target.newValue);
          foo.selectedElement.numPlantsHeight = Math.round(foo.selectedElement.plant.numPlants/parseInt(target.newValue));
          foo.plantLayer.removeChild(foo.selectedElement.asset)
          frame = foo
           var locx = foo.selectedElement.asset.x
           var locy = foo.selectedElement.asset.y
           var patch = {
              width: foo.selectedElement.numPlantsWidth,
              height: foo.selectedElement.numPlantsHeight
          }
           var assetName = plantIconAssetId(foo.selectedElement.plant);
          generatePlantElement(locx, locy,
              foo.selectedElement, foo.selectedElement.id, foo.selectedElement.plant.size, patch, assetName);
           if (frame.zoomScale != 1) {
               if (foo.selectedElement.plant.numPlants>1) {
                   var patchPlants = foo.selectedElement.asset.children
                   for (var i=0; i<patchPlants.length; i++) {
                       var patchPlant = patchPlants[i]
                       patchPlant.scaleX = frame.zoomScale * foo.selectedElement.scale;
                       patchPlant.scaleY = frame.zoomScale * foo.selectedElement.scale;
                   }
               } else {
                   foo.selectedElement.asset.scaleX = frame.zoomScale * foo.selectedElement.scale;
                   foo.selectedElement.asset.scaleY = frame.zoomScale * foo.selectedElement.scale;
                   foo.selectedElement.asset.x = x - foo.selectedElement.asset.width / 2
                   foo.selectedElement.asset.y = y - foo.selectedElement.asset.height / 2
                   foo.selectedElement.location.x = foo.selectedElement.asset.x/foo.zoomScale;
                   foo.selectedElement.location.y = foo.selectedElement.asset.y/foo.zoomScale;
               }
           }
           enterSelectionMode()
           selectSingleElement(savedElement)
       }  else if (target.props.name=="patchHeight") {
          foo.selectedElement.numPlantsHeight = parseInt(target.newValue);
          foo.selectedElement.numPlantsWidth = Math.round(foo.selectedElement.plant.numPlants/parseInt(target.newValue));
          foo.plantLayer.removeChild(foo.selectedElement.asset)
          frame = foo
           var locx = foo.selectedElement.asset.x
           var locy = foo.selectedElement.asset.y
          var patch = {
              width: foo.selectedElement.numPlantsWidth,
              height: foo.selectedElement.numPlantsHeight
          }
           var assetName = plantIconAssetId(foo.selectedElement.plant);
           generatePlantElement(locx, locy,
              foo.selectedElement, foo.selectedElement.id, foo.selectedElement.plant.size, patch, assetName);
           if (frame.zoomScale != 1) {
               if (foo.selectedElement.plant.numPlants>1) {
                   var patchPlants = foo.selectedElement.asset.children
                   for (var i=0; i<patchPlants.length; i++) {
                       var patchPlant = patchPlants[i]
                       patchPlant.scaleX = frame.zoomScale * foo.selectedElement.scale;
                       patchPlant.scaleY = frame.zoomScale * foo.selectedElement.scale;
                   }
               } else {
                   foo.selectedElement.asset.scaleX = frame.zoomScale * foo.selectedElement.scale;
                   foo.selectedElement.asset.scaleY = frame.zoomScale * foo.selectedElement.scale;
                   foo.selectedElement.asset.x = x - foo.selectedElement.asset.width / 2
                   foo.selectedElement.asset.y = y - foo.selectedElement.asset.height / 2
                   foo.selectedElement.location.x = foo.selectedElement.asset.x/foo.zoomScale;
                   foo.selectedElement.location.y = foo.selectedElement.asset.y/foo.zoomScale;
               }
           }
           enterSelectionMode()
           selectSingleElement(savedElement)
       } else if (target.props.name=="numPlants") {
          foo.selectedElement.plant["numPlants"] = target.newValue;
          var plant = foo.selectedElement;
          if (parseInt(target.newValue)>1) {
              var numPerSquareFoot = Math.pow(12/parseInt(target.newValue),2);
              plant.spaceUsed = (plant.numPlants/numPerSquareFoot).toFixed(2);
              var factors = getFactors(target.newValue)
              var bigfactor = factors[factors.length-1]
              if (factors.length>2) {
                  bigfactor = factors[factors.length-2]
              }
              var newWidth = bigfactor
              var newHeight = target.newValue/bigfactor
              plant.numPlantsWidth = newWidth
              plant.numPlantsHeight = newHeight
              var locx = foo.selectedElement.asset.x
              var locy = foo.selectedElement.asset.y
              foo.plantLayer.removeChild(foo.selectedElement.asset)
              frame = foo
              var patch = {
                  width: foo.selectedElement.numPlantsWidth,
                  height: foo.selectedElement.numPlantsHeight
              }
              var assetName = plantIconAssetId(foo.selectedElement.plant);
              generatePlantElement(locx,locy, foo.selectedElement, foo.selectedElement.id, foo.selectedElement.plant.size, patch, assetName);
          }
       } else if (target.props.name=="thickness") {
          let firstScale = foo.zoomScale;
          const thickFeet = isMetric ? parseFloat(target.newValue) * metricGridWidth / gridWidth : parseFloat(target.newValue);
          foo.selectedElement.thickness = thickFeet;
          foo.selectedElement.asset.thickness = thickFeet * 75 * firstScale
       } else if (target.props.name=="plantSpacing") {
           foo.selectedElement.plant.spacing_between_plants = isMetric ? parseFloat(target.newValue) / 2.54 : parseFloat(target.newValue)
           foo.plantLayer.removeChild(foo.selectedElement.asset)
           frame = foo
           var locx = foo.selectedElement.asset.x
           var locy = foo.selectedElement.asset.y
           var patch = {
               width: foo.selectedElement.numPlantsWidth,
               height: foo.selectedElement.numPlantsHeight
           }
           var assetName = plantIconAssetId(foo.selectedElement.plant);
           generatePlantElement(locx, locy,
               foo.selectedElement, foo.selectedElement.id, foo.selectedElement.plant.size, patch, assetName);
           if (frame.zoomScale != 1) {
               if (foo.selectedElement.plant.numPlants>1) {
                   var patchPlants = foo.selectedElement.asset.children
                   for (var i=0; i<patchPlants.length; i++) {
                       var patchPlant = patchPlants[i]
                       patchPlant.scaleX = frame.zoomScale * foo.selectedElement.scale;
                       patchPlant.scaleY = frame.zoomScale * foo.selectedElement.scale;
                   }
               } else {
                   foo.selectedElement.asset.scaleX = frame.zoomScale * foo.selectedElement.scale;
                   foo.selectedElement.asset.scaleY = frame.zoomScale * foo.selectedElement.scale;
                   foo.selectedElement.asset.x = x - foo.selectedElement.asset.width / 2
                   foo.selectedElement.asset.y = y - foo.selectedElement.asset.height / 2
                   foo.selectedElement.location.x = foo.selectedElement.asset.x/foo.zoomScale;
                   foo.selectedElement.location.y = foo.selectedElement.asset.y/foo.zoomScale;
               }
           }

           enterSelectionMode()
           applyZoomToPlantElement(foo.selectedElement, foo.zoomScale)
           selectSingleElement(savedElement)
       } else if (target.props.name=="rotation") {
           foo.selectedElement.rotation = target.newValue
       } else {
         foo.selectedElement.plant[target.props.name] = target.newValue
       }

       if (foo.selectedElement.type=="plant" && foo.selectedElement.area==foo.unassignedArea.id) {
            for (var ii=0; ii<foo.unassignedArea.plants.length; ii++) {
                if (foo.unassignedArea.plants[ii].id == foo.selectedElement.plant.id) {
                    foo.unassignedArea.plants[ii] = foo.selectedElement.plant
                    onUpdateArea(foo.unassignedArea)
                    break
                }
            }
       }
       saveDesign()
        foo.stage.update()
    }

    function configBackground (target) {

    }

    async function loadTile(folder, assetName) {
        try {
            // Retrieve the asset URL from S3
            const assetURL = await Storage.get(folder+ "/" + assetName, { level: 'public' });
            console.log(`Retrieved S3 URL: ${assetURL}`);

            return new Promise((resolve, reject) => {
                // Load the asset
                frame.loadAssets([{ id: assetName, src: assetURL }]);

                // Wait for the asset to finish loading
                frame.on("complete", () => {
                    resolve(); // Resolve the promise when the asset is ready
                });

                frame.on("error", (e) => {
                    console.error("Error loading asset:", e);
                    reject(e);
                });
            });

        } catch (error) {
            console.error(`Error loading tile from S3: ${assetName}`, error);
            throw error; // Rethrow error for further handling
        }
    }

    async function loadTileByKey(key) {
        try {
            const assetURL = await Storage.get(key, { level: 'public' });
            const assetId = key; // use full key as unique asset ID
            return new Promise((resolve, reject) => {
                frame.loadAssets([{ id: assetId, src: assetURL }]);
                frame.on("complete", () => resolve());
                frame.on("error", (e) => { console.error("Error loading asset:", e); reject(e); });
            });
        } catch (error) {
            console.error(`Error loading tile by key from S3: ${key}`, error);
            throw error;
        }
    }

    var plantBox;
    var planGrid;
    const gridWidth = 75;
    const gridHeight = 75;
    const metricGridWidth = 236;
    const isMetric = profile?.unitmeasurement === "metric";
    const displayGrid = isMetric ? metricGridWidth : gridWidth;
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    window.addEventListener("keydown", function(e) {
        const tag = e.target.tagName.toLowerCase();
        const isTypingField = tag === 'input' || tag === 'textarea' || e.target.isContentEditable;

        if (!isTypingField && ["Space", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.code)) {
            e.preventDefault();
        }
    }, false);

    return (
        <React.Fragment>
            <rt.Container fluid style={{paddingTop: "100px"}}>
                {/* Render Breadcrumb */}

                <rt.Row className="align-items-center" style={{marginBottom: "5px"}}>
                    <rt.Col md={1}>
                        <rt.Button color="link" size="lg" onClick={goPrevYear}>
                            ◀
                        </rt.Button>
                    </rt.Col>

                    <rt.Col md={2}>
                        <h4 style={{margin: 0}}>{currYear}</h4>
                    </rt.Col>

                    <rt.Col md={1}>
                        <rt.Button color="link" size="lg" onClick={goNextYear}>
                            ▶
                        </rt.Button>
                    </rt.Col>
                </rt.Row>

                <rt.Row>
                    <rt.Col xl="9">
                        <div style={{paddingTop: "-100px"}} id="designer"/>
                    </rt.Col>
                    <rt.Col xl="3">

                        <rt.Card outline className="border">
                            <rt.CardBody>
                                <rt.Row>
                                    <rt.Col md={12}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: "-20px" }}>
                                            <button
                                                type="button"
                                                title="Print"
                                                className="btn btn-sm"
                                                style={{ backgroundColor: "#7F8F7B", borderColor: "#7F8F7B", color: "#fff" }}
                                                onClick={() => generatePdf()}
                                            >
                                                <i className="bx bx-printer" style={{ fontSize: "20px", verticalAlign: "middle" }} />
                                            </button>
                                            <button
                                                type="button"
                                                title={panMode ? "Exit pan mode" : "Pan / drag the map"}
                                                className="btn btn-sm"
                                                style={panMode
                                                    ? { backgroundColor: "#243024", borderColor: "#FF9900", borderWidth: "2px", borderStyle: "solid", color: "#FF9900", boxShadow: "0 0 0 2px rgba(255,153,0,0.35)" }
                                                    : { backgroundColor: "#7F8F7B", borderColor: "#7F8F7B", color: "#fff" }}
                                                onClick={togglePan}
                                            >
                                                <i className="fas fa-hand-paper" style={{ fontSize: "20px", verticalAlign: "middle" }} />
                                            </button>
                                            <span style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.04em", color: "#6f7a72", marginLeft: "12px" }}>Zoom</span>
                                            <button
                                                type="button"
                                                title="Zoom out"
                                                className="btn btn-sm"
                                                style={{ backgroundColor: "#7F8F7B", borderColor: "#7F8F7B", color: "#fff" }}
                                                onClick={() => zoomBy(1 / 1.2)}
                                            >
                                                <i className="bx bxs-zoom-out" style={{ fontSize: "22px", verticalAlign: "middle" }} />
                                            </button>

                                            {isDropdownActive ? (
                                                <select
                                                    autoFocus
                                                    value={zoomScale}
                                                    onChange={handlePresetChange}
                                                    onBlur={() => setDropdownActive(false)} // Hide when losing focus
                                                    style={{border: "none", outline: "none", cursor: "pointer", fontSize: "18px"}}
                                                >
                                                    {zoomPresets.map((preset) => (
                                                        <option key={preset} value={preset}>
                                                            {Math.round(preset * 100)}%
                                                        </option>
                                                    ))}
                                                </select>
                                            ) : (
                                                <span
                                                    style={{cursor: "pointer", userSelect: "none", fontSize: "18px"}}
                                                    onClick={() => setDropdownActive(true)}
                                                >
                    {Math.round(zoomScale * 100)}%
                </span>
                                            )}

                                            <button
                                                type="button"
                                                title="Zoom in"
                                                className="btn btn-sm"
                                                style={{ backgroundColor: "#7F8F7B", borderColor: "#7F8F7B", color: "#fff" }}
                                                onClick={() => zoomBy(1.2)}
                                            >
                                                <i className="bx bxs-zoom-in" style={{ fontSize: "22px", verticalAlign: "middle" }} />
                                            </button>
                                        </div>
                                    </rt.Col>
                                </rt.Row>
                            </rt.CardBody>
                            <rt.CardHeader
                                onClick={toggleLayers}
                                style={{
                                    backgroundColor: "#BEC8B6",
                                    padding: "10px",
                                    cursor: "pointer",
                                    marginBottom: "10px"
                                }}
                            >
                                <rt.Row>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "24px",
                                            marginLeft: "10px",
                                            height: "24px",
                                            borderRadius: "50%",
                                            border: "1px solid #FFFFFF",
                                            backgroundColor: "#99A88D",
                                            transition: "transform 0.2s"
                                        }}
                                    >
                                        <i
                                            className={`fas ${isOpen ? 'fa-chevron-down' : 'fa-chevron-right'}`}
                                            style={{fontSize: "14px", color: "#FFFFFF"}}
                                        />

                                    </div>

                                    <h5 style={{marginLeft: "10px"}}>Layers</h5>
                                </rt.Row>


                            </rt.CardHeader>
                            <rt.Collapse isOpen={isOpen}>
                                <rt.CardBody>
                                    <rt.Row>
                                        <rt.Col md={2}>
                                            <input
                                                style={{width: "30px"}}
                                                name="layer"
                                                value="terrain"
                                                type="radio"
                                                checked={currLayer === 'terrain'}
                                                onClick={() => updateLayer('terrain')}
                                            />
                                        </rt.Col>
                                        <rt.Col md={2}><i className="fas fa-eye"/></rt.Col>
                                        <rt.Col md={6}><h5>Terrain</h5></rt.Col>
                                    </rt.Row>
                                    <rt.Row>
                                        <rt.Col md={2}>
                                            <input
                                                style={{width: "30px"}}
                                                name="layer"
                                                value="structure"
                                                type="radio"
                                                checked={currLayer === 'structure'}
                                                onClick={() => updateLayer('structure')}
                                            />
                                        </rt.Col>
                                        <rt.Col md={2}>
                                            <i
                                                onClick={() => toggleLayerVisibility('structure', !visibility['structure'])}
                                                className={visibility['structure'] ? 'fas fa-eye' : 'fas fa-eye-slash'}
                                            />
                                        </rt.Col>
                                        <rt.Col md={6}><h5>Structures</h5></rt.Col>
                                    </rt.Row>
                                    <rt.Row>
                                        <rt.Col md={2}>
                                            <input
                                                style={{width: "30px"}}
                                                name="layer"
                                                value="path"
                                                type="radio"
                                                checked={currLayer === 'path'}
                                                onClick={() => updateLayer('path')}
                                            />
                                        </rt.Col>
                                        <rt.Col md={2}>
                                            <i
                                                onClick={() => toggleLayerVisibility('path', !visibility['path'])}
                                                className={visibility['path'] ? 'fas fa-eye' : 'fas fa-eye-slash'}
                                            />
                                        </rt.Col>
                                        <rt.Col md={6}><h5>Paths</h5></rt.Col>
                                    </rt.Row>
                                    <rt.Row>
                                        <rt.Col md={2}>
                                            <input
                                                style={{width: "30px"}}
                                                name="layer"
                                                value="area"
                                                type="radio"
                                                checked={currLayer === 'area'}
                                                onClick={() => updateLayer('area')}
                                            />
                                        </rt.Col>
                                        <rt.Col md={2}>
                                            <i
                                                onClick={() => toggleLayerVisibility('area', !visibility['area'])}
                                                className={visibility['area'] ? 'fas fa-eye' : 'fas fa-eye-slash'}
                                            />
                                        </rt.Col>
                                        <rt.Col md={6}><h5>Areas</h5></rt.Col>
                                    </rt.Row>
                                    <rt.Row>
                                        <rt.Col md={2}>
                                            <input
                                                style={{width: "30px"}}
                                                name="layer"
                                                value="border"
                                                type="radio"
                                                checked={currLayer === 'border'}
                                                onClick={() => updateLayer('border')}
                                            />
                                        </rt.Col>
                                        <rt.Col md={2}>
                                            <i
                                                onClick={() => toggleLayerVisibility('border', !visibility['border'])}
                                                className={visibility['border'] ? 'fas fa-eye' : 'fas fa-eye-slash'}
                                            />
                                        </rt.Col>
                                        <rt.Col md={6}><h5>Borders</h5></rt.Col>
                                    </rt.Row>
                                    <rt.Row>
                                        <rt.Col md={2}>
                                            <input
                                                style={{width: "30px"}}
                                                name="layer"
                                                value="plant"
                                                type="radio"
                                                checked={currLayer === 'plant'}
                                                onClick={() => updateLayer('plant')}
                                            />
                                        </rt.Col>
                                        <rt.Col md={2}>
                                            <i
                                                onClick={() => toggleLayerVisibility('plant', !visibility['plant'])}
                                                className={visibility['plant'] ? 'fas fa-eye' : 'fas fa-eye-slash'}
                                            />
                                        </rt.Col>
                                        <rt.Col md={6}><h5>Plants</h5></rt.Col>
                                    </rt.Row>
                                </rt.CardBody>
                            </rt.Collapse>
                            <rt.CardHeader
                                style={{paddingTop: "5px", paddingBottom: "0px", backgroundColor: "#BEC8B6"}}>
                                <h5>
                                    Tools
                                </h5>
                            </rt.CardHeader>

                            <rt.CardBody style={{
                                height: '600px', // Set the fixed height for the scrollable area
                                overflowY: 'auto', // Enables vertical scrolling
                            }}>

                                <rt.Row>
                                    {currLayer == 'border' && !(selElement && selElement.type == 'border') &&
                                        <rt.Col md={4}>
                                            <label style={{
                                                backgroundColor: tool == "border" ? "#99A88D" : "#BEC8B6",
                                                width: "70px",
                                                height: "70px",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}
                                                   onClick={() => {
                                                       if (tool == "border") {
                                                           // Turn off Add mode → back to select/marquee.
                                                           enableTool("selectTool");
                                                           setTool("select");
                                                       } else {
                                                           // Turn on Add mode → draw the current shape.
                                                           clearOldSelections();
                                                           const shape = (foo && foo.borderShape) || 'rectangle';
                                                           setMode("border", shape);
                                                           setBorderTool(shape);
                                                           if (foo && !foo.borderFill) pickBorderFill('soil');
                                                           setTool("border");
                                                       }
                                                   }}
                                                   className={
                                                       tool == "border"
                                                           ? "btn btn-success active"
                                                           : "btn btn-success"
                                                   }
                                            >
                                                <i className="bx bx-shape-square" style={{fontSize: "22px"}}/>
                                                <span style={{fontSize: "0.75em", textAlign: "center", lineHeight: 1.1, marginTop: "4px"}}>Add Border</span>
                                            </label>
                                        </rt.Col>
                                    }
                                    {currLayer == 'terrain' && backgroundType == 'color' &&
                                        <div>
                                            <rt.Row>
                                                <rt.Col md={6}>Pick color</rt.Col>

                                                <rt.Col md={6}><input
                                                    className="form-control form-control-color mw-100"
                                                    type="color"
                                                    defaultValue="#556ee6"
                                                    id="example-color-input"
                                                />
                                                </rt.Col>
                                            </rt.Row>
                                        </div>
                                    }
                                    {currLayer == 'terrain' && backgroundType == 'googlemap' && !terrainExists &&
                                        <div>
                                            <rt.Row>
                                                <rt.Col md={12}>
                                                    <rt.Button
                                                        onClick={e => {
                                                            loadGoogleMap()
                                                        }}
                                                        color="success"
                                                        className="btn-sm"
                                                    >
                                                        Load Google Map
                                                    </rt.Button>
                                                </rt.Col>
                                            </rt.Row>

                                        </div>
                                    }
                                    {currLayer == 'terrain' && backgroundType == 'image' && !terrainExists && backgroundFiles.length == 0 &&
                                        <div>
                                            <rt.Row>
                                                <rt.Col md={12}>
                                                    <Dropzone
                                                        style={{
                                                            "width": "100%",
                                                            "height": "20%",
                                                            "border": "1px solid black"
                                                        }}
                                                        onDrop={acceptedFiles => {
                                                            handleBackgroundFiles(acceptedFiles)
                                                        }}
                                                    >
                                                        {({getRootProps, getInputProps}) => (
                                                            <div
                                                                className="dz-message needsclick"
                                                                {...getRootProps()}
                                                            >
                                                                <input {...getInputProps()} />
                                                                <span>Click here to upload background image</span>
                                                            </div>
                                                        )}
                                                    </Dropzone>
                                                </rt.Col>
                                            </rt.Row>

                                        </div>
                                    }
                                    {currLayer == 'terrain' && backgroundType == 'image' && !terrainExists && backgroundFiles.length > 0 &&
                                        <div>
                                            <rt.Row>
                                                <rt.Col md={6}>
                                                    {backgroundFiles.map((f, i) => {
                                                        return (
                                                            <rt.Card
                                                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                                key={i + "-file"}
                                                            >
                                                                <div className="p-2">
                                                                    <rt.Row className="align-items-center">
                                                                        <rt.Col className="col-auto">
                                                                            <img
                                                                                data-dz-thumbnail=""
                                                                                height="80"
                                                                                className="avatar-sm rounded bg-light"
                                                                                alt={f.name}
                                                                                src={f.preview}
                                                                            />
                                                                        </rt.Col>
                                                                        <rt.Col>
                                                                            <Link
                                                                                to="#"
                                                                                className="text-muted font-weight-bold"
                                                                            >
                                                                                {f.name}
                                                                            </Link>
                                                                            <p className="mb-0">
                                                                                <strong>{f.formattedSize}</strong>
                                                                            </p>
                                                                        </rt.Col>
                                                                    </rt.Row>
                                                                </div>
                                                            </rt.Card>
                                                        )
                                                    })}
                                                </rt.Col>
                                            </rt.Row>
                                            <rt.Row>
                                                <rt.Col md={1}>
                                                    <rt.Button
                                                        onClick={e => {
                                                            storeBackgroundImage()
                                                        }}
                                                        color="success"
                                                        className="btn-sm"
                                                    >
                                                        Save<i className="bx bx-photo-album"/>
                                                    </rt.Button>
                                                </rt.Col>
                                            </rt.Row>
                                            <rt.Row>
                                                <rt.Col md={6}>Image Width ({profile.unitmeasurement === "metric" ? "in meters" : "in feet"})</rt.Col>
                                                <div className="col-md-6">
                                                    <input
                                                        className="form-control"
                                                        onChange={() => {
                                                            setBackgroundWidth(event.target.value)
                                                        }}
                                                        value={backgroundWidth}
                                                        type="number"
                                                        defaultValue="100"
                                                        id="backgroundWidth"
                                                    />
                                                </div>
                                            </rt.Row>

                                        </div>
                                    }

                                    {currLayer == 'terrain' && terrainExists &&
                                        <rt.Row>
                                            <rt.Col md={5}>
                                                <StorageImage style={{width: '100px'}}
                                                              alt="backgroundImage"
                                                              imgKey={"designer_" + username + "_background.png"}
                                                              accessLevel="guest"
                                                              onStorageGetError={(error) => console.error(error)}
                                                />
                                            </rt.Col>
                                        </rt.Row>
                                    }

                                    {currLayer == 'structure' && !(selElement && layerOf(selElement) === 'structure') &&
                                        <rt.Col md={4}>
                                            <label style={{
                                                backgroundColor: tool == "structure" ? "#99A88D" : "#BEC8B6",
                                                width: "70px",
                                                height: "70px",
                                                display: "flex",       // Enables flexbox
                                                flexDirection: "column", // Stacks items vertically
                                                alignItems: "center",   // Centers horizontally
                                                justifyContent: "center" // Centers vertically
                                            }}
                                                   onClick={() => {
                                                       if (tool == "structure") {
                                                           // Turn off Add mode → back to select.
                                                           enableTool("selectTool");
                                                           setTool("select");
                                                       } else {
                                                           enableTool("structuresTool");
                                                           setTool("structure");
                                                       }
                                                   }}
                                                   className={
                                                       tool == "structure"
                                                           ? "btn btn-success active"
                                                           : "btn btn-success"
                                                   }
                                            >
                                                <i className="bx bx-building-house" style={{fontSize: "22px"}}/>
                                                <span style={{fontSize: "0.75em", textAlign: "center", lineHeight: 1.1, marginTop: "4px"}}>Add Structure</span>
                                            </label>
                                        </rt.Col>
                                    }

                                    {currLayer == 'path' && !(selElement && layerOf(selElement) === 'path') &&
                                        <rt.Col md={4}>
                                            <label style={{
                                                backgroundColor: tool == "access" ? "#99A88D" : "#BEC8B6",
                                                width: "70px",
                                                height: "70px",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}
                                                   onClick={() => {
                                                       if (tool == "access") {
                                                           // Turn off Add mode → back to select.
                                                           enableTool("selectTool");
                                                           setTool("select");
                                                       } else {
                                                           enableTool("accessTool");
                                                           setTool("access");
                                                           if (!accessFill) pickFill("gravel");
                                                       }
                                                   }}
                                                   className={
                                                       tool == "access"
                                                           ? "btn btn-success active"
                                                           : "btn btn-success"
                                                   }
                                            >
                                                <i className="fas fa-route" style={{fontSize: "22px"}}/>
                                                <span style={{fontSize: "0.75em", textAlign: "center", lineHeight: 1.1, marginTop: "4px"}}>Add Path</span>
                                            </label>
                                        </rt.Col>
                                    }
                                    {currLayer === 'terrain' && visibility.terrain && (
                                        <div>
                                            <rt.Row style={{paddingTop: "0px"}}>
                                                <rt.Col><b>Garden Background</b></rt.Col>
                                            </rt.Row>

                                            <rt.Row style={{marginLeft: "10px", paddingTop: "8px"}}>
                                                {TILE_OPTIONS.map(tile => {
                                                    const selected = backgroundType === tile.key;

                                                    return (
                                                        <rt.Col
                                                            md={3}
                                                            key={tile.key}
                                                            style={{
                                                                marginBottom: "12px",     // ✅ vertical gap
                                                                paddingLeft: "6px",       // ✅ horizontal gap
                                                                paddingRight: "6px",
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "center",
                                                                cursor: "pointer"
                                                            }}
                                                            onClick={() => {
                                                                setBackgroundType(tile.key);
                                                                setGardenBackground(tile.key, backgroundOpacity / 100, true);
                                                            }}
                                                        >
                                                            {/* Compact square swatch */}
                                                            <div
                                                                style={{
                                                                    width: "36px",
                                                                    height: "36px",
                                                                    borderRadius: "4px",
                                                                    backgroundColor: selected ? "#F2F2F2" : "#FAFAFA",
                                                                    border: selected ? "3px solid #222" : "1px solid #AAA",
                                                                    boxSizing: "border-box",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    position: "relative",
                                                                    overflow: "hidden"
                                                                }}
                                                            >
                                                                {tile.img ? (
                                                                    <StorageImage
                                                                        style={{
                                                                            width: "100%",
                                                                            height: "100%",
                                                                            objectFit: "cover"
                                                                        }}
                                                                        alt={tile.label}
                                                                        imgKey={tile.img}
                                                                        accessLevel="guest"
                                                                    />
                                                                ) : (
                                                                    <>
                                                                        {/* Neutral fill */}
                                                                        <div
                                                                            style={{
                                                                                position: "absolute",
                                                                                inset: 0,
                                                                                backgroundColor: "#EEE"
                                                                            }}
                                                                        />
                                                                        {/* Diagonal slash */}
                                                                        <div
                                                                            style={{
                                                                                position: "absolute",
                                                                                width: "140%",
                                                                                height: "2px",
                                                                                backgroundColor: "#888",
                                                                                transform: "rotate(-45deg)"
                                                                            }}
                                                                        />
                                                                    </>
                                                                )}
                                                            </div>


                                                            {/* Centered label */}
                                                            <div
                                                                style={{
                                                                    fontSize: "11px",
                                                                    marginTop: "4px",
                                                                    textAlign: "center",
                                                                    lineHeight: "1.2",
                                                                    color: selected ? "#2F6F2F" : "#444"
                                                                }}
                                                            >
                                                                {tile.label}
                                                            </div>
                                                        </rt.Col>
                                                    );
                                                })}
                                            </rt.Row>
                                        </div>


                                    )}

                                    {currLayer == 'path' && tool == 'access' && !foo.lineStarted &&
                                        <div style={{paddingTop: "10px"}}>
                                            <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "6px"}}>
                                                <span style={{fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.04em", color: "#6f7a72"}}>Fill</span>
                                                <span
                                                    title="Return to Select"
                                                    style={{cursor: "pointer", color: "#8a3d3d", display: "flex", alignItems: "center", gap: "5px"}}
                                                    onClick={() => {
                                                        enableTool("selectTool");
                                                        setTool("select");
                                                    }}
                                                >
                                                    <span style={{fontSize: "13px", fontWeight: 600}}>Cancel</span>
                                                    <i className="fas fa-times" style={{fontSize: "20px"}}/>
                                                </span>
                                            </div>
                                            <rt.Row style={{marginLeft: "4px"}}>
                                                {[
                                                    {key: "soil", label: "Dark Soil"},
                                                    {key: "light_soil", label: "Light Soil"},
                                                    {key: "fence", label: "Fence"},
                                                    {key: "brick", label: "Brick"},
                                                    {key: "gravel", label: "Gravel"},
                                                    {key: "grass", label: "Grass"},
                                                    {key: "deck", label: "Deck"},
                                                    {key: "mulch", label: "Mulch"},
                                                    {key: "water", label: "Water"},
                                                ].map(({key, label}) => (
                                                    <rt.Col md={3} key={key} style={{paddingLeft: "4px", paddingRight: "4px", marginBottom: "8px"}}>
                                                        <div
                                                            onClick={() => pickFill(key)}
                                                            style={{
                                                                cursor: "pointer",
                                                                border: accessFill == key ? "2px solid #556B2F" : "2px solid transparent",
                                                                borderRadius: "4px",
                                                                padding: "2px",
                                                            }}
                                                        >
                                                            <StorageImage style={{width: "100%", display: "block"}}
                                                                          alt={label}
                                                                          imgKey={"planner_static/fill_" + key + ".png"}
                                                                          accessLevel="guest"
                                                                          onStorageGetError={(error) => console.error(error)}
                                                            />
                                                            <div style={{fontSize: "0.6em", textAlign: "center", color: "#555", marginTop: "2px", lineHeight: 1.1}}>{label}</div>
                                                        </div>
                                                    </rt.Col>
                                                ))}
                                            </rt.Row>
                                            <rt.Row style={{marginTop: "14px"}}>
                                                <rt.Col md={7}>Width ({isMetric ? 'Meters' : 'Feet'})</rt.Col>
                                                <rt.Col md={5}>
                                                    <Editable
                                                        name="thickness"
                                                        value={isMetric ? (foo.accessThickness / metricGridWidth).toFixed(2) : foo.accessThickness / 75}
                                                        display={(value) => {
                                                            return (<span style={{color: "black"}}>{value}</span>);
                                                        }}
                                                        dataType="text"
                                                        showButtons={false}
                                                        mode="inline"
                                                        handleSubmit={newAcccessProperties}
                                                    />
                                                </rt.Col>
                                            </rt.Row>
                                            <rt.Row style={{paddingTop: "10px"}}>
                                                <rt.Col>
                                                    <div style={{fontSize: "11px", color: "#888", fontStyle: "italic"}}>
                                                        Click on the canvas to drop a path, then drag its points to shape it.
                                                    </div>
                                                </rt.Col>
                                            </rt.Row>
                                        </div>
                                    }

                                    {currLayer == 'structure' && tool == 'structure' &&
                                        <div style={{paddingTop: "10px", width: "100%"}}>
                                        <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "6px"}}>
                                            <span style={{fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.04em", color: "#6f7a72"}}>Add Structure</span>
                                            <span
                                                title="Return to Select"
                                                style={{cursor: "pointer", color: "#8a3d3d", display: "flex", alignItems: "center", gap: "5px"}}
                                                onClick={() => {
                                                    enableTool("selectTool");
                                                    setTool("select");
                                                }}
                                            >
                                                <span style={{fontSize: "13px", fontWeight: 600}}>Cancel</span>
                                                <i className="fas fa-times" style={{fontSize: "20px"}}/>
                                            </span>
                                        </div>
                                        <div style={{marginBottom: "10px"}}>
                                            <PlantSelect
                                                plantOptions={structureData.map(structureItem => ({
                                                    key: structureItem.name,
                                                    label: structureItem.name
                                                }))}
                                                value={""}
                                                placeholder="Search structures..."
                                                onChange={(val) => {
                                                    updateStructureOptions(val);
                                                    setTool("structure");
                                                }}
                                            />
                                        </div>
                                        </div>
                                    }

                                    {tool == "structure" && showSelectedStructure &&
                                        <div>
                                            <rt.Row>
                                                <rt.Col md={6}>
                                                    <StorageImage style={{width: '100px'}}
                                                                  alt={foo.selectedStructure.name}
                                                                  imgKey={"planner_structures/planner_" + foo.selectedStructure.name.toLowerCase().replace(" ", "_").replace("(", "").replace(")", "").replace(",", "_").replace(" ", "_") + "_icon.png"}
                                                                  accessLevel="guest"
                                                                  onStorageGetError={(error) => console.error(error)}
                                                    /><br/>
                                                    <span>{foo.selectedStructure.name}</span>
                                                </rt.Col>
                                                <rt.Col md={6}>
                                                    <span>Left mouse-click on design area to place.</span>
                                                </rt.Col>
                                            </rt.Row>
                                            <rt.Row style={{marginTop: "20px"}}>
                                                <rt.Col md={6}>Width
                                                    ({profile.unitmeasurement === "metric" ? ' Meters' : ' Feet'})
                                                </rt.Col>
                                                <rt.Col md={6}>
                                                    <Editable
                                                        name="width"
                                                        value={isMetric ? (foo.currStructure.width * gridWidth / metricGridWidth).toFixed(2) : foo.currStructure.width}
                                                        display={(value) => {
                                                            return (<span style={{color: "black"}}>{value}</span>);
                                                        }}
                                                        dataType="text"
                                                        showButtons={false}
                                                        mode="inline"
                                                        handleSubmit={newStructureProperties}
                                                    />
                                                </rt.Col>
                                            </rt.Row>
                                            <rt.Row style={{marginTop: "20px"}}>
                                                <rt.Col md={6}>Height
                                                    ({profile.unitmeasurement === "metric" ? ' Meters' : ' Feet'})
                                                </rt.Col>
                                                <rt.Col md={6}>
                                                    <Editable
                                                        name="height"
                                                        value={isMetric ? (foo.selectedStructure.height * gridWidth / metricGridWidth).toFixed(2) : foo.selectedStructure.height}
                                                        display={(value) => {
                                                            return (<span style={{color: "black"}}>{value}</span>);
                                                        }}
                                                        dataType="text"
                                                        showButtons={false}
                                                        mode="inline"
                                                        handleSubmit={newStructureProperties}
                                                    />
                                                </rt.Col>
                                            </rt.Row>
                                            <rt.Row style={{marginTop: "20px"}}>
                                                <rt.Col md={6}>Rotation</rt.Col>
                                                <rt.Col md={6}>
                                                    <Editable
                                                        name="rotation"
                                                        value={foo.selectedStructure.rotation}
                                                        display={(value) => {
                                                            return (<span style={{color: "black"}}>{value}</span>);
                                                        }}
                                                        dataType="text"
                                                        showButtons={false}
                                                        mode="inline"
                                                        handleSubmit={newStructureProperties}
                                                    />
                                                </rt.Col>
                                            </rt.Row>
                                        </div>
                                    }

                                    {currLayer === "area" && activeArea && (
                                        <div
                                            style={{
                                                width: "100%",
                                                height: "220px",               // 👈 slightly smaller fixed height
                                                display: "flex",
                                                flexDirection: "column",
                                                backgroundColor: "#F9FBF9",
                                                borderRadius: "4px",
                                                border: "1px solid #D6DDD6",
                                                overflow: "hidden",
                                                flexShrink: 0,
                                                marginBottom: "12px",
                                            }}
                                        >
                                            {/* ───────── Header (fixed) ───────── */}
                                            <div
                                                style={{
                                                    padding: "6px 10px",
                                                    borderBottom: "1px solid #E0E6E0",
                                                    backgroundColor: "#EEF2EE",
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "11px",
                                                        color: "#6f7a72",
                                                        textTransform: "uppercase",
                                                        letterSpacing: "0.04em",
                                                    }}
                                                >
                                                    Current Area
                                                </div>

                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        marginTop: "2px",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "14px",
                                                            fontWeight: 600,
                                                            color: activeArea ? "#2f3a34" : "#9aa39c",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {activeArea ? activeArea.name : "No area selected"}
                                                    </div>

                                                    {activeArea &&
                                                        !activeArea.info?.physical &&
                                                        activeArea.name !== "Unassigned" && (
                                                            <i
                                                                className="fas fa-vector-square"
                                                                title="Add boundary"
                                                                style={{
                                                                    cursor: "pointer",
                                                                    color: "#4F6C60",
                                                                    fontSize: "14px",
                                                                    marginLeft: "8px",
                                                                }}
                                                                onClick={() => {
                                                                    enableTool("linkAreaTool");
                                                                    frame.currArea = activeArea;
                                                                    setMode("area", "link");
                                                                }}
                                                            />
                                                        )}

                                                    {/* Delete Area */}
                                                    {activeArea && activeArea.name !== "Unassigned" && (
                                                        <i
                                                            className="bx bx-trash"
                                                            title="Delete area"
                                                            style={{
                                                                cursor: "pointer",
                                                                color: "#8a3d3d",
                                                                fontSize: "16px",
                                                            }}
                                                            onClick={() => {
                                                                deleteArea(activeArea.id);
                                                                setActiveAreaId(null);
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>

                                            {/* ───────── Scrollable content ───────── */}
                                            <div
                                                style={{
                                                    flex: 1,
                                                    overflowY: "auto",
                                                    padding: "6px 8px",
                                                }}
                                            >
                                                {activeArea &&
                                                    (() => {
                                                        const plants = activeArea.plants || [];
                                                        const placed = plants.filter(p => p.species && p.location);
                                                        const unplaced = plants.filter(p => p.species && !p.location);

                                                        return (
                                                            <table
                                                                style={{
                                                                    width: "100%",
                                                                    borderCollapse: "collapse",
                                                                }}
                                                            >
                                                                <tbody>
                                                                {/* Placed */}
                                                                {placed.length > 0 && (
                                                                    <>
                                                                        <tr>
                                                                            <td
                                                                                colSpan={3}
                                                                                style={{
                                                                                    fontSize: "11px",
                                                                                    color: "#6f7a72",
                                                                                    padding: "4px 0",
                                                                                    textTransform: "uppercase",
                                                                                }}
                                                                            >
                                                                                Placed
                                                                            </td>
                                                                        </tr>
                                                                        {placed.map((plant, i) => (
                                                                            <tr key={plant.id || i}>
                                                                                <td style={{width: "32px"}}>
                                                                                    <StorageImage
                                                                                        style={{width: "24px"}}
                                                                                        alt={plant.species}
                                                                                        imgKey={plant.designerIconKey ? plant.designerIconKey : `planner_icons/planner_${plant.species
                                                                                            .toLowerCase()
                                                                                            .replace(/[(),]/g, "").replace(/\s+/g, "_")}_icon.png`}
                                                                                        accessLevel="guest"
                                                                                    />
                                                                                </td>
                                                                                <td style={{fontSize: "13px"}}>
                                                                                    {plant.species} ({plant.numPlants})
                                                                                </td>
                                                                                <td/>
                                                                            </tr>
                                                                        ))}
                                                                    </>
                                                                )}

                                                                {/* Unplaced */}
                                                                {unplaced.length > 0 && (
                                                                    <>
                                                                        <tr>
                                                                            <td
                                                                                colSpan={3}
                                                                                style={{
                                                                                    fontSize: "11px",
                                                                                    color: "#6f7a72",
                                                                                    padding: "8px 0 4px",
                                                                                    textTransform: "uppercase",
                                                                                }}
                                                                            >
                                                                                Unplaced
                                                                            </td>
                                                                        </tr>

                                                                        {unplaced.map((plant, i) => {
                                                                            const active = existingPlant?.id === plant.id;

                                                                            return (
                                                                                <tr key={plant.id || i}>
                                                                                    <td style={{width: "32px"}}>
                                                                                        <StorageImage
                                                                                            style={{width: "24px"}}
                                                                                            alt={plant.species}
                                                                                            imgKey={plant.designerIconKey ? plant.designerIconKey : `planner_icons/planner_${plant.species
                                                                                                .toLowerCase()
                                                                                                .replace(/[(),]/g, "").replace(/\s+/g, "_")}_icon.png`}
                                                                                            accessLevel="guest"
                                                                                        />
                                                                                    </td>

                                                                                    <td style={{fontSize: "13px"}}>
                                                                                        {plant.species} ({plant.numPlants})
                                                                                    </td>

                                                                                    <td style={{textAlign: "right"}}>
                                                                                        <i
                                                                                            className={`fas ${
                                                                                                active ? "fa-times" : "fa-map-marker-alt"
                                                                                            }`}
                                                                                            title={
                                                                                                active
                                                                                                    ? "Cancel placement"
                                                                                                    : "Place in designer"
                                                                                            }
                                                                                            style={{
                                                                                                cursor: "pointer",
                                                                                                color: active ? "#8a3d3d" : "#4F6C60",
                                                                                            }}
                                                                                            onClick={() => {
                                                                                                if (active) {
                                                                                                    setExistingPlant();
                                                                                                    foo.existingPlant = undefined;
                                                                                                    setMode();
                                                                                                } else {
                                                                                                    if (!plant.id) plant.id = uuidv4();
                                                                                                    setExistingPlant(plant);
                                                                                                    foo.existingPlant = plant;
                                                                                                    setMode("plant");
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })}
                                                                    </>
                                                                )}

                                                                {placed.length === 0 && unplaced.length === 0 && (
                                                                    <tr>
                                                                        <td
                                                                            colSpan={3}
                                                                            style={{
                                                                                fontSize: "12px",
                                                                                color: "#9aa39c",
                                                                                fontStyle: "italic",
                                                                            }}
                                                                        >
                                                                            No plants in this area yet.
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                                </tbody>
                                                            </table>
                                                        );
                                                    })()}
                                            </div>
                                        </div>
                                    )}


                                    {currLayer === "area" && (
                                        <div style={{width: "100%", marginBottom: "12px"}}>

                                            {/* ───────── Header row ───────── */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    marginBottom: "6px",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "12px",
                                                        fontWeight: 600,
                                                        color: "#2f3a34",
                                                    }}
                                                >
                                                    Areas
                                                </div>

                                                {/* Add Area icon */}
                                                <i
                                                    className="fas fa-plus"
                                                    title="Add new area"
                                                    style={{
                                                        cursor: "pointer",
                                                        fontSize: "14px",
                                                        color: "#4F6C60",
                                                        padding: "4px",
                                                    }}
                                                    onClick={() => {
                                                        enableTool("addAreaTool");
                                                        setMode("area", "add");
                                                        setTool("newArea");
                                                        setNewAreaModal(true);
                                                    }}
                                                />
                                            </div>

                                            {/* ───────── Instruction (NOT scrollable) ───────── */}
                                            <div
                                                style={{
                                                    fontSize: "11px",
                                                    color: "#7A847D",
                                                    fontStyle: "italic",
                                                    marginBottom: "6px",
                                                }}
                                            >
                                                Click an area to view details above.
                                            </div>

                                            {/* ───────── Scrollable list ───────── */}
                                            <div
                                                style={{
                                                    maxHeight: "180px",
                                                    overflowY: "auto",
                                                    paddingRight: "2px",
                                                }}
                                            >
                                                {visibleAreas.map(area => {
                                                    const selected = activeAreaId === area.id;

                                                    return (
                                                        <div
                                                            key={area.id}
                                                            onClick={() => setActiveAreaId(area.id)}
                                                            style={{
                                                                padding: "6px 8px",
                                                                marginBottom: "4px",
                                                                borderRadius: "4px",
                                                                cursor: "pointer",
                                                                backgroundColor: selected ? "#99A88D" : "#BEC8B6",
                                                                color: "#FFFFFF",
                                                                fontSize: "13px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
            <span
                style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                }}
            >
              {area.name}
            </span>

                                                            {/* Boundary missing indicator */}
                                                            {!area.info?.physical && area.name !== "Unassigned" && (
                                                                <i
                                                                    className="fas fa-vector-square"
                                                                    title="Boundary not drawn"
                                                                    style={{
                                                                        fontSize: "12px",
                                                                        opacity: 0.85,
                                                                    }}
                                                                />
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}


                                </rt.Row>

                                {currLayer == 'border' && tool == 'border' && !(selElement && selElement.type == 'border') &&
                                    <div style={{paddingTop: "10px"}}>
                                        <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "6px"}}>
                                            <span style={{fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.04em", color: "#6f7a72"}}>
                                                Shape
                                            </span>
                                            <span
                                                title="Return to Select"
                                                style={{cursor: "pointer", color: "#8a3d3d", display: "flex", alignItems: "center", gap: "5px"}}
                                                onClick={() => {
                                                    enableTool("selectTool");
                                                    setTool("select");
                                                }}
                                            >
                                                <span style={{fontSize: "13px", fontWeight: 600}}>Cancel</span>
                                                <i className="fas fa-times" style={{fontSize: "20px"}}/>
                                            </span>
                                        </div>

                                        <rt.Row>
                                            <rt.Col md={4}>
                                                <label style={{
                                                    backgroundColor: borderTool == "line" ? "#99A88D" : "#BEC8B6",
                                                    width: "70px",
                                                    height: "70px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}
                                                       onClick={() => {
                                                           setMode("border", "line");
                                                           setBorderTool("line");
                                                           if (foo) foo.borderShape = "line";
                                                       }}
                                                       className={borderTool == "line" ? "btn btn-success active" : "btn btn-success"}
                                                >
                                                    <i className="fas fa-draw-polygon fa-2x"/>
                                                    <span style={{fontSize: "0.75em", marginTop: "4px"}}>Custom</span>
                                                </label>
                                            </rt.Col>
                                            <rt.Col md={4}>
                                                <label style={{
                                                    backgroundColor: borderTool == "rectangle" ? "#99A88D" : "#BEC8B6",
                                                    width: "70px",
                                                    height: "70px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}
                                                       onClick={() => {
                                                           setMode("border", "rectangle");
                                                           setBorderTool("rectangle");
                                                           if (foo) foo.borderShape = "rectangle";
                                                       }}
                                                       className={borderTool == "rectangle" ? "btn btn-success active" : "btn btn-success"}
                                                >
                                                    <i className="fas fa-square fa-2x"/>
                                                    <span style={{fontSize: "0.75em", marginTop: "4px"}}>Rectangle</span>
                                                </label>
                                            </rt.Col>
                                            <rt.Col md={4}>
                                                <label style={{
                                                    backgroundColor: borderTool == "circle" ? "#99A88D" : "#BEC8B6",
                                                    width: "70px",
                                                    height: "70px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}
                                                       onClick={() => {
                                                           setMode("border", "circle");
                                                           setBorderTool("circle");
                                                           if (foo) foo.borderShape = "circle";
                                                       }}
                                                       className={borderTool == "circle" ? "btn btn-success active" : "btn btn-success"}
                                                >
                                                    <i className="fas fa-circle fa-2x"/>
                                                    <span style={{fontSize: "0.75em", marginTop: "4px"}}>Circle</span>
                                                </label>
                                            </rt.Col>
                                        </rt.Row>

                                        <rt.Row style={{paddingTop: "16px"}}>
                                            <rt.Col>
                                                <div style={{fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.04em", color: "#6f7a72", marginBottom: "6px"}}>Fill</div>
                                            </rt.Col>
                                        </rt.Row>
                                        <rt.Row style={{marginLeft: "4px"}}>
                                            {[
                                                {key: "soil", label: "Dark Soil"},
                                                {key: "light_soil", label: "Light Soil"},
                                                {key: "fence", label: "Fence"},
                                                {key: "brick", label: "Brick"},
                                                {key: "gravel", label: "Gravel"},
                                                {key: "grass", label: "Grass"},
                                                {key: "deck", label: "Deck"},
                                                {key: "mulch", label: "Mulch"},
                                                {key: "water", label: "Water"},
                                            ].map(({key, label}) => (
                                                <rt.Col md={3} key={key} style={{paddingLeft: "4px", paddingRight: "4px", marginBottom: "8px"}}>
                                                    <div
                                                        onClick={() => pickBorderFill(key)}
                                                        style={{
                                                            cursor: "pointer",
                                                            border: borderFill == key ? "2px solid #556B2F" : "2px solid transparent",
                                                            borderRadius: "4px",
                                                            padding: "2px",
                                                        }}
                                                    >
                                                        <rt.Input name="fill_type" value={"fill_" + key} type="radio"
                                                                  checked={borderFill == key}
                                                                  onChange={() => pickBorderFill(key)}
                                                                  style={{display: "none"}}
                                                        />
                                                        <StorageImage style={{width: "100%", display: "block"}}
                                                                      alt={label}
                                                                      imgKey={"planner_static/fill_" + key + ".png"}
                                                                      accessLevel="guest"
                                                                      onStorageGetError={(error) => console.error(error)}
                                                        />
                                                        <div style={{fontSize: "0.6em", textAlign: "center", color: "#555", marginTop: "2px", lineHeight: 1.1}}>{label}</div>
                                                    </div>
                                                </rt.Col>
                                            ))}
                                        </rt.Row>

                                        <rt.Row style={{paddingTop: "10px"}}>
                                            <rt.Col>
                                                <div style={{fontSize: "11px", color: "#888", fontStyle: "italic"}}>
                                                    Click and drag on the canvas to place a shape.
                                                </div>
                                            </rt.Col>
                                        </rt.Row>
                                    </div>
                                }

                                {(tool === "select" || (currLayer === 'border' && selElement?.type === 'border')) && selElement && (
                                    selElement.type === "multi"
                                        ? <MultiSelectionPanel selElement={selElement}/>
                                        : <SingleSelectionPanel selElement={selElement}/>
                                )}
                                {currLayer == 'border' && selElement && selElement.type == 'border' && selElement.tool != 'line' && foo && foo.selectedElement &&
                                    <div style={{paddingTop: "10px"}}>
                                        <rt.Row style={{marginTop: "10px"}}>
                                            <rt.Col md={7}>X position ({isMetric ? 'm' : 'ft'})</rt.Col>
                                            <rt.Col md={5}>
                                                <Editable
                                                    name="locationx"
                                                    value={isMetric ? (foo.selectedElement.location.x / metricGridWidth).toFixed(2) : (foo.selectedElement.location.x / gridWidth).toFixed(1)}
                                                    display={(value) => {
                                                        return (<span style={{color: "black"}}>{value}</span>);
                                                    }}
                                                    dataType="text"
                                                    showButtons={false}
                                                    mode="inline"
                                                    handleSubmit={changeBorder}
                                                />
                                            </rt.Col>
                                        </rt.Row>
                                        <rt.Row style={{marginTop: "10px"}}>
                                            <rt.Col md={7}>Y position ({isMetric ? 'm' : 'ft'})</rt.Col>
                                            <rt.Col md={5}>
                                                <Editable
                                                    name="locationy"
                                                    value={isMetric ? (foo.selectedElement.location.y / metricGridWidth).toFixed(2) : (foo.selectedElement.location.y / gridHeight).toFixed(1)}
                                                    display={(value) => {
                                                        return (<span style={{color: "black"}}>{value}</span>);
                                                    }}
                                                    dataType="text"
                                                    showButtons={false}
                                                    mode="inline"
                                                    handleSubmit={changeBorder}
                                                />
                                            </rt.Col>
                                        </rt.Row>
                                        {selElement.tool == 'rectangle' &&
                                            <rt.Row style={{marginTop: "10px"}}>
                                                <rt.Col md={7}>Width ({isMetric ? 'm' : 'ft'})</rt.Col>
                                                <rt.Col md={5}>
                                                    <Editable
                                                        name="width"
                                                        value={isMetric ? (foo.selectedElement.width * gridWidth / metricGridWidth).toFixed(2) : foo.selectedElement.width.toFixed(1)}
                                                        display={(value) => {
                                                            return (<span style={{color: "black"}}>{value}</span>);
                                                        }}
                                                        dataType="text"
                                                        showButtons={false}
                                                        mode="inline"
                                                        handleSubmit={changeBorder}
                                                    />
                                                </rt.Col>
                                            </rt.Row>
                                        }
                                        {selElement.tool == 'rectangle' &&
                                            <rt.Row style={{marginTop: "10px"}}>
                                                <rt.Col md={7}>Height ({isMetric ? 'm' : 'ft'})</rt.Col>
                                                <rt.Col md={5}>
                                                    <Editable
                                                        name="height"
                                                        value={isMetric ? (foo.selectedElement.height * gridWidth / metricGridWidth).toFixed(2) : foo.selectedElement.height.toFixed(1)}
                                                        display={(value) => {
                                                            return (<span style={{color: "black"}}>{value}</span>);
                                                        }}
                                                        dataType="text"
                                                        showButtons={false}
                                                        mode="inline"
                                                        handleSubmit={changeBorder}
                                                    />
                                                </rt.Col>
                                            </rt.Row>
                                        }
                                        {selElement.tool == 'circle' &&
                                            <rt.Row style={{marginTop: "10px"}}>
                                                <rt.Col md={7}>Diameter ({isMetric ? 'm' : 'ft'})</rt.Col>
                                                <rt.Col md={5}>
                                                    <Editable
                                                        name="diameter"
                                                        value={isMetric ? (foo.selectedElement.diameter * gridWidth / metricGridWidth).toFixed(2) : foo.selectedElement.diameter.toFixed(1)}
                                                        display={(value) => {
                                                            return (<span style={{color: "black"}}>{value}</span>);
                                                        }}
                                                        dataType="text"
                                                        showButtons={false}
                                                        mode="inline"
                                                        handleSubmit={changeBorder}
                                                    />
                                                </rt.Col>
                                            </rt.Row>
                                        }
                                    </div>
                                }

                                {tool == "select" && selElement && selElement.subtype == 'access' &&
                                    <div>
                                        <rt.Row style={{paddingTop: "20px"}}>
                                            <rt.Col md={6}>Width
                                                ({profile.unitmeasurement === "metric" ? ' Meters' : ' Feet'})
                                            </rt.Col>
                                            <rt.Col md={6}>
                                                <Editable
                                                    name="thickness"
                                                    value={isMetric ? (selElement.thickness * gridWidth / metricGridWidth).toFixed(2) : selElement["thickness"]}
                                                    showButtons={false}
                                                    display={(value) => {
                                                        return (<span style={{color: "black"}}>{value}</span>);
                                                    }}
                                                    dataType="text"
                                                    mode="inline"
                                                    handleSubmit={changeElement}
                                                />
                                            </rt.Col>
                                        </rt.Row>
                                    </div>
                                }
                                {foo && foo.selectedElement && selElement && ((tool == "select" && selElement.subtype == 'access') || (currLayer == 'border' && selElement.type == 'border')) &&
                                    <div>
                                        <rt.Row style={{paddingTop: "14px"}}>
                                            <rt.Col>
                                                <div style={{fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.04em", color: "#6f7a72", marginBottom: "6px"}}>Fill</div>
                                            </rt.Col>
                                        </rt.Row>
                                        <rt.Row style={{marginLeft: "4px"}}>
                                            {[
                                                {key: "soil", label: "Dark Soil"},
                                                {key: "light_soil", label: "Light Soil"},
                                                {key: "fence", label: "Fence"},
                                                {key: "brick", label: "Brick"},
                                                {key: "gravel", label: "Gravel"},
                                                {key: "grass", label: "Grass"},
                                                {key: "deck", label: "Deck"},
                                                {key: "mulch", label: "Mulch"},
                                                {key: "water", label: "Water"},
                                            ].map(({key, label}) => (
                                                <rt.Col md={3} key={key} style={{paddingLeft: "4px", paddingRight: "4px", marginBottom: "8px"}}>
                                                    <div
                                                        onClick={() => changeFill(key)}
                                                        style={{
                                                            cursor: "pointer",
                                                            border: foo.selectedElement.fill == key ? "2px solid #556B2F" : "2px solid transparent",
                                                            borderRadius: "4px",
                                                            padding: "2px",
                                                        }}
                                                    >
                                                        <StorageImage style={{width: "100%", display: "block"}}
                                                                      alt={label}
                                                                      imgKey={"planner_static/fill_" + key + ".png"}
                                                                      accessLevel="guest"
                                                                      onStorageGetError={(error) => console.error(error)}
                                                        />
                                                        <div style={{fontSize: "0.6em", textAlign: "center", color: "#555", marginTop: "2px", lineHeight: 1.1}}>{label}</div>
                                                    </div>
                                                </rt.Col>
                                            ))}
                                        </rt.Row>
                                    </div>
                                }

                                {tool == "select" && selElement && selElement.type == 'structure' && selElement.subtype != 'access' &&
                                    <div>
                                        <rt.Row style={{paddingTop: "20px"}}>
                                            <rt.Col md={6}>Width ({isMetric ? 'Meters' : 'Feet'})</rt.Col>
                                            <rt.Col md={6}>
                                                <Editable
                                                    name="width"
                                                    value={isMetric ? (selElement.width * gridWidth / metricGridWidth).toFixed(2) : selElement["width"]}
                                                    showButtons={false}
                                                    display={(value) => {
                                                        return (<span style={{color: "black"}}>{value}</span>);
                                                    }}
                                                    dataType="text"
                                                    mode="inline"
                                                    handleSubmit={changeStructure}
                                                />
                                            </rt.Col>
                                        </rt.Row>
                                        <rt.Row style={{paddingTop: "20px"}}>
                                            <rt.Col md={6}>Height ({isMetric ? 'Meters' : 'Feet'})</rt.Col>
                                            <rt.Col md={6}>
                                                <Editable
                                                    name="height"
                                                    value={isMetric ? (selElement.height * gridWidth / metricGridWidth).toFixed(2) : selElement["height"]}
                                                    showButtons={false}
                                                    display={(value) => {
                                                        return (<span style={{color: "black"}}>{value}</span>);
                                                    }}
                                                    dataType="text"
                                                    mode="inline"
                                                    handleSubmit={changeStructure}
                                                />
                                            </rt.Col>
                                        </rt.Row>
                                        <rt.Row style={{paddingTop: "20px"}}>
                                            <rt.Col md={6}>Rotation</rt.Col>
                                            <rt.Col md={6}>
                                                <Editable
                                                    name="rotation"
                                                    value={selElement["rotation"]}
                                                    showButtons={false}
                                                    display={(value) => {
                                                        return (<span style={{color: "black"}}>{value}</span>);
                                                    }}
                                                    dataType="text"
                                                    mode="inline"
                                                    handleSubmit={changeStructure}
                                                />
                                            </rt.Col>
                                        </rt.Row>
                                    </div>
                                }


                                {tool === "select" &&
                                    selElement &&
                                    selElement.type === "plant" && (
                                        <div
                                            style={{
                                                width: "100%",
                                                marginTop: "16px",
                                                backgroundColor: "#F9FBF9",
                                                border: "1px solid #D6DDD6",
                                                borderRadius: "4px",
                                                padding: "12px",
                                            }}
                                        >

                                            {/* Header */}
                                            <div
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: 600,
                                                    marginBottom: "10px",
                                                    color: "#2f3a34",
                                                    textTransform: "uppercase",
                                                    letterSpacing: "0.03em",
                                                }}
                                            >
                                                Selected Plant
                                            </div>

                                            {/* Species Row */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                    padding: "8px 10px",
                                                    marginBottom: "14px",
                                                    backgroundColor: "#EEF2EE",
                                                    borderRadius: "4px",
                                                }}
                                            >
                                                <StorageImage
                                                    style={{ width: "26px", height: "26px" }}
                                                    alt={selElement.plant.name}
                                                    imgKey={selElement.plant.designerIconKey ? selElement.plant.designerIconKey : `planner_icons/planner_${selElement.plant.name
                                                        .toLowerCase()
                                                        .replace(/[(),]/g, "").replace(/\s+/g, "_")}_icon.png`}
                                                    accessLevel="guest"
                                                />

                                                <div
                                                    style={{
                                                        fontSize: "14px",
                                                        fontWeight: 600,
                                                        color: "#2f3a34",
                                                    }}
                                                >
                                                    {selElement.plant.name}
                                                </div>
                                            </div>

                                            {/* Properties */}
                                            <PropertyRow label="Variety">
                                                <Editable
                                                    name="variety"
                                                    value={selElement.plant.variety}
                                                    dataType="text"
                                                    showButtons={false}
                                                    mode="inline"
                                                    handleSubmit={changeElement}
                                                />
                                            </PropertyRow>

                                            <PropertyRow label="Season Rotation">
                                                <Editable
                                                    name="season"
                                                    value={selElement.plant.season_rotation || ""}
                                                    dataType="select"
                                                    showButtons={false}
                                                    options={[
                                                        { value: "", text: "" },
                                                        { value: "Spring", text: "Spring" },
                                                        { value: "Summer", text: "Summer" },
                                                        { value: "Fall", text: "Fall" },
                                                        { value: "Winter", text: "Winter" },
                                                    ]}
                                                    mode="inline"
                                                    handleSubmit={changeElement}
                                                />
                                            </PropertyRow>

                                            <PropertyRow label="Number of Plants">
                                                <Editable
                                                    name="numPlants"
                                                    value={selElement.plant.numPlants}
                                                    dataType="text"
                                                    showButtons={false}
                                                    mode="inline"
                                                    handleSubmit={changeElement}
                                                />
                                            </PropertyRow>


                                            {selElement.plant.numPlants > 1 && (
                                                <>
                                                    <PropertyRow label="Patch Width">
                                                        <Editable
                                                            name="patchWidth"
                                                            value={selElement.numPlantsWidth}
                                                            dataType="text"
                                                            showButtons={false}
                                                            mode="inline"
                                                            handleSubmit={changeElement}
                                                        />
                                                    </PropertyRow>

                                                    <PropertyRow label="Patch Height">
                                                        <Editable
                                                            name="patchHeight"
                                                            value={selElement.numPlantsHeight}
                                                            dataType="text"
                                                            showButtons={false}
                                                            mode="inline"
                                                            handleSubmit={changeElement}
                                                        />
                                                    </PropertyRow>
                                                </>
                                            )}

                                            <PropertyRow label="Size">
                                                <Editable
                                                    name="size"
                                                    value={selElement.plant.size}
                                                    dataType="select"
                                                    showButtons={false}
                                                    options={plantSizeOptions}
                                                    mode="inline"
                                                    handleSubmit={changeElement}
                                                />
                                            </PropertyRow>

                                            <PropertyRow
                                                label={`Spacing (${profile.unitmeasurement === "metric" ? "cm" : "Inches"})`}
                                            >
                                                <Editable
                                                    name="plantSpacing"
                                                    value={isMetric ? (selElement.plant.spacing_between_plants * 2.54).toFixed(1) : selElement.plant.spacing_between_plants}
                                                    dataType="text"
                                                    showButtons={false}
                                                    mode="inline"
                                                    handleSubmit={changeElement}
                                                />
                                            </PropertyRow>

                                            <PropertyRow label="Days to Harvest">
                                                <Editable
                                                    name="daysToHarvest"
                                                    value={selElement.plant.daysToHarvest}
                                                    dataType="text"
                                                    showButtons={false}
                                                    mode="inline"
                                                    handleSubmit={changeElement}
                                                />
                                            </PropertyRow>

                                            <PropertyRow label="Start Date">
                                                <Editable
                                                    name="seedStartDate"
                                                    value={selElement.plant.seedStartDate}
                                                    dataType="date"
                                                    showButtons={false}
                                                    mode="inline"
                                                    handleSubmit={changeElement}
                                                />
                                            </PropertyRow>

                                            <PropertyRow label="Transplant Date">
                                                <Editable
                                                    name="transplantDate"
                                                    value={selElement.plant.transplantDate}
                                                    dataType="date"
                                                    showButtons={false}
                                                    mode="inline"
                                                    handleSubmit={changeElement}
                                                />
                                            </PropertyRow>

                                            <PropertyRow label="Harvest Date">
                                                <Editable
                                                    name="harvestDate"
                                                    value={selElement.plant.harvestDate}
                                                    dataType="date"
                                                    showButtons={false}
                                                    mode="inline"
                                                    handleSubmit={changeElement}
                                                />
                                            </PropertyRow>
                                        </div>
                                    )}


                                {currLayer === "plant" && selectionCount === 0 && (
                                    <>
                                        <div
                                            style={{
                                                fontSize: "11px",
                                                textTransform: "uppercase",
                                                letterSpacing: "0.04em",
                                                color: "#6f7a72",
                                                marginBottom: "4px",
                                            }}
                                        >
                                            Add Plant
                                        </div>

                                        <div style={{marginBottom: "10px"}}>
                                            <PlantSelect
                                                plantOptions={[
                                                    ...plantData.map(plantItem => ({
                                                        key: plantItem.name,
                                                        label: plantItem.name
                                                    })),
                                                    ...(customplants || []).map(cp => ({
                                                        key: cp.species,
                                                        label: `${cp.species} (custom)`
                                                    }))
                                                ]}
                                                value={""}
                                                onChange={(val) => {
                                                    updatePlantOptions(val);     // your existing function
                                                    setTool("plant");            // ensure plant mode
                                                }}
                                            />
                                        </div>

                                        </>
                                    )}


                                        {currLayer === "plant" && (
                                            <div style={{padding: "0px"}}>
                                                {tool === "plant" && showSelectedPlant && foo.selectedPlant && (

                                                    <div
                                                        style={{
                                                            border: "1px solid #D9E2D8",
                                                            borderRadius: "6px",
                                                            backgroundColor: "#ffffff",
                                                            overflow: "hidden",
                                                        }}
                                                    >

                                                        <div
                                                            style={{
                                                                padding: "6px 10px",
                                                                borderBottom: "1px solid #E0E6E0",
                                                                backgroundColor: "#EEF2EE",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "8px",
                                                                    overflow: "hidden",
                                                                }}
                                                            >
                                                                <StorageImage
                                                                    style={{
                                                                        width: "28px",
                                                                        height: "28px",
                                                                        objectFit: "contain",
                                                                        flexShrink: 0,
                                                                    }}
                                                                    alt={foo.selectedPlant.name}
                                                                    imgKey={
                                                                        foo.selectedPlant.designerIconKey
                                                                            ? foo.selectedPlant.designerIconKey
                                                                            : "planner_icons/planner_" +
                                                                              foo.selectedPlant.name
                                                                                  .toLowerCase()
                                                                                  .replace(/[(),]/g, "").replace(/\s+/g, "_") +
                                                                              "_icon.png"
                                                                    }
                                                                    accessLevel="guest"
                                                                    onStorageGetError={(error) =>
                                                                        console.error(error)
                                                                    }
                                                                />

                                                                <div
                                                                    style={{
                                                                        fontSize: "13px",
                                                                        fontWeight: 600,
                                                                        color: "#2f3a34",
                                                                        whiteSpace: "nowrap",
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                    }}
                                                                >
                                                                    Add: {foo.selectedPlant.name}
                                                                </div>
                                                            </div>

                                                            {/* Escape */}
                                                            <i
                                                                className="fas fa-times"
                                                                title="Return to Select"
                                                                style={{
                                                                    cursor: "pointer",
                                                                    color: "#8a3d3d",
                                                                }}
                                                                onClick={() => {
                                                                    // Clear selected plant
                                                                    foo.selectedPlant = undefined;
                                                                    foo.currPlant = undefined;
                                                                    setTool("select");
                                                                    foo.tool = "select";
                                                                    setShowSelectedPlant(false);
                                                                    enterSelectionMode()
                                                                }}
                                                            />
                                                        </div>

                                                        {/* ---------- BODY ---------- */}

                                                        <div style={{padding: "10px", fontSize: "13px"}}>

                                                            <div
                                                                style={{
                                                                    fontSize: "12px",
                                                                    color: "#6f7a72",
                                                                    marginBottom: "8px",
                                                                }}
                                                            >
                                                                Click in the design to place plants.
                                                            </div>

                                                            {/* Variety */}
                                                            <PropertyRow label="Variety">
                                                                <Editable
                                                                    name="variety"
                                                                    value={foo.selectedPlant.variety}
                                                                    dataType="text"
                                                                    showButtons={false}
                                                                    mode="inline"
                                                                    handleSubmit={newPlantProperties}
                                                                />
                                                            </PropertyRow>

                                                            {String(foo.selectedPlant.season || "").toLowerCase() === "annual" && (
                                                                <PropertyRow label="Season Rotation">
                                                                    <Editable
                                                                        name="seasonRotation"
                                                                        value={foo.selectedPlant.seasonRotation || ""}
                                                                        dataType="select"
                                                                        showButtons={false}
                                                                        options={seasonRotationOptions}
                                                                        mode="inline"
                                                                        handleSubmit={(target) => {
                                                                            // persist it like your other new-plant fields
                                                                            newPlantProperties(target);

                                                                            // keep your existing behavior
                                                                            changeSeasonRotation(target.newValue);
                                                                        }}
                                                                    />
                                                                </PropertyRow>
                                                            )}

                                                            {/* Number */}
                                                            <PropertyRow label="Number of Plants">
                                                                <Editable
                                                                    name="numPlants"
                                                                    value={foo.selectedPlant.numPlants}
                                                                    dataType="text"
                                                                    showButtons={false}
                                                                    mode="inline"
                                                                    handleSubmit={newPlantProperties}
                                                                />
                                                            </PropertyRow>

                                                            {/* Patch Layout */}
                                                            {foo.selectedPlant.numPlants > 1 && (
                                                                <>
                                                                    <PropertyRow label="Horizontal">
                                                                        <Editable
                                                                            name="patchWidth"
                                                                            value={foo.selectedPlant.numPlantsWidth}
                                                                            dataType="text"
                                                                            showButtons={false}
                                                                            mode="inline"
                                                                            handleSubmit={newPlantProperties}
                                                                        />
                                                                    </PropertyRow>

                                                                    <PropertyRow label="Vertical">
                                                                        <Editable
                                                                            name="patchHeight"
                                                                            value={foo.selectedPlant.numPlantsHeight}
                                                                            dataType="text"
                                                                            showButtons={false}
                                                                            mode="inline"
                                                                            handleSubmit={newPlantProperties}
                                                                        />
                                                                    </PropertyRow>
                                                                </>
                                                            )}

                                                            {/* Spacing */}
                                                            <PropertyRow
                                                                label={`Spacing (${profile.unitmeasurement === "metric" ? "cm" : "Inches"})`}
                                                            >
                                                                <Editable
                                                                    name="plantSpacing"
                                                                    value={isMetric ? (foo.selectedPlant.spacing_between_plants * 2.54).toFixed(1) : foo.selectedPlant.spacing_between_plants}
                                                                    dataType="text"
                                                                    showButtons={false}
                                                                    mode="inline"
                                                                    handleSubmit={newPlantProperties}
                                                                />
                                                            </PropertyRow>

                                                            {/* Days to Harvest */}
                                                            <PropertyRow label="Days to Harvest">
                                                                <Editable
                                                                    name="daysToHarvest"
                                                                    value={foo.selectedPlant.daysToHarvest}
                                                                    dataType="text"
                                                                    showButtons={false}
                                                                    mode="inline"
                                                                    handleSubmit={newPlantProperties}
                                                                />
                                                            </PropertyRow>

                                                            {/* Checkboxes */}
                                                            <PropertyCheckbox
                                                                label="Create Dates"
                                                                checked={generateDatesOption}
                                                                onChange={(val) => setGenerateDatesOption(val)}
                                                            />

                                                            <PropertyCheckbox
                                                                label="Use Last Possible Date"
                                                                checked={lastDatePossible}
                                                                onChange={(val) => changeLastDatePossible(val)}
                                                            />

                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {tool === "plant" && showSelectedPlant && foo.selectedPlant && foo.selectedPlant.numPlants > 1 &&
                                            <div>
                                                <rt.Row style={{paddingTop: "20px"}}>
                                                    <rt.Col md={6}># Of Plants (Horizontal)</rt.Col>
                                                    <rt.Col md={6}>
                                                        <Editable
                                                            name="patchWidth"
                                                            value={foo.selectedPlant.numPlantsWidth}
                                                            showButtons={false}
                                                            display={(value) => {
                                                                return (<span style={{color: "black"}}>{value}</span>);
                                                            }}
                                                            dataType="text"
                                                            mode="inline"
                                                            handleSubmit={newPlantProperties}
                                                        />
                                                    </rt.Col>
                                                </rt.Row>
                                                <rt.Row style={{paddingTop: "20px"}}>
                                                    <rt.Col md={6}># Of Plants (Vertical)</rt.Col>
                                                    <rt.Col md={6}>
                                                        <Editable
                                                            name="patchHeight"
                                                            value={foo.selectedPlant.numPlantsHeight}
                                                            showButtons={false}
                                                            display={(value) => {
                                                                return (<span style={{color: "black"}}>{value}</span>);
                                                            }}
                                                            dataType="text"
                                                            mode="inline"
                                                            handleSubmit={newPlantProperties}
                                                        />
                                                    </rt.Col>
                                                </rt.Row>
                                            </div>
                                        }

                                        </rt.CardBody>

                                    </rt.Card>
                                    </rt.Col>
                                    </rt.Row>

                                    </rt.Container>




            <rt.Modal isOpen={newAreaModal} toggle={() => {

            }}
            >
                <rt.ModalHeader tag="h4">
                    New Area
                </rt.ModalHeader>
                <rt.ModalBody>
                    <rt.Form>
                        <rt.Row>
                            <rt.Col md={6}><b>Name</b></rt.Col>
                            <rt.Col md={6}>
                                <rt.Input type="text" value={name} onChange={event => {
                                    setName(event.target.value);
                                }}
                                />
                            </rt.Col>
                        </rt.Row>
                        <rt.Row style={{paddingTop: "10px"}}>
                            <rt.Col md="4"/>
                            <rt.Col md="2">
                                <rt.Button
                                    onClick={e => {
                                        createNewArea()
                                    }}
                                    color="success"
                                    className="btn-sm"
                                >
                                    Create
                                </rt.Button>
                            </rt.Col>
                            <rt.Col md="2">
                                <rt.Button
                                    onClick={e => {
                                        cancelNewArea()
                                    }}
                                    color="primary"
                                    className="btn-sm"
                                >
                                    Cancel
                                </rt.Button>
                            </rt.Col>
                        </rt.Row>

                    </rt.Form>
                </rt.ModalBody>
            </rt.Modal>

            <rt.Modal isOpen={deleteAreaModal} toggle={() => {

            }}
            >
                <rt.ModalHeader tag="h4">
                    Delete Area
                </rt.ModalHeader>
                <rt.ModalBody>
                    <rt.Form>
                        <rt.Row>
                            <rt.Col md={6}><b>Name</b></rt.Col>
                            <rt.Col md={6}>
                                {foo?.currArea?.name || ""}
                            </rt.Col>
                        </rt.Row>
                        <rt.Row style={{marginBottom: "10px"}}>
                            <rt.Col md={7}>
                                <b>Delete All Plants in Area?</b>
                            </rt.Col>
                            <rt.Col md={5}>
                                <rt.Input
                                    type="checkbox"
                                    checked={deleteAllPlants}
                                    onChange={event => {
                                        setDeleteAllPlants(event.target.checked);
                                    }}
                                />
                            </rt.Col>
                        </rt.Row>
                        <rt.Row style={{paddingTop: "10px"}}>
                            <rt.Col md="4"/>
                            <rt.Col md="2">
                                <rt.Button
                                    onClick={e => {
                                        finalDeleteArea()
                                    }}
                                    color="success"
                                    className="btn-sm"
                                >
                                    Delete Area
                                </rt.Button>
                            </rt.Col>
                            <rt.Col md="2">
                                <rt.Button
                                    onClick={e => {
                                        cancelDeleteArea()
                                    }}
                                    color="primary"
                                    className="btn-sm"
                                >
                                    Cancel
                                </rt.Button>
                            </rt.Col>
                        </rt.Row>

                    </rt.Form>
                </rt.ModalBody>
            </rt.Modal>

            <rt.Modal isOpen={deleteModal} toggle={() => {

            }}
            >
                <rt.ModalHeader tag="h3">
                    Are you sure?
                </rt.ModalHeader>
                <rt.ModalBody>
                    <rt.Row>
                        <rt.Col md={5}>
                            <rt.Button
                                onClick={e => {
                                    deleteAllElements()
                                }}
                                color="success"
                                variant="outlined"
                            >
                                Confirm
                            </rt.Button>
                        </rt.Col>
                        <rt.Col md={7}>
                            <rt.Button
                                onClick={e => {
                                    setDeleteModal(false)
                                }}
                                color="error"
                                variant="outlined"
                            >
                                Cancel
                            </rt.Button>
                        </rt.Col>
                    </rt.Row>
                </rt.ModalBody>
            </rt.Modal>


        </React.Fragment>

    );
};

const mapStateToProps = (state, ownProps) => {
    const sortedPlants = state.designer.plants.sort((a, b) => (a.name > b.name) ? 1 : -1);
    const sortedStructures = state.designer.structures.sort((a, b) => (a.name > b.name) ? 1 : -1);
    return ({
        designs: state.designer.designs,
        profile: state.Profile.user,
        userareas: state.goals.areas,
        plantData: state.designer.plants,
        structureData: state.designer.structures,
        climateData: state.designer.temps,
        plantDataMap: sortedPlants.reduce((map, obj) => (map[obj.name] = obj, map), {}),
        structureDataMap: sortedStructures.reduce((map, obj) => (map[obj.name] = obj, map), {}),
        customplants: state.goals.customplants,
    })
}

const mapDispatchToProps = dispatch => ({
    onGetProfile: (username) => dispatch(getProfile(username)),
    onUpdateProfile: (profile) => dispatch(editProfile(profile)),
    onGetPlantData: () => dispatch(getPlantData()),
    onFetchClimateData: (zipcode) => dispatch(getClimateData(zipcode)),
    onGetStructureData: () => dispatch(getStructureData()),
    onSaveDesign: (design) => dispatch(updateDesign(design)),
    onAddArea: area => dispatch(addArea(area)),
    onUpdateArea: area => dispatch(updateArea(area)),
    onAddDesign: (design) => dispatch(addDesign(design)),
    onDeleteArea: id => dispatch(deleteArea(id)),
    onLoadDesigns: () => dispatch(getDesigns()),
    onGetAreas: () => dispatch(getAreas()),
    onGetCustomPlants: () => dispatch(fetchCustomPlants()),
})

Designer.propTypes = {
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Designer)
